import localeAntd from "ant-design-vue/lib/locale-provider/en_US";

const messages = {
  all: {
    selectionnerEleves: "Chagua wanafunzi",
    printByLevel: "Chapisha kwa viwango",
    printLoginCredentials: "Chapisha hati za kuingia",
    understood: "Nimeelewa",
    automatique: "Otomatiki",
    manuel: "Mkononi",
    okay: "Sawa",
    table: "Jedwali",
    add: "Ongeza",
    or: "au",
    edit: "Hariri",
    cancel: "Ghairi",
    save: "Hifadhi",
    cloneByType: "Nakili kwa aina",
    apply: "Tekeleza",
    source: "Chanzo",
    targets: "Lengo",
    sureToCancelAlert: "Una uhakika unataka kughairi?",
    sureToDelete: "Una uhakika unataka kufuta?",
    startDate: "Tarehe ya kuanza",
    endDate: "Tarehe ya mwisho",
    requiredStartDate: "Tarehe ya kuanza inahitajika",
    requiredEndDate: "Tarehe ya mwisho inahitajika",
    requiredName: "Jina linahitajika",
    requiredLevel: "Kiwango kinahitajika",
    enterInformationBelow: "Ingiza maelezo katika sehemu zilizo hapa chini",
    oui: "Ndiyo",
    non: "Hapana",
    none: "Hakuna",
    and: "Na",
    filterBy: "Chuja kwa",
    filterByAddedDate: "Chuja kwa tarehe ya kuongeza",
    filtresEtRecherche: "Vichujio na Utafutaji",
    sureTo: "Una uhakika?",
    unsavedchanges: "Mabadiliko hayajahifadhiwa!",
    unsavedchangesContent:
      "Je, unataka kwenda kweli? Una mabadiliko ambayo hayajahifadhiwa!",
    unsavedChangesInfo:
      "Una mabadiliko ambayo hayajahifadhiwa. Tafadhali hifadhi ili mabadiliko yako yatekelezwe.",
    unsavedChangesLeaveConfirm:
      "Una mabadiliko ambayo hayajahifadhiwa. Ikiwa utaondoka, utapoteza mabadiliko haya. Una uhakika unataka kuondoka?",
    savedChanges: "Mabadiliko yamehifadhiwa kwa mafanikio",
    typeNeeded: "Aina za faili zinazoruhusiwa: png, jpg, jpeg.",
    packAcces:
      "Huwezi kufikia kipengele hiki kwa mpango wako wa sasa wa kujiunga.",
    attention: "Makini",
    nonGroupAssigned: "Haijagawiwa katika vikundi",
    pagination: {
      showTotal: "Onyesha {start}-{end} kati ya {total} vipengele",
      pageSize: "Vipengele kwa ukurasa",
      jumpTo: "Nenda kwa",
      page: "Ukurasa",
      total: "Jumla",
      items: "vipengele",
    },
    date: "Tarehe",
    switchMode: "Hindura insanganyamatsiko y'urumuri / iyijimye",
    loadingText: "Inapakia...",
    selectDate: "Chagua tarehe",
    noData: "Hakuna data",
    tpiAll: "Yote",
    pending: "Inasubiri",
    dateRangeToday: "Leo",
    dateRangeThisWeek: "Wiki hii",
    dateRangeThisMonth: "Mwezi huu",
    dateRangeLastThreeMonths: "Miezi mitatu iliyopita",
    enabled: "Imewezeshwa",
    disabled: "Imezimwa",
  },
  time: {
    minuteAgo: "Dakika 1 iliyopita",
    minutesAgo: "Dakika {count} zilizopita",
    hourAgo: "Saa 1 iliyopita",
    hoursAgo: "Saa {count} zilizopita",
    dayAgo: "Siku 1 iliyopita",
    daysAgo: "Siku {count} zilizopita",
    monthAgo: "Mwezi 1 uliyopita",
    monthsAgo: "Miezi {count} iliyopita",
    yearAgo: "Mwaka 1 uliyopita",
    yearsAgo: "Miaka {count} iliyopita",
  },
  pdf: {
    pageNumber: "Ukurasa {current} / {total}",
  },
  months: {
    january: "Januari",
    february: "Februari",
    march: "Machi",
    april: "Aprili",
    may: "Mei",
    june: "Juni",
    july: "Julai",
    august: "Agosti",
    september: "Septemba",
    october: "Oktoba",
    november: "Novemba",
    december: "Desemba",
  },
  pdfLogin: {
    loginInfo: "Taarifa za kuingia",
    father: "Baba",
    mother: "Mama",
    guardian: "Mlezi",
    teacher: "Mwalimu",
    student: "Mwanafunzi",
    students: "Wanafunzi",
    option1: "Chaguo 1: Kuingia kwa kutumia vitambulisho",
    option2: "Chaguo 2: Kuingia kwa kutumia QR Code",
    username: "Jina la mtumiaji",
    password: "Nenosiri",
    qrCodeInstruction:
      "Unaweza kuingia kwa kutumia QR Code hii katika programu ya simu :",
    scanQRCode: "Skani QR Code hii kwa kutumia programu ya simu:",
    howToAccess: "Jinsi ya kufikia jukwaa",
    webPlatform: "Jukwaa la wavuti:",
    mobileApp: "Programu ya simu:",
    installApp: "Sakinisha programu ya {appName} kwenye simu yako",
    importantInfo: "Taarifa muhimu",
    changePassword:
      "• Badilisha nenosiri lako wakati wa kuingia kwa mara ya kwanza.",
    keepDocumentSafe: "• Hifadhi hati hii mahali salama.",
    contactAdmin: "• Wasiliana na utawala ikiwa kuna matatizo.",
    parentLogins: "Miingio ya Wazazi",
    teacherLogins: "Miingio ya Walimu",
    studentLogins: "Miingio ya Wanafunzi",
    adminLogins: "Miingio ya Wasimamizi",
  },
  pack: {
    new: "Mpya",
    upgrade: "Boresha",
    packMessage: "Boresha kwa vipengele zaidi",
    typeNeededPNG: "Aina za faili zinazoruhusiwa: png.",
    infoConx: "Maelezo ya kuingia",
    lienConx: "Kiungo cha kuingia",
    lienConxText: "au programu ya simu ya EdTeacher",
    upgradeModal: {
      title: "Kipengele Hakipatikani",
      subtitle: "Mpango wako wa sasa wa kujiunga hauuni kipengele hiki",
      description:
        "Ili kufikia kipengele hiki, unahitaji kuboresha mpango wako. Tafadhali wasiliana na timu yetu ya mauzo kwa maelezo zaidi na habari za bei.",
      contactInfo: "Maelezo ya Mawasiliano",
      phone: "Simu",
      email: "Barua pepe",
      website: "Tovuti",
      contactSales: "Wasiliana na Timu ya Mauzo",
      close: "Funga",
    },
  },
  moduleType: {
    pedagogicalModule: "Moduli ya kiufundishaji",
    pilotModule: "Moduli ya kijamii",
    specificModule: "Moduli ya mwongozi",
  },
  teacherAvailability: {
    available: "Nipo tayari",
    notAvailable: "Sipo tayari",
    saved: "Upatikanaji umehifadhiwa kwa mafanikio",
    notFilledYet: "Mwalimu hajajaza bado karatasi ya upatikanaji",
  },
  smartSchedule: {
    generalParams: "Jumla",
    comment: "Maoni",
    commentRequired: "Maoni yanahitajika",
    startDay: "Siku ya kuanza",
    endDay: "Siku ya mwisho",
    workingTime: "Muda wa kazi",
    breakingTime: "Muda wa mapumziko",
    startAt: "Anza saa",
    endAt: "Maliza saa",
    scheduleParmsAdded: "Ratiba imeongezwa kwa mafanikio",
    generalParamsSaved: "Vipimo vya jumla vimehifadhiwa kwa mafanikio",
    selectSchedule: "Chagua usanidi",
    subjectsSchedParam: "Masomo",
    weeklyRate: "Kiwango cha kila wiki",
    module: "Moduli",
    subject: "Somo",
    moduleSpecific: "Moduli ya mwongozi",
    teacherClassParam: "Ugao wa walimu",
    teacherAffectedSuccess: "Mwalimu amegaiwa kwa mafanikio",
    teachersWeeklyRate: "Viwango vya walimu kila wiki",
    name: "Jina la usanidi",
    smartSchedule: "Ratiba mahiri",
    smartSchedules: "Ratiba mahiri",
    ready: "Tayari",
    pending: "Inasubiri",
    finished: "Imekamilika",
    error: "Kosa",
    addParam: "Ongeza usanidi",
    migrateSuccess: "Ratiba zimehamishwa kwa mafanikio",
    migrate: "Hamisha ratiba",
    unmigrated: "Ratiba zimerejeeshwa kwa mafanikio",
    noDataToUnmigrate: "Ratiba tayari zina vikao vya mkononi!",
    unmigrate: "Rejesha vikao vya mkononi",
    minDuration: "Muda wa chini zaidi",
    maxDuration: "Muda wa juu zaidi",
    fillAllClassroomsToGenerate:
      "Tafadhali jaza madarasa yote ili kuzalisha ratiba",
    weeklyRateMaxError:
      "Kiwango cha kila wiki kinapaswa kuwa sawa au zaidi ya muda wa juu zaidi",
    weeklyRateMinError:
      "Kiwango cha kila wiki kinapaswa kuwa sawa au zaidi ya muda wa chini zaidi",
  },
  calender: {
    calendar: "Kalenda",
    noDescription: "Hakuna maelezo",
    month: "Mwezi",
    week: "Wiki",
    day: "Siku",
    addEvent: "Ongeza tukio",
    addEventTitle: "Ongeza tukio jipya",
    duration: "Muda",
    durationRequired: "Muda unahitajika",
    exam: "Mtihani",
    party: "Sherehe",
    excursion: "Ziara",
    meeting: "Mkutano",
    other: "Nyingine",
    eventType: "Aina ya tukio",
    color: "Rangi",
    typeRequired: "Aina ya tukio inahitajika",
    editEventTitle: "Hariri tukio",
    editEvent: "Hariri tukio",
    editedEvent: "Tukio limeharirishwa kwa mafanikio",
    deletedEvent: "Tukio limefutwa kwa mafanikio",
    addedEvent: "Tukio limeongezwa kwa mafanikio",
    meetingBetweenTeachersAdvisors:
      "Mkutano kati ya walimu na washauri wa elimu",
    createdBy: "Limeundwa na mshauri",
  },
  chat: {
    ROOMS_EMPTY: "Hakuna mazungumzo",
    ROOM_EMPTY: "Hakuna mazungumzo yaliyochaguliwa",
    NEW_MESSAGES: "Ujumbe mpya",
    MESSAGE_DELETED: "Ujumbe huu umefutwa",
    MESSAGES_EMPTY: "Hakuna ujumbe",
    CONVERSATION_STARTED: "Mazungumzo yalianza:",
    TYPE_MESSAGE: "Andika ujumbe wako",
    SEARCH: "Tafuta",
    IS_ONLINE: "yupo mtandaoni",
    searchParents: "Tafuta mzazi",
    parentDetails: "Maelezo ya mzazi",
    startNewConversationWithParent: "Unda mazungumzo mapya na mzazi",
    addParent: "Ongeza mzazi",
    deleted: "Imefutwa",
    LAST_SEEN: "alionekana mwisho",
    noLogin: "Hakuna akaunti ya kuingia",
    inactiveParent: "Mzazi asiye hai",
    alreadyAdded: "Tayari ameongezwa kwenye mazungumzo",
    availableToAdd: "Anapatikana kuongezwa",
    noParentsFound: "Hakuna wazazi waliopatikana",
    legacyMessage: "Ujumbe wa zamani (kabla ya kutengwa kwa aina ya mzazi)",
    legacyMessageInfo:
      "Ujumbe hapa juu ulitumwa wakati wazazi walikuwa na akaunti ya pamoja.",
    deleteMessage: "Futa ujumbe",
    filter: "Chuja",
    individualChats: "Mazungumzo ya mtu binafsi",
    groupChats: "Mazungumzo ya kikundi",
    groupDetails: "Maelezo ya kikundi",
    name: "Jina",
    members: "Wanachama",
    teacher: "Mwalimu",
    parent: "Mzazi",
    manager: "Msimamizi",
    group: "Kikundi",
    user: "Mtumiaji",
  },
  paymentStatus: {
    paymentStatus: "Hali ya malipo",
    paidAmount: "Kiasi kilicholipwa",
    monthRemainingPayments: "Malipo yaliyobaki ({month})",
    allRemainingPayments: "Malipo yote yaliyobaki",
    noRemainingPyaments: "Hakuna malipo yaliyobaki",
    nothingPaid: "Hakuna malipo yaliyolipwa",
    statutPaiement: "Hali ya malipo",
    nomEleve: "Jina la mwanafunzi",
    categorie: "Jamii",
    frais: "Ada",
    montant: "Kiasi",
    etat: "Hali",
    totalNonPaye: "Jumla isiyolipwa",
    totalPaye: "Jumla iliyolipwa",
    totalAPayer: "Jumla ya kulipa",
    resteAPayer: "Kiasi kilichobaki",
    legende: "Ufafanuzi",
    date: "Tarehe",
    inscription: "Usajili",
    pastYearsArrearsTitle: "Madeni ya miaka ya shule iliyopita",
    pastYearsArrearsSummary:
      "Ada {fees} hazijalipwa (masomo na shughuli) katika: {years}. Zikusanywe kabla ya usajili mpya.",
    pastYearsArrearsDetails: "Ona maelezo",
    pastYearsArrearsHide: "Ficha maelezo",
    pastYearsArrearsCollect: "Kusanya kwa {year}",
    scolarite: "Masomo",
    activite: "Shughuli",
  },
  language: {
    ar: "Kiarabu",
    fr: "Kifaransa",
    en: "Kiingereza",
    sw: "Kiswahili",
  },
  appreciation: {
    adminAppreciation: "Kuthamini kwa msimamizi",
    withOptions: "Kuthamini kwa kutajwa",
    manual: "Kuthamini kwa mkononi",
    appreciation: "Kuthamini",
    add: "Ongeza kuthamini",
    changedToManual: "Njia ya kuthamini imebadilishwa kuwa ya mkononi",
    changedToOptions: "Njia ya kuthamini imebadilishwa kuwa ya kutajwa",
    giveAppreciation: "Toa kuthamini",
    bulkAppreciation: "Kuthamini kwa wingi",
    selectAppreciation: "Chagua kuthamini",
    customAppreciation: "Ongeza kuthamini maalum",
    selectPredefinedAppreciation: "Chagua kuthamini kilichotayarishwa",
    insertPredefinedAppreciation: "Weka kuthamini kilichotayarishwa",
    teacherManualDesc:
      "Mwalimu ana ufikiaji wa kuandika chochote katika kuthamini",
    saved: "Kuthamini kumehifadhiwa kwa mafanikio",
    deleted: "Kuthamini kumefutwa kwa mafanikio",
    teacherAppreciation: "Kuthamini kwa walimu",
    studentsWithoutAppreciation: "Wanafunzi bila kuthamini",
    allStudentsHaveAppreciations: "Wanafunzi wote wana kuthamini",
    missingAppreciation: "kuthamini kunakosekana",
    appreciationGiven: "Kuthamini kumetolewa",
    automatic: "Kuthamini otomatiki",
    automaticDescription: "Mfumo otomatiki unaozingatia wastani",
    automaticDescriptionCollege:
      "Kuthamini otomatiki kulingana na wastani wa somo (chuo / lycee).",
    applyNotImplemented:
      "Kutumia bado haipatikani; itawezeshwa katika sasisho linalofuata.",
    applyAutomatic: "Tumia kuthamini otomatiki",
    duplicateAppreciations: "Nakili kuthamini",
    existingAppreciations: "Kuthamini zilizopo",
    noExistingAppreciations: "Hakuna kuthamini zilizopo zilizopatikana",
    selectToReplace:
      "Chagua kuthamini unazotaka kuzibadilisha na zile otomatiki:",
    noTeacherAssigned: "Hakuna mwalimu aliyepewa",
    transferAppreciation: "Hamisha kuthamini",
    transferSource: "Ripoti chanzo",
    transferTarget: "Ripoti lengwa",
    selectTargetType: "Chagua aina ya ripoti lengwa",
    targetModulesSelected: "Moduli {count} lengwa zimechaguliwa",
    transferSelectSource: "Tafadhali chagua moduli chanzo",
    transferSelectTargetModules: "Tafadhali chagua angalau moduli moja lengwa",
    transferNoModules: "Hakuna moduli zinazopatikana",
    transferPickTypeFirst: "Chagua aina ya ripoti lengwa ili kuona moduli",
    transferOverwritePolicy: "Nini cha kufanya ikiwa kuthamini tayari lipo",
    transferSkipExisting: "Ruka kuthamini zilizopo",
    transferReplaceExisting: "Badilisha kuthamini zilizopo",
    transferConfirmTitle: "Thibitisha uhamishaji",
    transferConfirmContent:
      "Nakili kuthamini kutoka \"{source}\" ({sourceType}) kwenda moduli {count} ({targets}) za aina {targetType}? Sera: {policy}",
    transferResult:
      "Uhamishaji umekamilika: {copied} zimenakiliwa, {skipped} zimerukwa",
    applySuccess: "Kuthamini otomatiki zimetumika kwa wanafunzi {count}",
    applyNone: "Hakuna kuthamini otomatiki zilizotumika.",
    cloneCollegeSourceHint:
      "Chagua somo na mwaka wa shule ambao unataka kunakili kanuni za kuthamini otomatiki.",
    cloneCollegeTargetHint:
      "Chagua kwanza mwaka (au miaka) wa shule lengwa. Unaweza kuchagua viwango na mihula mingi; orodha ya masomo inaunganisha usanidi wa ripoti kwa mchanganyiko huo. «Chagua zote» huchagua kila kiwango, kila muhula, na kila somo isipokuwa chanzo.",
    cloneSelectAllNoLevels: "Hakuna viwango vinavyopatikana kwa shule hii.",
    cloneSelectAllNoSubjects:
      "Hakuna masomo lengwa yaliyopatikana, au somo la chanzo pekee lipo katika usanidi — ongeza masomo mengine au rekebisha vichujio.",
    cloneCollegeSourceIncomplete:
      "Tafadhali chagua somo la chanzo na mwaka wa shule wa chanzo.",
    selectTargetSubjects: "Tafadhali chagua angalau somo moja lengwa.",
    selectTargetTrimesters: "Tafadhali chagua angalau muhula mmoja lengwa.",
    selectTargetLevels: "Tafadhali chagua angalau kiwango kimoja lengwa.",
    selectSourceModule: "Tafadhali chagua moduli chanzo na mwaka wa shule",
    selectTargetSchoolYear: "Tafadhali chagua mwaka wa shule lengwa",
    selectTargetModules: "Tafadhali chagua moduli lengwa au vichujio",
    noTargetModulesFound: "Hakuna moduli lengwa zilizopatikana",
    noAutoAppreciationToClone: "Hakuna tathmini otomatiki ya kunakili",
  },
  connected: {
    online: "Mtandaoni",
    offline: "Nje ya mtandao",
    all: "Yote",
    button_name: "Watumiaji",
    school_user: "Watumiaji wa utawala",
    noname: "Bila jina",
  },
  feedback: {
    title: "Maoni",
    sendFeedback: "Tuma maoni",
    category: "Jamii",
    comment: "Maoni",
    problem: "Tatizo/hitilafu",
    idea: "Wazo la kuboresha",
    others: "Nyingine",
    section: "Sehemu",
    selectSection: "Tafadhali chagua sehemu",
    priority: "Kipaumbele",
    selectPriority: "Tafadhali chagua kipaumbele",
    low: "Chini",
    medium: "Wastani",
    high: "Juu",
    critical: "Muhimu sana",
    message: "Ujumbe",
    uploadFiles: "Pakia faili",
    uploadAudio: "Pakia sauti",
    record: "Rekodi",
    successSent:
      "Asante kwa mchango wako. Tutaangalia na kuwasiliana nawe inapohitajika. Siku njema!",
  },
  certification: {
    add: "Ongeza cheti",
    moyPer: "Wastani wa kibinafsi",
    moySpec: "Wastani maalum",
    default: "Tumia vyeti chaguo-msingi",
    confirmDefault:
      "Tendo hili litafuta vyeti vyako. Una uhakika unaweka kama chaguo-msingi?",
    name: "Jina la cheti",
    min: "Wastani wa chini",
    max: "Wastani wa juu",
    minError: "Wastani wa chini hauwezi kuwa mkubwa kuliko wastani wa juu",
    maxError: "Wastani wa juu hauwezi kuwa mdogo kuliko wastani wa chini",
    Corresponding: "Uamuzi unaolingana",
    pass: "Amepita",
    cnd_pass: "Amepita kwa msamaha",
    age_pass: "Amepita kwa msamaha wa umri",
    fail: "Ameshindwa",
    defaultDone: "Vyeti vimesasishwa kwa mafanikio",
    addCertificateDesigns: "Ongeza miundo yako ya vyeti",
    namePlaceholder: "mfano: Cheti cha Remesha",
    fileUploadedSuccessfully: "Faili imepakiwa kwa mafanikio",
    moyenne: "Wastani",
    certificateDate: "Tarehe ya cheti",
    printDate: "Tarehe ya kuchapisha",
    printDateEnabled: "Washa tarehe ya kuchapisha",
    dateFormat: "Muundo wa tarehe",
    dateLabel: "Maandishi kabla ya tarehe",
    stamp: "Muhuri",
    stampEnabled: "Washa muhuri",
    stampPosition: "Nafasi ya muhuri",
    stampScale: "Kiwango cha muhuri",
    stampWarning: "Hakuna muhuri uliowekwa kwa shule hii",
    stampHelp: "Muhuri utaongezwa kiotomatiki kutoka kwa mipangilio ya taasisi",
    generalSettings: "Mipangilio ya jumla",
    studentName: "Jina la mwanafunzi",
    className: "Jina la darasa",
    trimesterName: "Jina la muhula",
    schoolYearHeader: "Mwaka wa shule",
    printDateHeader: "Tarehe ya kuchapisha",
    stampHeader: "Muhuri",
    orientation: "Mwelekeo",
    positionX: "Nafasi X",
    font: "Fonti",
    size: "Ukubwa",
    color: "Rangi",
    enable: "Washa",
    format: "Muundo",
    textBefore: "Maandishi kabla",
    scale: "Kiwango",
    vertical: "Wima",
    horizontal: "Kutega",
    centered: "Katikati",
    atStart: "Mwanzo",
    dateFormatDDMMYYYY: "DD/MM/YYYY",
    dateFormatYYYYMMDD: "YYYY-MM-DD",
    placeholderOrientation: "mwelekeo",
    placeholderPositionX: "Nafasi X",
    placeholderSelectFont: "Chagua fonti",
    placeholderX: "x",
    placeholderY: "y",
    placeholderTextSize: "Ukubwa wa maandishi",
    placeholderDateLabel: "mf: Tarehe ya kuchapisha:",
    placeholderScale: "1.0",
    scaleHelp: "Kati ya 0.1 na 3 (1 = ukubwa wa kawaida)",
  },
  decisionConseil: {
    decision: "Uamuzi",
    decisionM: "Uamuzi (mvulana)",
    decisionF: "Uamuzi (msichana)",
    decisionConseil: "Maamuz ya baraza",
    default: "Tumia maamuzi ya chaguo-msingi",
    defaultDone: "Maamuzi ya baraza yamebadilishwa kwa mafanikio",
    confirmDefault:
      "Tendo hili litafuta maamuzi yako ya baraza. Una uhakika unaweka kama chaguo-msingi?",
    editorTitle: "Maamuzi ya baraza kwa kila mwanafunzi",
    openEditor: "Maamuzi ya baraza",
    auto: "Otomatiki (kwa wastani)",
    other: "Nyingine",
    manualPlaceholder: "Andika uamuzi",
    apply: "Tumia",
    applyToSelected: "Tumia kwa waliochaguliwa",
    selectDecision: "Chagua uamuzi",
    selectStudents: "Chagua angalau mwanafunzi mmoja kabla ya kutumia.",
    noClassroom: "Chagua darasa kwanza.",
    unsavedHint:
      "Una mabadiliko ambayo hayajahifadhiwa. Bofya Hifadhi kuthibitisha.",
    bulkConfirmTitle: "Tumia kwa waliochaguliwa",
    bulkConfirmContent:
      "Uamuzi huu utawekwa kwa wanafunzi waliochaguliwa wenye wastani wa jumla tu. Wale bila wastani watarukwa.",
    bulkConfirmCounts:
      "Wanafunzi {eligible} kati ya {selected} waliochaguliwa watasasishwa.",
    noEligibleStudents:
      "Hakuna mwanafunzi aliyechaguliwa ana wastani wa jumla. Uamuzi hauwezi kutumika.",
    noMoyenneForStudent:
      "Mwanafunzi huyu hana wastani wa jumla. Uamuzi wa baraza hauwezi kuwekwa.",
    filterByStudentName: "Tafuta kwa jina la mwanafunzi",
    decisonOnPlaceholder: "Uamuzi unaolingana",
    decisonOnRequired:
      "Tafadhali chagua uamuzi unaolingana (A/C/R) kwa PV ya baraza la darasa.",
    pvNotDisplayed: "Haijaonyeshwa kwenye PV",
    pvMissingKeyRow:
      "Mwanafunzi huyu hataonekana kwenye PV ya baraza la darasa. Rekebisha mipangilio au weka uamuzi unaolingana.",
    pvMissingKeyBanner: "Wanafunzi {count} bila uamuzi unaolingana (A/C/R)",
    pvMissingKeyHint:
      "Wanafunzi hawa hawaonekani kwenye jedwali la PV. Rekebisha mipangilio ya maamuzi ya baraza au weka uamuzi kwa kila mwanafunzi.",
    pvMissingKeyMore: "... na {count} zaidi",
    years:  "Vipindi vya masomo",
  },
  notifications: {
    desactivation:
      "Akaunti imesimamishwa! Wasiliana na utawala kwa maelezo zaidi!",
    desactivateBuilding:
      "Taasisi yako imesimamishwa! Wasiliana na utawala kwa maelezo zaidi!",
    updateuser: "Akaunti imebadilishwa! Tafadhali ingia tena!",
    updateAccess: "Ufikiaji umebadilishwa! Tafadhali ingia tena!",
  },
  login: {
    incorrectInfo: "Jina la mtumiaji au nenosiri si sahihi",
    bienvenue: "Karibu",
    title: "Mfumo wa usimamizi wa taasisi za elimu",
    connectezVous: "Ingia!",
    connextion: "Kuingia",
    requisMdp: "Tafadhali ingiza nenosiri lako!",
    requisUsername: "Tafadhali ingiza jina lako la mtumiaji!",
    username: "Jina la mtumiaji",
    password: "Nenosiri",
    connecte: "Ameunganishwa",
    loginSuccess: "Umeingia kwa mafanikio",
    readAndAccept: "Nimesoma na nakubali",
    termsAndConditions: "Sheria na Masharti",
    subscribePart1:
      "Ikiwa shule yako bado haijasajiliwa, gundua matoleo yetu ya kipekee kwenye ",
    subscribePart2: "tovuti yetu",
    subscribePart3: " na jiunge na jumuiya yetu ya elimu leo!",
    scanQR: "Karibisha msimbo wako wa QR karibu na kamera ili kuingia.",
    back: "Rudi",
    qrCodeInvalid: "Msimbo wa QR si sahihi",
    oldQRCode:
      "Msimbo huu wa QR unatumia umbizo la zamani. Tafadhali omba msimbo mpya kutoka kwa msimamizi.",
    qrCameraError: "Imeshindwa kufikia kamera",
  },
  mfa: {
    twoFactorAuth: "Uthibitishaji wa Sababu Mbili",
    notEnabled: "Uthibitishaji wa sababu mbili haujaamilishwa",
    notEnabledDescription:
      "Amilisha uthibitishaji wa sababu mbili ili kuongeza safu ya ziada ya usalama kwenye akaunti yako.",
    enable: "Amilisha",
    enabled: "Uthibitishaji wa sababu mbili umeamilishwa",
    enabledDescription:
      "Akaunti yako imelindwa na uthibitishaji wa sababu mbili.",
    enabledSuccess: "Uthibitishaji wa sababu mbili umeamilishwa kwa mafanikio.",
    disabled: "Uthibitishaji wa sababu mbili umezimwa",
    disabledSuccess: "Uthibitishaji wa sababu mbili umezimwa kwa mafanikio.",
    method: "Njia",
    authenticatorApp: "Programu ya Uthibitishaji",
    sms: "SMS",
    phoneNumber: "Nambari ya Simu",
    disable: "Zima",
    disableConfirmation:
      "Una uhakika unataka kuzima uthibitishaji wa sababu mbili? Hii itafanya akaunti yako kuwa na usalama mdogo.",
    passwordRequiredToDisable:
      "Kwa sababu za usalama, tafadhali ingiza nenosiri lako ili kuzima uthibitishaji wa sababu mbili.",
    enterPasswordToDisable: "Ingiza nenosiri lako",
    passwordRequired: "Nenosiri linahitajika",
    invalidPassword: "Nenosiri batili. Tafadhali jaribu tena.",
    confirmDisable: "Zima MFA",
    setup: "Sanidi Uthibitishaji wa Sababu Mbili",
    chooseMethod: "Chagua Njia",
    verify: "Thibitisha",
    complete: "Maliza",
    phoneRequired:
      "Nambari ya simu inahitajika kwa uthibitishaji wa SMS. Tafadhali ongeza nambari ya simu kwenye wasifu wako kwanza.",
    continue: "Endelea",
    scanQRCode: "Skani Msimbo wa QR",
    scanQRCodeDescription:
      "Tumia programu yako ya uthibitishaji kuskani msimbo huu wa QR.",
    manualEntry: "Huwezi kuskani? Ingiza msimbo huu mwenyewe:",
    secret: "Siri",
    next: "Ifuatayo",
    smsReady:
      "Uthibitishaji wa SMS umeandaliwa. Bofya 'Amilisha' ili kuuamilisha.",
    verificationRequired: "Uthibitishaji Unahitajika",
    enterAppCode:
      "Ingiza msimbo wa tarakimu 6 kutoka kwenye programu yako ya uthibitishaji.",
    enterSMSCode:
      "Ingiza msimbo wa tarakimu 6 uliotumwa kwenye simu yako. SMS inaweza kuchukua hadi dakika 10 kufikia.",
    sentTo: "Msimbo umetumwa kwa",
    verificationCode: "Msimbo wa Uthibitishaji",
    codeRequired: "Msimbo wa uthibitishaji unahitajika",
    codeLength: "Msimbo lazima uwe na tarakimu 6",
    codeFormat: "Msimbo lazima uwe na tarakimu 6",
    enterCode: "Ingiza msimbo wa tarakimu 6",
    enterBackupCode: "Ingiza msimbo wa dharura",
    backupCode: "Msimbo wa Dharura",
    authenticatorCode: "Msimbo wa Uthibitishaji",
    backupCodeLength: "Msimbo wa dharura lazima uwe na herufi 8",
    backupCodeFormat:
      "Msimbo wa dharura lazima uwe na herufi 8 za alfanumeriki",
    backupCodeHint:
      "Ingiza moja ya misimbo yako ya dharura. Kila msimbo unaweza kutumiwa mara moja tu.",
    useBackupCode: "Huwezi kufikia uthibitishaji wako? Tumia msimbo wa dharura",
    useAuthenticatorCode: "Tumia msimbo wa uthibitishaji badala yake",
    resendCode: "Tuma Msimbo Tena",
    codeSent: "Msimbo Umetumwa",
    codeSentDescription:
      "Msimbo mpya wa uthibitishaji umetumwa kwenye simu yako.",
    rateLimitExceeded: "Kikomo cha Kutuma Tena Kimefikia",
    rateLimitMessage:
      "Lazima usubiri dakika {minutes} kabla ya kuomba msimbo mpya.",
    rateLimitMessageSingular:
      "Lazima usubiri dakika {minutes} kabla ya kuomba msimbo mpya.",
    backupCodes: "Msimbo wa Backup",
    backupCodesDescription:
      "Hifadhi msimbo huu wa backup mahali salama. Unaweza kuitumia kufikia akaunti yako ikiwa umepoteza ufikiaji wa programu yako ya uthibitishaji.",
    copyCodes: "Nakili Msimbo",
    codesCopied: "Msimbo wa backup umeigwa kwenye ubao wa kunakili",
    smsEnabledDescription:
      "Uthibitishaji wa SMS umeamilishwa. Utapokea msimbo kupitia SMS unapoingia.",
    chooseMethodTitle: "Chagua Njia Yako ya Usalama",
    chooseMethodDescription:
      "Chagua jinsi unavyotaka kuthibitisha utambulisho wako unapoingia. Tunapendekeza kutumia programu ya uthibitishaji kwa usalama bora zaidi.",
    recommended: "Inapendekezwa",
    authenticatorAppDescription:
      "Tumia programu ya uthibitishaji kwenye simu yako kuzalisha msimbo salama. Inafanya kazi hata bila muunganisho wa intaneti.",
    moreSecure: "Salama zaidi kuliko SMS",
    fasterLogin: "Kuingia haraka zaidi - hakuna kusubiri SMS",
    moreReliable: "Kuaminika zaidi - hakuna kuchelewa kwa SMS",
    noNetworkNeeded: "Hakuna mtandao unahitajika kwenye simu yako",
    industryStandard: "Njia ya usalama ya kiwango cha tasnia",
    smsDescription:
      "Pokea msimbo wa uthibitishaji kupitia ujumbe wa maandishi kwenye nambari yako ya simu.",
    setupAuthenticatorApp: "Sanidi Programu ya Uthibitishaji",
    setupAuthenticatorAppDescription:
      "Fuata hatua hizi rahisi kusanidi uthibitishaji wa sababu mbili na programu ya uthibitishaji.",
    step1Download: "Hatua 1: Pakua Programu ya Uthibitishaji",
    downloadInstruction:
      "Ikiwa hujapata programu ya uthibitishaji bado, pakua moja ya programu hizi za bure kwenye simu yako:",
    appStore: "Duka la Programu",
    googlePlay: "Google Play",
    step2Scan: "Hatua 2: Skani Msimbo wa QR",
    scanQRCodeInstruction:
      "Fungua programu yako ya uthibitishaji na skani msimbo huu wa QR na kamera ya simu yako. Programu itaongeza akaunti yako kiotomatiki chini ya jina 'EdManager'.",
    cantScan: "Huwezi kuskani msimbo wa QR?",
    manualEntryDescription:
      "Ikiwa huwezi kuskani msimbo wa QR, unaweza kuingiza msimbo huu wa siri mwenyewe kwenye programu yako ya uthibitishaji:",
    copySecret: "Nakili Siri",
    secretCopied: "Msimbo wa siri umeigwa kwenye ubao wa kunakili",
    iHaveScanned: "Nimeskani Msimbo",
    setupSMS: "Sanidi Uthibitishaji wa SMS",
    setupSMSDescription:
      "Uthibitishaji wa SMS utatuma msimbo wa uthibitishaji kwenye nambari yako ya simu iliyosajiliwa.",
    smsReadyDescription:
      "Uthibitishaji wa SMS umeandaliwa kuamilishwa. Utapokea msimbo wa tarakimu 6 kupitia ujumbe wa maandishi kila unapoingia.",
    enterAppCodeDescription:
      "Fungua programu yako ya uthibitishaji na ingiza msimbo wa tarakimu 6 unaoonyeshwa kwenye skrini yako.",
    enterSMSCodeDescription:
      "Angalia simu yako kwa ujumbe wa SMS na ingiza msimbo wa tarakimu 6 uliopokea.",
    codeHint:
      "Msimbo unasasisha kila sekunde 30. Hakikisha unaingiza msimbo wa sasa.",
    backupCodesWarning: "Muhimu: Hifadhi msimbo huu sasa!",
    securityAlertTitle:
      "⚠️ Mapendekezo ya Usalama: Wezesha Uthibitishaji wa Mambo Mawili",
    securityAlertDescription:
      "Linda akaunti yako kwa safu ya ziada ya usalama. Uthibitishaji wa mambo mawili hupunguza kwa kiasi kikubwa hatari ya ufikiaji usioidhinishwa kwa akaunti yako.",
    benefit1:
      "Huzuia ufikiaji usioidhinishwa hata ikiwa nenosiri lako limevurugika",
    benefit2: "Inahitajika na mazoea bora ya usalama kwa akaunti za nyeti",
    benefit3: "Inalinda data yako na kuzuia mashambulio ya kuchukua akaunti",
    setupError: "Hitilafu ya Kusimamia MFA",
    setupErrorDescription: "Hawezi kuweka uthibitishaji wa mambo mawili",
    enableError: "Hitilafu ya Kuwezesha MFA",
    enableErrorDescription:
      "Msimbo wa uthibitishaji sio sahihi. Tafadhali jaribu tena.",
    disableError: "Hitilafu ya Kuzima MFA",
    disableErrorDescription: "Nenosiri lako batili. Tafadhali jaribu tena.",
    invalidCode: "Msimbo wa Uthibitishaji Batili",
    invalidCodeDescription: "Msimbo wa uthibitishaji sio sahihi",
    smsError: "Hitilafu ya Kutuma SMS",
    smsErrorDescription: "Hawezi kutuma msimbo wa SMS",
    adminStatusOn: "MFA imewashwa",
    adminStatusOff: "MFA haijawashwa",
    adminDisableConfirm:
      "Zima MFA kwa akaunti hii? Mtumiaji ataondolewa kwenye vifaa vyote na ataingia kwa nenosiri tu.",
    adminDisableSuccess: "MFA imezimwa kwa mafanikio",
    adminDisableError: "Imeshindwa kuzima MFA",
  },
  forceLogout: {
    passwordChanged: "Nenosiri lako limebadilishwa",
    accountDeactivated: "Akaunti yako imezimwa",
    mfaEnabled: "MFA imewezeshwa kwenye akaunti yako",
    securityEvent: "Tukio la usalama limegunduliwa",
    sessionExpired: "Kipindi kimeisha",
    loggedOut: "Umetolewa kwenye akaunti. Tafadhali ingia tena.",
  },
  trialCommercialBlock: {
    title: "Kipindi chako cha majaribio kimeisha",
    badge: "Majaribio ya bure yameisha",
    body:
      "Asante kwa kujaribu EdTrust. Ili kuendelea kusimamia taasisi yako kupitia EdManager, wasiliana na timu yetu ya biashara ili kuchagua ofa inayofaa.",
    contactTitle: "Wasiliana na timu yetu ya biashara",
    switchBuildingHint:
      "Bado unaweza kufikia taasisi zako nyingine kwa kubadilisha taasisi hapa chini.",
    accountsKeptTitle: "Akaunti za EdParent na EdTeacher zimehifadhiwa",
    parentsKept: "Akaunti za wazazi hazifutwi.",
    teachersKept: "Akaunti za walimu hazifutwi.",
    accountsKeptFootnote: "Ufikiaji kamili utarejeshwa mara tu hali yako itakaporekebishwa.",
    phoneLabel: "Simu",
    emailLabel: "Barua pepe",
  },
  overduePaymentBlock: {
    title: "Ufikiaji wa EdManager umesimamishwa",
    badge: "Malipo yanasubiriwa",
    body:
      "Ada za usajili za taasisi yako bado hazijalipwa. Ili kurejesha ufikiaji, tafadhali wasiliana na timu yetu ya biashara ili kukamilisha malipo yako.",
    reasonLabel: "Sababu:",
    reason: "muda wa mwisho wa malipo umepitwa kwa zaidi ya siku {days} (tarehe iliyopangwa: {date}, saa za Tunis, UTC+1).",
    reasonNoDate: "muda wa mwisho wa malipo umepitwa kwa zaidi ya siku {days}.",
    contactTitle: "Una swali kuhusu malipo yako? Wasiliana na timu yetu ya biashara",
  },
  auth: {
    loginFailed: "Kushindwa Kuingia",
    ssoLoginFailed: "Kushindwa Kuingia SSO",
    genericError: "Hitilafu imetokea",
  },
  niveau: {
    niveauPre: "Kabla ya shule",
    niveau0: "Maandalizi",
    playGroup: "Kikundi cha Mchezo",
    pp1: "PP1",
    pp2: "PP2",
    niveau1: "Mwaka wa kwanza",
    niveau2: "Mwaka wa pili",
    niveau3: "Mwaka wa tatu",
    niveau4: "Mwaka wa nne",
    niveau5: "Mwaka wa tano",
    niveau6: "Mwaka wa sita",
    autres: "Nyingine",
    niveau7: "Mwaka wa saba",
    niveau8: "Mwaka wa nane",
    niveau9: "Mwaka wa tisa",
    niveau10: "Mwaka wa kumi",
    niveau11: "Mwaka wa kumi na moja",
    niveau12: "Mwaka wa kumi na mbili",
    niveau13: "Mwaka wa kumi na tatu",
  },
  assiduite: {
    assiduite: "Mahudhurio",
    retard: "Kuchelewa",
    present: "Yupo",
    absence: "Kutokuwepo",
    exclus: "Kutengwa",
    assiduiteMSA: "Mahudhurio yamesasishwa",
    assiduiteMoisChart: "Mahudhurio mwezi huu ya darasa { className }",
    nb_absent: "Idadi ya ukosefu",
    nb_delay: "Idadi ya kuchelewa",
    nb_exclusion: "Idadi ya kutengwa",
    date: "Tarehe",
    areYouSureToEdit: "Una uhakika unataka kubadilisha mahudhurio?",
    erreurRecuperationSeances: "Kosa wakati wa kupata vipindi",
    erreurRecuperationDonnees: "Kosa wakati wa kupata data za mahudhurio",
    callSheet: "Karatasi ya mahudhurio",
    seance: "Kipindi",
    type: "Aina",
  },
  teacherAttendance: {
    title: "Mahudhurio ya Walimu",
    teacher: "Mwalimu",
    filterTeacher: "Chuja kwa mwalimu",
    allTeachers: "Walimu wote",
    filterStatus: "Chuja kwa hali",
    allStatuses: "Hali zote",
    notMarked: "Haijarekodiwa",
    status_present: "Yupo",
    status_absent: "Hayupo",
    status_late: "Amechelewa",
    status_absent_morning: "Hayupo (asubuhi)",
    status_absent_afternoon: "Hayupo (alasiri)",
    status_absent_morning_short: "Asubuhi",
    status_absent_afternoon_short: "Alasiri",
    lateTitle: "Ingiza ucheleweshaji",
    enterDelay: "Tafadhali ingiza muda wa ucheleweshaji (kwa dakika)",
    delayPlaceholder: "Muda kwa dakika",
    updated: "Mahudhurio yamesasishwa",
    removed: "Mahudhurio yameondolewa",
    offSite: "Nje ya eneo",
    offSiteHint: "Kuingia kulirekodiwa nje ya eneo la shule",
    tabDaily: "Kuingia kwa siku",
    tabPersonnelDaily: "Siku (bila ratiba)",
    tabReport: "Ripoti",
    reportMode: "Aina ya ripoti",
    personnelDailyReportTitle: "Ripoti ya mahudhurio ya kila siku",
    markedDays: "Siku zilizorekodiwa",
    tabComparison: "Yanayotarajiwa dhidi ya halisi",
    searchByName: "Tafuta kwa jina",
    searchByNamePlaceholder: "Jina la mfanyakazi...",
    comparisonHint:
      "Linganisha masaa yanayotarajiwa (usanidi wa somo × wiki, au ratiba / usanidi wa kila siku) na masaa halisi. Panua safu ya mwalimu kwa maelezo kwa kila somo.",
    comparisonTitle: "Ripoti ya yanayotarajiwa dhidi ya halisi",
    expectedHours: "Masaa yanayotarajiwa",
    actualHours: "Masaa halisi",
    absentHours: "Masaa ya kutokuwepo",
    delayHours: "Masaa ya ucheleweshaji",
    varianceHours: "Tofauti",
    timetableHours: "Masaa ya ratiba",
    noSubjectBreakdown: "Hakuna maelezo kwa somo kwa mtu huyu.",
    validationPending: "Inasubiri uthibitisho",
    validationValidated: "Imethibitishwa",
    validate: "Thibitisha",
    validateAll: "Thibitisha zote zinazosubiri",
    validationHint:
      "Hierarkia ya uthibitisho imewashwa: alama zinabaki zikisubiri hadi meneja athibitishe.",
    moduleDisabled:
      "Mahudhurio ya Walimu yamezimwa kwa taasisi hii. Yawasha katika Taasisi → Mipangilio.",
    personnelDailyHint:
      "Mahudhurio kwa kila mtu kwa siku, hayahusiani na ratiba. Haijarekodiwa = Yupo kwa chaguo-msingi.",
    filterPersonnel: "Chuja kwa wafanyakazi",
    allPersonnel: "Wafanyakazi wote",
    defaultPresent: "Yupo (chaguo-msingi)",
    reportTitle: "Ripoti ya mahudhurio ya walimu",
    period: "Kipindi",
    delayMinutes: "Ucheleweshaji (dak)",
    workedHours: "Masaa yaliyofanya kazi",
    workedDays: "Siku zilizofanya kazi",
    editHistory: "Historia ya mahudhurio",
    noHistory: "Hakuna historia bado",
    recordDeleted: "Mahudhurio haya yamefutwa",
    showDeleted: "Onyesha yaliyofutwa",
    historyBy: "Na",
    historyBefore: "Kabla",
    historyAfter: "Baada",
    historyAction_created: "Imeundwa",
    historyAction_updated: "Imesasishwa",
    historyAction_deleted: "Imefutwa",
    historyAction_restored: "Imerejeshwa",
    source_teacher_checkin: "Kuingia kwa mwalimu",
    source_admin_manual: "Ingizo la msimamizi",
    minShort: "dak",
  },
  avance: {
    ajoutAvance: "Ongeza mkopo",
    ajoutAvanceSubTitle:
      "Tafadhali jaza sehemu zilizo hapa chini ili kuongeza mkopo.",
    montantAvance: "Kiasi cha mkopo",
    impoAnnulerAvance: "Haiwezekani kughairi mkopo",
    typeRecetteRequis: "Aina ya mapato inahitajika!",
    saisirChequeInfo: "Ingiza maelezo ya hundi",
    saisirChequeEspaceInfo: "Ingiza maelezo ya hundi na fedha taslimu",
    chequeNumRequis: "Nambari ya hundi inahitajika!",
    historiqueAvances: "Historia ya mikopo",
    avanceAjoute: "Mkopo umeongezwa kwa mafanikio",
  },
  xlsxUploader: {
    cliquer: "Bonyeza au buruta faili katika eneo hili ili kuipakia",
    importEleves: "Leta wanafunzi",
    importElevesSubTitle: "Leta wanafunzi kwa kufuata muundo katika kiolezo",
    downloadTemplate: "Pakua kiolezo cha Excel",
    affectation: "Ugao",
    affectationSubTitle: "Gawa wazazi",
    enregistrer: "Hifadhi",
    enregistrerSubTitle: "Kagua kisha hifadhi",
    erreurValidationEleves: "Kosa la uthibitishaji - karatasi ya wanafunzi",
    erreurValidationParents: "Kosa la uthibitishaji - karatasi ya wazazi",
    erreurFormatDate: "Kosa la muundo wa tarehe",
    formatFichierInvalide: "Muundo wa faili si sahihi",
    formatFichierInvalideSubTitle:
      "Tafadhali pakua faili sahihi la kiolezo na ujaze data yako!",
    verifierDonnees: "Kagua data yako",
    affecterParents: "Gawa wazazi",
    sectionParent: "Sehemu ya wazazi katika jedwali",
    totalEleves: "Jumla ya wanafunzi",
    totalParents: "Jumla ya wazazi",
    elevesNonAffectes: "Wanafunzi wasiogawiwa",
    verificationParents:
      "Kagua, wazazi wengi wenye jina moja wanaweza kugawiwa",
    eleveNonAffecte: "Mwanafunzi asiyegawiwa",
    affecterParent: "Gawa mzazi",
    rechercher: "Tafuta",
    reset: "Anzisha upya",
    laLigne: "mstari",
    lesLignes: "mistari",
    dansLeFichierExcel: "katika faili la Excel",
    verifierDonneesEleves: "Tafadhali kagua data za lazima za wanafunzi",
    verifierDonneesParents: "Tafadhali kagua data za lazima za wazazi",
    verifierDonnees:
      "Tafadhali kagua miundo ya data, sehemu za lazima na ugao wa wazazi kwa kila mwanafunzi",
    listeImporteeSucces: "Orodha imeletwa kwa mafanikio",
    incompleteImport:
      "Uletaji hautimizwi, baadhi ya wanafunzi au wazazi hawakuingizwa",
    erreurImportationParents: "Kosa la kuingiza wazazi",
    erreurImportationEleves: "Kosa la kuingiza wanafunzi",
    erreurImportationSubTitle: "Tafadhali kagua mistari ifuatayo",
    elevesExistants: "Wanafunzi wanaoweza kuwepo",
    elevesExistantsPotentiels: "Wanafunzi wanaoweza kuwepo",
    existeDeja: "Inaweza kuwepo tayari katika msingi",
    correspondances: "Mawasiliano",
    eleveExisteDeja: "mwanafunzi anaweza kuwepo tayari",
    elevesExistentDeja: "wanafunzi wanaweza kuwepo tayari",
    lignesExcel: "Mistari",
    verifierAvantImport: "Tafadhali kagua kabla ya kuhifadhi",
    erreurVerificationExistence:
      "Kosa wakati wa kukagua wanafunzi waliopo. Tafadhali endelea kwa tahadhari.",
    filtrerPar: "Chuja kwa",
    effacerFiltres: "Futa vichujio",
    elevesExistantsDeja: "Wanafunzi wanaoweza kuwepo",
    elevesExistantsDejaSubTitle:
      "Wanafunzi hawa wanaweza kuwepo tayari katika msingi wa data",
    verificationEnCours: "Kukagua wanafunzi waliopo inaendelea...",
    eleveExistePotentiellement: "Mwanafunzi huyu anaweza kuwepo tayari",
    confirmerEnregistrement: "Thibitisha kuhifadhi",
    resumeImportation: "Muhtasari wa uletaji",
    totalDansFichier: "Jumla katika faili la Excel",
    elevesAInserer: "Wanafunzi wa kuweka",
    elevesAvecParentsSimilaires: "Wanafunzi na wazazi sawa",
    confirmezVousEnregistrement: "Je, unathibitisha kuhifadhi wanafunzi hawa?",
    eleves: "wanafunzi",
    confirmerRetraitTitle: "Thibitisha kuondoa",
    confirmerRetrait: "Thibitisha kuondoa",
    confirmer: "Thibitisha",
    annuler: "Ghairi",
    confirmerRetraitMessage:
      "Una uhakika unataka kuondoa {count} mwanafunzi/mwanafunzi kutoka kwenye orodha?",
    actionIrreversible: "Tendo hili halibadilishwi",
    selectionnerAuMoinsUn: "Tafadhali chagua angalau mwanafunzi mmoja",
    elevesRetires: "{count} mwanafunzi/mwanafunzi wameondolewa kwa mafanikio",
    modeSelection: "Hali ya kuchagua imeamilishwa",
    modeSelectionDescription:
      "Chagua wanafunzi wa kuondoa kutoka kwenye orodha, kisha bonyeza 'Thibitisha kuondoa'",
    retirerDeLaListe: "Ondoa kutoka kwenye orodha",
    actions: "Vitendo",
    nomPrenom: "Jina na jina la kwanza",
    dateNaissance: "Tarehe ya kuzaliwa",
    adresse: "Anwani",
    sexe: "Jinsia",
    telephone: "Simu",
    identifiantUnique: "Kitambulisho cha kipekee",
    parent: "Mzazi",
    garcon: "Mvulana",
    fille: "Msichana",
    elevesRetiresDeListe: "Wanafunzi wameondolewa kutoka kwenye orodha",
  },
  profil: {
    noParentCredentials: "Mzazi huyu hana akaunti ya kuingia",
    noParentInfo:
      "Tafadhali ongeza maelezo ya mzazi huyu ili kuunda akaunti ya kuingia",
    photoMediaConsent: "Idhini ya picha na midia ya mzazi",
    photoMediaConsentCard: "Picha na midia",
    photoMediaConsentHint: "Kwa wanafunzi wote wa akaunti hii ya mzazi.",
    parentSuggestionTitle: "Wazazi wenye nambari sawa ya simu",
    changerNomUtilisateur: "Badilisha jina la mtumiaji",
    historique: "Historia",
    paiement: "Malipo",
    payes: "Yaliyolipwa",
    nonPayes: "Hayajalipwa",
    bulletin: " Ripoti ya shule",
    qrCode: "Msimbo wa QR",
    informations: "Maelezo",
    Control: "Udhibiti wa mzazi",
    edtudiant: "Akaunti za wanafunzi",
    paiementScol: "Malipo ya shule",
    paiementAct: "Malipo ya shughuli",
    paidWithAvance: "Imelipwa kwa mkopo",
    listeReglements: "Orodha ya kanuni",
    sexe: "Jinsia",
    nom: "Jina la ukoo",
    middleName: "Jina la pili",
    prenom: "Jina la kwanza",
    nomFr: "Jina la ukoo kwa Kifaransa",
    prenomFr: "Jina la kwanza kwa Kifaransa",
    middleNameFr: "Jina la pili kwa Kifaransa",
    nemisNumber: "Nambari ya NEMIS ya Mwanafunzi",
    birthCertificate: "Hati ya kuzaliwa",
    fullname: "Jina kamili",
    saccoName: "Jina la SACCO",
    saccoBankName: "Jina la Benki ya SACCO",
    dateNaissance: "Tarehe ya kuzaliwa",
    garcon: "Mvulana",
    fille: "Msichana",
    adresse: "Anwani",
    postalAddress: "Anwani ya posta",
    physicalAddress: "Anwani halisi",
    tel: "Simu",
    classe: "Darasa",
    notes: "Alama",
    healthInformation: "Taarifa za afya",
    bloodType: "Aina ya damu",
    medicalCondition: "Hali ya kiafya",
    medicalNotes: "Maelezo ya kiafya",
    allergies: "Vichocheo",
    parentNoteOnAllergies: "Maelezo ya mzazi kuhusu vichocheo",
    unknown: "Haijulikani",
    nonInscrit: "Hajasajiliwa bado",
    nomUser: "Jina la mtumiaji",
    mdp: "Nenosiri",
    currentPassword: "Nenosiri la sasa",
    NewPwd: "Nenosiri jipya",
    ConfirmNewPwd: "Thibitisha nenosiri jipya",
    resetPwd: "Anzisha upya nenosiri",
    gere: "Simamia",
    consulter: "Shauriana",
    consulterPaiement: "Angalia malipo",
    etat: "Hali",
    mois: "Mwezi",
    etablissement: "Taasisi",
    administration: "Utawala",
    ajouteLe: "Imeongezwa",
    lastModifi: "Mabadiliko ya mwisho",
    annulerInscri: "Ghairi usajili",
    father: "Baba",
    mother: "Mama",
    guardian: "Mlezi",
    changerPrametreParent: "Badilisha mipangilio ya mzazi",
    changerPrametreParents: "Badilisha mipangilio ya wazazi",
    changerPrametreEleve: "Badilisha mipangilio ya mwanafunzi",
    changerPrametreTeacher: "Badilisha mipangilio ya mwalimu",
    teacherCredentialsSessionWarning:
      "Kubadilisha jina la mtumiaji au nenosiri kutamwondoa mwalimu kwenye vifaa na vikao vyote.",
    noTeacherCredentials: "Mwalimu huyu hana akaunti ya kuingia",
    noTeacherInfo:
      "Tafadhali ongeza maelezo (barua pepe) ya mwalimu huyu ili kuunda akaunti ya kuingia",
    ajouterCompteEnseignant: "Ongeza akaunti ya mwalimu",
    inscriActivitePour: "Usajili wa shughuli kwa {name}",
    poid: "Uzito",
    taille: "Urefu",
    maladies: "Magonjwa",
    remarques: "Maelezo",
    selectOption: "Chagua angalau chaguo moja",
    aucuneMaladieEnregistree: "Hakuna ugonjwa ulioandikwa",
    aucuneDossierMedical: "Hakuna faili la kiafya lililopatikana!",
    annulationEleve: "Kughairi usajili",
    deleteEleve: "Futa mwanafunzi",
    nameChangeRequest: "Mabadiliko ya jina yameombwa",
    firstNameChangeRequest: "Mabadiliko ya jina la kwanza kutoka",
    lastNameChangeRequest: "Mabadiliko ya jina la ukoo kutoka",
    requestedBy: "imeombwa na",
    student: "Mwanafunzi",
    to: "hadi",
    approuver: "Idhinisha",
    rejeter: "Kataa",
    birthPlace: "Mahali pa kuzaliwa",
    confirmDelete:
      "Una uhakika unataka kufuta picha hii ya mwanafunzi? Tendo hili haliwezi kubatilishwa.",
    viewStudentPhoto: "Ona picha ya mwanafunzi",
    uploadStudentPhoto: "Pakia picha ya mwanafunzi",
    removeStudentPhoto: "Futa picha ya mwanafunzi",
    years: "miaka",
    profile: "Wasifu",
    userProfilePhoto: "Picha ya wasifu",
    uploadUserPhoto: "Pakia picha ya wasifu",
    removeUserPhoto: "Futa picha ya wasifu",
    unavailableUserName: "Jina la mtumiaji halipatikani!",
    passwordMustIncludeDigit: "Nenosiri lazima liwe na angalau nambari moja",
    passwordMustIncludeUppercase:
      "Nenosiri lazima liwe na angalau herufi kubwa moja",
    passwordMustIncludeLowercase:
      "Nenosiri lazima liwe na angalau herufi ndogo moja",
    passwordMinLength: "Nenosiri lazima liwe na angalau herufi 8",
    passwordMustNotMatchUsername:
      "Nenosiri lazima liwe tofauti na jina la mtumiaji",
    ajouterCompteParent: "Ongeza akaunti ya mzazi",
    administration: "Utawala",
  },
  topBar: {
    issuesHistory: "Historia ya matatizo",
    projectManagement: "Usimamizi wa mradi",
    typeToSearch: "Tafuta...",
    findPages: "Tafuta kurasa...",
    actions: "Vitendo",
    status: "Hali",
    profileMenu: {
      hello: "Hujambo",
      billingPlan: "Mpango wa bili",
      role: "Jukumu",
      email: "Barua pepe",
      phone: "Simu",
      editProfile: "Hariri wasifu",
      logout: "Toka",
    },
    notification: {
      notifications: "Arifa",
      searchPlaceholder: "Tafuta arifa...",
      noNotifications: "Hakuna arifa zilizopatikana",
      errorFetch: "Imeshindwa kupakia arifa",
      readMore: "Soma zaidi",
    },
    bookmarks: "Kumbuka",
    pack: "Kifurushi",
    storage: {
      menuLabel: "Hifadhi",
      menuHintNoBar: "Fungua kwa historia na maelezo",
      tooltip: "Matumizi ya hifadhi",
      modalTitle: "Historia ya matumizi ya hifadhi",
      seriesStorage: "Hifadhi",
      noData: "Hakuna data ya skani bado",
      objectsLabel: "vitu",
      currentSummary: "Ya mwisho: {storage} · {count} vitu",
      scopeDescription:
        "Jumla hii inaonyesha hifadhi zote zinazotumika na shule yako kwenye mfumo, ikijumuisha kozi, kazi za nyumbani, na faili walizopakia walimu na mengine kama hayo.",
      quotaTitle: "Hifadhi ya kifurushi chako",
      quotaUsedOf: "{used} kati ya {allowed} zimetumika",
      quotaUnlimitedLine:
        "{used} zimetumika · hakuna kikomo cha hifadhi kwenye kifurushi chako",
      quotaOver:
        "Umepitisha kikomo cha hifadhi. Kupakia kunaweza kusitishwa. Wasiliana na timu ya mauzo kuongeza kikomo.",
      quotaNear:
        "Ukaribia kikomo cha hifadhi. Ondoa faili au wasiliana na timu ya mauzo kuongeza kikomo.",
      objectsInLastScan: "{count} vitu katika ukusanyaji wa mwisho",
      chartLimitLabel: "Kikomo cha kifurushi",
    },
  },
  command: {
    idCommand: "Kitambulisho cha amri",
    clientName: "Jina la mteja",
    date: "Tarehe",
    montant: "Kiasi",
    productName: "Jina la bidhaa",
    quantity: "Idadi",
    etat: "Hali",
    status: "Hali",
    detailsTitle: "Maelezo",
    available: "Inapatikana",
    unavailable: "Haipatikani",
    productsInCommand: "Bidhaa katika amri",
    associatedCommands: "Amri zinazohusiana",
    state: "Hali",
    Commands: "Amri",
    createdAt: "Imeundwa",
    pending: "Inasubiri",
    inProgress: "Inaendelea",
    cancelled: "Imeghairiwa",
    validated: "Imethibitishwa",
    active: "Hai",
    inactive: "Si hai",
    note: "Kidokezo",
    showArchived: "Onyesha zilizohifadhiwa",
    search: "Tafuta kwa nambari au jina la mteja",
    showActive: "Onyesha hai",
    ennote: "Ingiza kidokezo kwa amri",
  },
  product: {
    image: "Picha",
    name: "Jina",
    price: "Bei",
    availability: "Upatikanaji",
    quantity: "Idadi",
    lastUpdate: "Mwisho kusasishwa",
    addProduct: "Ongeza bidhaa",
    editProduct: "Hariri bidhaa",
    visibility: "Mfumo wa kuona",
    tags: "Alama",
    description: "Maelezo",
    coverPicture: "Picha ya jalada",
    additionalPictures: "Picha za ziada",
    submit: "Wasilisha",
    available: "Inapatikana",
    unavailable: "Haipatikani",
    private: "Binafsi",
    public: "Umma",
    uploadCoverPicture: "Pakia picha ya jalada",
    modifyCoverPicture: "Badilisha picha ya jalada",
    uploadAdditionalPictures: "Pakia picha za ziada",
    reference: "Kumbuka",
    pictures: "Picha",
    Products: "Bidhaa",
    comingSoon: "Inakuja hivi karibuni",
    outOfStock: "Haikupo kwenye hifadhi",
    reqprice: "Bei inahitajika",
    reqavailability: "Upatikanaji unahitajika",
    reqquantity: "Idadi inahitajika",
    productAdded: "Bidhaa imeongezwa kwa mafanikio",
    impoPubAjout: "Haiwezekani kuongeza bidhaa",
    reqname: "Jina linahitajika",
    tag: "Ingiza alama au chagua kutoka zilizopo",
    ref: "Ingiza kumbuka (si lazima)",
    currency: "KSH",
    search: "Ingiza jina la bidhaa",
    minprice: "Bei ya chini",
    maxprice: "Bei ya juu",
    noChanges: "Hakuna mabadiliko yaliyogunduliwa",
    productDetails: "Maelezo ya bidhaa",
    visiblity: "Mfumo wa kuona",
  },
  menu: {
    marketproducts_list: "Orodha ya bidhaa",
    marketPlace: "Duka la shule",
    powerbi: "PowerBI",
    connection: "Watumiaji",
    statstiqueGeneral: "Takwimu za jumla",
    accessTeacher: "Ufikiaji wa walimu",
    parametrageEtablissement: "Mipangilio ya taasisi",
    parametrageComptabilite: "Mipangilio ya uhasibu",
    parametrageScolarite: "Mipangilio ya masomo",
    smartSchedule: "Ratiba mahiri",
    teacherAvailability: "Upatikanaji wa walimu",
    calender: "Kalenda",
    cheques: "Hundi",
    chat: "Mazungumzo",
    supervision: "Usimamizi",
    ptchat: "Mazungumzo ya walimu na wazazi",
    logout: "Toka",
    activites: "Shughuli",
    etablissement: "Taasisi",
    generale: "Ya jumla",
    accueil: "Nyumbani",
    parametrage: "Mipangilio",
    actualite: "Habari",
    administration: "Utawala",
    autorisation: "Idhini",
    utilisateur: "Mtumiaji",
    liste: "Orodha ya wanafunzi",
    cantine: "Menyu ya mkahawa",
    etatPaiement: "Hali ya malipo",
    inscriActiv: "Usajili: Shughuli",
    emploiActivites: "Ratiba: Shughuli",
    assiduiteActivites: "Mahudhurio: Shughuli",
    scolarite: "Masomo",
    inscriScol: "Usajili: Masomo",
    etatPaiements: "Hali ya malipo",
    listePunition: "Orodha ya adhabu",
    emploi: "Ratiba ya masaa",
    eleves: "Wanafunzi",
    enseignants: "Walimu",
    bulletin: "Ripoti ya shule",
    bulletinCollege: "Ripoti ya shule ya kati / sekondari",
    bulletinStatistique: "Ripoti ya takwimu",
    notes: "Alama",
    notesModule: "Alama kwa somo",
    notesParEleve: "Alama kwa mwanafunzi",
    notesModuleComplet: "Alama kwa moduli",
    personnel: "Wafanyakazi",
    listePersonnels: "Orodha ya wafanyakazi",
    listeEnseignants: "Orodha ya walimu",
    teacherAttendance: "Mahudhurio ya Walimu",
    listeActivites: "Orodha ya shughuli",
    virementBancaire: "Uhamishaji wa benki",
    listeEleves: "Orodha ya wanafunzi",
    comptabilite: "Uhasibu",
    etatRecettes: "Hali ya mapato",
    journaleCaisse: "Jarida la sanduku",
    depenses: "Matumizi",
    nouvelleDepense: "Gharama mpya",
    fournisseurs: "Wauzaji",
    fournisseurProfile: "Wasifu wa mtoa huduma",
    factures: "Ankara",
    saisiePaiement: "Kuingiza malipo",
    historiquePaiements: "Historia ya malipo",
    encaissementValidation: "Uthibitishaji wa mapokezi",
    reconciliation: "Upatanisho",
    avoirFournisseur: "Hati ya mkopo ya muuzaji",
    dettes: "Ahadi",
    depensesPersonnel: "Matumizi ya mishahara",
    etatImpayes: "Hali ya yasiyolipwa",
    listeReglement: "Orodha ya kanuni",
    reglementsAnnules: "Kanuni zilizoghairiwa",
    etatImpayesActivites: "Hali ya yasiyolipwa: Shughuli",
    etatImpayesScolarite: "Hali ya yasiyolipwa: Masomo",
    declaration: "Azimio",
    decaissement: "Kutoa fedha",
    declarationTva: "Azimio la VAT",
    chiffreAffaires: "Mauzo",
    chiffreAffairesScolarite: "Mauzo: Masomo",
    statistique: "Takwimu",
    actulite: "Habari",
    sms: "SMS",
    smsAndNotifications: "SMS na Arifa",
    envoyerSms: "Tuma SMS",
    envoyerSmsLogin: "Miingio ya wazazi",
    envoyerParClasseSms: "Tuma kwa darasa",
    historiqueSms: "Historia",
    caisseAvance: "Sanduku la mikopo",
    assiduite: "Mahudhurio",
    preinscription: "Usajili wa awali",
    profile: "Wasifu wangu",
    certificate: "Cheti",
    finance: "Fedha",
    tresorerie: "Hazina",
    manageCaisses: "Simamia masanduku",
    myCaisse: "Sanduku langu",
    encaissement: "Ukusanyaji wa fedha",
    chequeEtTraite: "Hundi na drafti",
    degital_library: "Maktaba ya kidijitali",
    degital_library_list: "Orodha ya hati",
    financialStats: "Takwimu za kifedha",
    printExport: "Chapisha na Hamisha",
    dataManagement: "Usimamizi wa Data",
    accessManagement: "Usimamizi wa Ufikiaji",
    parentLogins: "Miingio ya Wazazi",
    studentLogins: "Miingio ya Wanafunzi",
    adminLogins: "Miingio ya Wasimamizi",
  },
  finance: {
    invoiceBuilder: "Ongeza malipo",
    legend: "Ufafanuzi:",
  },
  accueil: {
    title: "Dashibodi",
    subtitle: "Muhtasari wa shughuli na takwimu za shule",
    refresh: "Sasisha",
    activite: "Shughuli",
    activiteSubtitle: "Jumla ya idadi ya shughuli zinazopatikana",
    eleves: "Wanafunzi",
    elevesSubtitle: "Jumla ya idadi ya wanafunzi waliojiandikisha",
    employees: "Wafanyakazi",
    employeesSubtitle: "Jumla ya idadi ya wafanyakazi",
    classes: "Madarasa",
    classesSubtitle: "Jumla ya idadi ya madarasa yanayopatikana",
    serviceActiv: "Huduma / Shughuli",
    benefice: "Jumla ya mapato",
    montant: "Kiasi",
    pourcentage: "ASILIMIA",
    depense: "Jumla ya matumizi",
    RevenuDep: "Matumizi / Mapato",
    depenses: "Matumizi",
    revenu: "Mapato",
    tnd: "KSH",
    boys: "Wavulana",
    girls: "Wasichana",
    totalBoys: "Jumla ya wavulana",
    totalGirls: "Jumla ya wasichana",
    noDataClasses: "Hakuna data ya madarasa",
    totalClasses: "Jumla ya idadi ya madarasa",
    nombreDeClasses: "Idadi ya madarasa",
    noDataNiveaux: "Hakuna data ya viwango",
    moreDetails: "Bonyeza hapa kwa maelezo zaidi",
    stat: "Takwimu za kina",
    deletedClasse: "Darasa limefutwa",
    dashboard: {
      hello: "Habari",
      guest: "Mgeni",
      subtitleOverview: "Hii ni muhtasari wa shule yako leo.",

      quickCantine: "Mkahawa",
      quickConsolidation: "Uimarishaji",
      quickClasses: "Madarasa",
      quickEmploi: "Ratiba",
      quickEleves: "Wanafunzi",
      quickDiscipline: "Nidhamu",
      quickSupport: "Msaada",

      financialSummary: "Muhtasari wa fedha",
      seeDetails: "Angalia maelezo",
      encaissementDuJour: "Makusanyo ya leo",
      decaissementDuJour: "Malipo ya leo",
      vsHier: "ikilinganishwa na jana",
      soldeNetJour: "Salio safi la leo",

      criticalTasks: "Kazi muhimu",
      criticalTasksSubtitle: "Hatua inahitajika · Unahitaji umakinifu wako",
      enAttente: "inasubiri",
      allClear: "Kila kitu kimesasishwa!",
      punitionsPending: "Adhabu zinazosubiri uthibitishaji",
      actualitesPending: "Habari zinazosubiri uthibitishaji",
      notificationsUnread: "Arifa ambazo hazijasomwa",
      messagesUnanswered: "Ujumbe wa wazazi ambao haujajibiwa",
      addNews: "Ongeza habari",
      newsCtaFirstTitle: "Ongeza habari yako ya kwanza na uarifu wazazi",
      newsCtaFirstSubtitle:
        "Shiriki taarifa muhimu za shule kwa kubofya machache.",
      newsCtaTodayTitle: "Ongeza habari ya leo ili kuwaambia wazazi",
      newsCtaTodaySubtitle:
        "Hakuna habari iliyochapishwa leo. Endelea kuwasiliana na wazazi.",

      pendingRequests: "Maombi yanayosubiri",
      enAttenteReponse: "Inasubiri jibu",
      requestsParents: "Wazazi",
      requestsEleves: "Wanafunzi",
      requestsPersonnel: "Wafanyakazi",

      birthdays: "Siku za kuzaliwa zijazo mwezi huu",
      searchByName: "Tafuta kwa jina...",
      staff: "Mfanyakazi",
      student: "Mwanafunzi",
      birthdayToday: "Leo",
      birthdayTomorrow: "Kesho",
      birthdayInDays: "Baada ya siku {days}",
      birthdayOnDate: "{date}",
      noBirthdaysToday: "Hakuna siku za kuzaliwa mwezi huu",

      topStudents: "Wanafunzi 10 bora kwa wastani",
      moyenne: "Wastani",
      bulletinPedagogique: "Kielimu",
      bulletinPilote: "Jaribio",
      bulletinSpecifique: "Maalum",
      noTopStudents: "Hakuna wastani unaopatikana kwa ripoti hii",
      accessDenied: "Ufikiaji umekataliwa",

      upcomingEvents: "Matukio yajayo",
      seeAllEvents: "Angalia matukio yote",
      noUpcomingEvents: "Hakuna matukio katika siku 7 zijazo",

      latestNews: "Habari za hivi karibuni",
      seeAllNews: "Angalia habari zote",
      noNews: "Hakuna habari kwa sasa",

      roomsAvailability: "Upatikanaji wa vyumba kwa wakati halisi",
      free: "Huru",
      occupied: "Inatumika",
      noRooms: "Hakuna vyumba vilivyowekwa",

      disciplineBreakdown: "Mgawanyo wa nidhamu",
      total: "Jumla",
      cases: "kesi",
      noSanctions: "Hakuna vikwazo vilivyorekodiwa",
    },
  },
  action: {
    impressionReussie: "Uchapishaji umefanikiwa",
    erreurImpression: "Hitilafu imetokea wakati wa kuchapisha",
    reinitialiser: "Anzisha upya",
    clone: "Nakili",
    reset: "Anzisha upya",
    imprimerTab: "Chapisha jedwali",
    imprimerFreresSoeurs: "Chapisha orodha ya ndugu",
    imprimerBadges: "Chapisha vibeti",
    imprimerNewBadges: "Chapisha vibeti vya picha",
    simpleBadge: "Kibeti rahisi",
    badgeAvecPhoto: "Kibeti na picha",
    actions: "Vitendo",
    operation: "Operesheni",
    supprimer: "Futa",
    ajouter: "Ongeza",
    modifier: "Hariri",
    consulter: "Shauriana",
    annuler: "Ghairi",
    enregistrer: "Hifadhi",
    afficher: "Onyesha",
    voir: "Ona",
    desactiver: "Zima",
    activer: "Washa",
    imprimer: "Chapisha",
    confirmer: "Thibitisha",
    changer: "Badilisha",
    importer: "Leta",
    preview: "Hakiki",
    revoke: "Ondoa",
    retour: "Rudi",
    refresh: "Sasisha",
    retry: "Jaribu tena",
    selectAll: "Chagua vyote",
    bulkEdit: "Hariri kwa wingi",
    saveAll: "Hifadhi vyote",
    applySameReduction: "Tumia punguzo sawa kwa mistari yote iliyochaguliwa",
    selected: "imechaguliwa",
    editing: "Inaharirishwa",
    fullyPaid: "Imelipwa kabisa",
    upload: "Pakia",
    search: "Tafuta",
    cloneSuccess: "Data zote zimebadilishwa kwa mafanikio",
    refreshPage: "tafadhali sasisha ukurasa ili kuona athari kamili",
    imprimerHistorique: "Chapisha historia",
    genererPdfHistorique: "Tengeneza PDF",
    pdfGenereAvecSucces: "PDF imetengenezwa kwa mafanikio",
    succes: "Mafanikio",
    fermer: "Funga",
    status: "Hali",
    suivant: "Ifuatayo",
  },
  common: {
    loading: "Inapakia takwimu...",
    selected: "imechaguliwa",
    editing: "Inaharirishwa",
  },
  message: {
    noSelection: "Hakuna kitu kilichochaguliwa",
    noValidUpdates: "Hakuna mwisho halali uliopatikana",
    bulkUpdateSuccess: "Mapunguzo {count} yamebadilishwa kwa mafanikio",
    bulkUpdateError: "Kosa wakati wa kubadilisha kwa wingi",
    enterReductionValue: "Tafadhali ingiza thamani ya upunguzi",
    paymentDataNotFound: "Data ya malipo haipatikani",
    loadingBulletin: "Tafadhali subiri...",
  },
  confirmation: {
    revokeAccess: "Una thibitisha kuondoa ufikiaji?",
    revokeAccessSaved: "Ufikiaji umeondolewa kwa mafanikio",
    solveTheConflictError: "Tatua mgogoro wa ufikiaji",
  },
  sms: {
    smsSentSuccess: "SMS imetumwa kwa mafanikio",
    selectionner: "Chagua",
    corriger: "Sahihisha",
    paymentRappel: "Ukumbusho wa malipo",
    deatilsAutoSmsTitle: "Maelezo ya ujumbe wa SMS wa otomatiki",
    seeProfile: "Ona wasifu",
    newPayment: "Malipo mapya",
    newInscription: "Usajili mpya",
    newAbsence: "Kutokuwepo/kuchelewa",
    newCourse: "Darasa/Zoezi",
    bulletinDispo: "Ripoti inapatikana",
    actualite: "Habari",
    autoSms: "Mipangilio ya SMS za otomatiki",
    autoPn: "Mipangilio ya arifa za simu",
    votreSolde: "MIZANI YAKO",
    nbrSmsRestant: "Idadi ya SMS zilizobaki",
    paymentTemplate1:
      'Umelipa {kiasi kilicholipwa} TND ada za "{Jina la Shughuli}" kwa {Jina la Mwanafunzi}. Malipo haya ni kwa kipindi {orodha ya miezi}.',
    paymentTemplate2:
      "Umelipa {kiasi kilicholipwa} TND ada za shule kwa {Jina la Mwanafunzi}. Malipo haya ni kwa kipindi {orodha ya miezi}.",
    inscriptionTemplate1:
      "Mtoto wako {jina la mwanafunzi} amesajiliwa kwa mafanikio katika {jina la shughuli}.",
    inscriptionTemplate2:
      "Mtoto wako {jina la mwanafunzi} amesajiliwa kwa mafanikio katika darasa {jina la darasa}.",
    absenceTemplate1:
      'Mtoto wako {jina la mwanafunzi} alikuwa hayupo tarehe {tarehe} saa {wakati} wakati wa kipindi "{jina la kipindi}"',
    absenceTemplate2:
      'Mtoto wako {jina la mwanafunzi} alichelewa tarehe {tarehe} saa {wakati} wakati wa kipindi "{jina la kipindi}"',
    courseTemplate1:
      "Somo jipya limeongezwa kwa mtoto wako kwa kichwa: {kichwa}.",
    courseTemplate2:
      "Zoezi jipya limeongezwa kwa mtoto wako kwa kichwa: {kichwa}.",
    bulletinTemplate:
      "Ripoti {ya kiufundishaji/ya mwongozi/maalum} ya {jina la mwanafunzi} kwa muhula {robo} inapatikana kwenye EdParent.",
    actualiteTemplate:
      "Habari mpya imeongezwa kwenye Edparent kwa kichwa: {kichwa}.",
    nomlExpediteur: "JINA LA MTUMAJI",
    desclExpediteur: "SMS zinatumwa kama",
    gererListeDistinateurs: "SIMAMIA ORODHA YA WAPOKEAJI",
    envoyerDesSms: "TUMA SMS",
    listeVosEleves: "Orodha ya wanafunzi wako",
    listeClasses: "Orodha ya madarasa",
    selectionnerEleves: "Chagua wanafunzi",
    selectionnerClases: "Chagua madarasa",
    pressEnterToSelect: "Bonyeza enter ili kuchagua",
    pressEnterToRemove: "Bonyeza enter ili kuondoa",
    selected: "Imechaguliwa",
    maxClassesReached: "Unaweza kuchagua madarasa 4 kwa upeo",
    entrerNumerosSpecifiques: "Ingiza nambari maalum",
    entrerNumerosSpecifiquesDesc: "Nambari za simu lazima zitengwe kwa koma",
    categorieTag: "Jamii/alama",
    categorieTagDesc: "Alama zinakusaidia kupanga machapisho yako vizuri",
    saisirCategorieTag: "Ingiza jamii/alama",
    contenueVotreMessage: "Ingiza maudhui ya ujumbe wako",
    contenueMessage: "Ingiza maudhui ya SMS",
    listeFinale: "ORODHA YA MWISHO",
    nombreSms: "Idadi ya SMS",
    nombreMessage: "Idadi ya ujumbe",
    nomberTotal: "Idadi ya jumla",
    nombreMessageParCategorie: "Idadi ya SMS kwa jamii",
    nombreCaracteres: "IDADI YA HERUFI",
    pere: "Baba",
    mere: "Mama",
    guardian: "Mlezi",
    specifique: "Maalum",
    destinataire: "Mpokeaji",
    telephone: "Simu",
    parents: "wazazi",
    personnel: "binafsi",
    sanction: "adhabu",
    bulletin: "Ripoti",
    envoyer: "Tuma",
    nonInscrit: "Hajasajiliwa",
    noOptions: "Orodha ni tupu",
    jours: "Siku",
    boiteEnvoieSms: "Sanduku la kutuma SMS",
    message: "Ujumbe",
    numsSpecifiques: "Nambari maalum",
    listeParents: "Orodha ya wazazi",
    envoyeParUser: "Imetumwa na mtumiaji",
    groupe: "Kundi",
    tags: "Alama",
    envoiDate: "Tarehe ya kutuma",
    selectAll: "Chagua vyote",
    selectAllTeachers: "Chagua walimu wote",
    selectAllStudents: "Chagua wanafunzi wote",
    envoyerDesSmsLogins: "TUMA SMS ZA MIINGIO",
    alertNumberSMS:
      "Ikiwa jina la mtumiaji na nenosiri ni ndefu (inazidi herufi 66 za Kiarabu au 156 za Kiingereza) idadi ya SMS kwa mzazi inaweza tumia SMS 2 kutoka kwenye mizani",
    envoyerDesLoginsParents: "Ohereza imyirondoro y'ababyeyi",
    calculerNombreSms: "Kukokotoa idadi ya SMS...",
    totalSms: "Jumla ya SMS: ",
    boiteEnvoie: "Sanduku la kutuma",
    nomUtilisateur: "Jina la mtumiaji",
    nombreSmsEnvoye: "Idadi ya SMS zilizotumwa",
    date: "Tarehe",
    noRecipients: "Tafadhali chagua angalau mpokeaji mmoja ili kutuma SMS.",
    confirmSendTitle: "Uthibitisho wa kutuma SMS",
    invalidPhones: "si sahihi",
    duplicatePhones: "nakala rudufu",
    duplicateTag: "Rudufu",
    noValidNumbers: "Hakuna nambari sahihi",
    confirmTotalLabel: "Idadi ya SMS zitumwazo",
    noValidParentsInformation: "Hakuna maelezo sahihi ya mzazi kwa mwanafunzi:",
    noValidParentInformation:
      "Hakuna maelezo sahihi ya {parent} kwa mwanafunzi:",
    noAccount: "Hakuna akaunti ya {parent} kwa mwanafunzi:",
  },
  library: {
    yes: "Ndiyo",
    no: "Hapana",
    createdBy: "Imeundwa na",
    ajouterDocument: "Ongeza hati",
    editDocument: "Hariri hati",
    titre: "Kichwa",
    subject: "Somo",
    grade: "Kiwango",
    search: "Tafuta",
    submit: "Wasilisha",
    contentType: "Aina ya maudhui",
    text: "Maandishi",
    video: "Video",
    attachment: "Kiambatisho",
    createdAt: "Imeundwa",
    lastUpdate: "Mwisho kusasishwa",
    uploadAttachment: "Pakia kiambatisho",
    uploadVideo: "Pakia video",
    uploadText: "Pakia maandishi",
    visibility: "Mfumo wa kuona",
    public: "Umma",
    private: "Binafsi",
    shared: "Imeshirikiwa",
    add: "Ongeza",
    document: "Hati",
    documents: "Hati",
    levelRequired: "Kiwango kinahitajika",
    select: "Chagua",
    docRequired: "Lazima upakia hati",
    maxDocs: "Huwezi kupakia zaidi ya faili 15",
    ressources: "Rasilimali",
    fileName: "Jina la faili",
    fileUploadError: "Unaweza kupakia faili za JPG, JPEG au PNG tu!",
    added: "Imeongezwa",
    deleted: "Imefutwa",
    updated: "Imesasishwa",
  },
  mobileNotifications: {
    title: "Arifa za Simu",
    detailsTitle: "Maelezo ya arifa za simu za otomatiki",
    enablePaymentReminder: "Washa ukumbusho wa malipo",
    recurringFrequency: "Mara kwa mara",
    weekly: "Kila wiki",
    monthly: "Kila mwezi",
    dayOfWeek: "Siku ya wiki",
    dayOfMonth: "Siku ya mwezi",
    time: "Muda",
    selectDays: "Chagua siku",
    paymentReminderTitle: "Ukumbusho wa Malipo",
    paymentReminderClassroom: "Ukumbusho wa Malipo - Masomo",
    paymentReminderActivity: "Ukumbusho wa Malipo - Shughuli",
    notificationTitle: "Kichwa",
    // Monthly payment messages (matching Lambda function)
    messageClassroomMonthly:
      "Ukumbusho: Tafadhali lipa ada ya masomo ya {month} inayostahili sasa. Tafadhali angalia programu kwa maelezo zaidi.",
    messageActivityMonthly:
      "Ukumbusho: Tafadhali lipa ada ya shughuli za {month} inayostahili sasa. Tafadhali angalia programu kwa maelezo zaidi.",
    // Tranche payment messages (matching Lambda function)
    messageClassroomTranche:
      "Ukumbusho: Tafadhali lipa ada ya masomo ya kistari inayostahili sasa. Tafadhali angalia programu kwa maelezo zaidi.",
    messageActivityTranche:
      "Ukumbusho: Tafadhali lipa ada ya shughuli za kistari inayostahili sasa. Tafadhali angalia programu kwa maelezo zaidi.",
    sendNow: "Tuma Sasa",
    sendNotificationSuccess: "Ukumbusho wa malipo umetumwa kwa mafanikio",
    sendNowConfirmTitle: "Tuma Arifa Sasa?",
    sendNowConfirmMessage:
      "Je, una uhakika unataka kutuma arifa za ukumbusho wa malipo kwa wazazi wote walio na malipo yasiyolipwa sasa hivi?",
    timeRequired: "Muda unahitajika wakati arifa zimewashwa",
    dayOfWeekRequired:
      "Siku angalau moja ya wiki inahitajika kwa mzunguko wa kila wiki",
    dayOfMonthRequired:
      "Siku angalau moja ya mwezi inahitajika kwa mzunguko wa kila mwezi",
  },
  notificationConfig: {
    title: "Kubukua Arifa",
    sendPaymentValidationNotification:
      "Tuma arifa wakati malipo imethibitishwa",
  },
  subject: {
    subject1: "Lugha ya Kiarabu",
    subject2: "Lugha ya Kifaransa",
    subject3: "Hisabati",
    subject4: "Sayansi za Asili",
    subject5: "Historia",
    subject6: "Jiografia",
    subject7: "Elimu ya Kiraia",
    subject8: "Elimu ya Sanaa",
    subject9: "Elimu ya Mwili na Michezo",
    subject10: "Teknolojia ya Habari",
    subject11: "Lugha ya Kiingereza",
    subject12: "Lugha ya Kigeni",
    subject13: "Fizikia-Kemia",
    subject14: "Sayansi za Uhai na Dunia",
    subject15: "Teknolojia",
    subject16: "Falsafa",
  },
  actualite: {
    ajouterAlbum: "Ongeza albamu",
    ajouterActualite: "Ongeza habari",
    modifierAlbum: "Hariri albamu",
    modifierActualite: "Hariri habari",
    album: "Albamu",
    date: "Tarehe ya kutolewa",
    seenAtLabel: "Imeonwa saa",

    tousClasses: "Madarasa yote",
    titre: "Kichwa",
    categorie: "Jamii",
    customCategory: "Jamii maalum",
    customCategoryPlaceholder: "Weka jamii maalum",
    categoryInfo: "Taarifa",
    categoryImportantInfo: "Taarifa muhimu",
    categoryUrgent: "Haraka",
    categoryAvisImportant: "Arifa muhimu",
    categoryAvis: "Arifa",
    categoryImportant: "Muhimu",
    categoryOther: "Nyingine",
    cibles: "Malengo",
    jaimes: "Napenda",
    photos: "Picha",
    dateCreation: "Tarehe ya kuunda",
    tous: "Wote",
    enseignants: "Walimu",
    eleves: "Wanafunzi",
    teachers: "Walimu",
    students: "Wanafunzi",
    administration: "Utawala",
    parents: "Wazazi",
    cliquer: "Bonyeza au buruta faili kwenye eneo ili kuipakia",
    support:
      "Inasaidia upakiaji wa faili moja au nyingi. Ni marufuku kabisa kupakia data za kampuni au faili za vikundi vingine",
    description: "Maelezo",
    ajouterPub: "Ongeza chapisho",
    trimestre1: "Muhula wa 1",
    trimestre2: "Muhula wa 2",
    trimestre3: "Muhula wa 3",
    trimester_one: "Muhula asilia",
    trimester_two: "Muhula ulionakiliwa",
    retour: "Rudi",
    pasImages: "Hakuna picha",
    mentionJaimes: "Mipendaji",
    seenByParentsNewsTitle: "Wazazi walioona habari hii",
    notSeenByParentsNewsTitle: "Wazazi ambao hawajaona habari hii",
    seenNotSeenParentsTitle: "Imeonwa / Haijaonwa na wazazi",
    seenNotSeenParentsLabel: "Imeonwa na haijaonwa na wazazi",
    seenTrackedOnlyForParents:
      "Mionekano hufuatiliwa tu kwa habari zinazolenga wazazi.",
    noParentSeenNews: "Hakuna mzazi ambaye ameona habari hii bado.",
    allParentsSeenNews: "Wazazi wote waliolengwa wameona habari hii.",
    seenCountLabel: "Imeonwa ({count})",
    notSeenLabel: "Haijaonwa",
    notSeenCountLabel: "Haijaonwa ({count})",
    modifierImages: "Hariri picha",
    specificFor: "Maalum kwa",
    levels: "Viwango",
    classrooms: "Madarasa",
    students: "Wanafunzi",
    specified: "Maalum",
    specifiedInfo: "Vichujio vya kutuma vitatekelezwa kwa wazazi tu",
    files: "Faili",
    noFiles: "Hakuna faili zilizopatikana",
    details: "Maelezo ya habari",
    aucuneActualite: "Hakuna habari zilizochapishwa",
    teacherSpecifiedInfo: "Vichujio vya kutuma vitatekelezwa kwa walimu tu",
    selectionnerEnseignants: "Chagua walimu",
    activities: "Shughuli",
    selectActivities: "Chagua shughuli",
    activitiesRequired: "Shughuli zinahitajika",
    studentSpecifiedInfo: "Vichujio vya kutuma vitatekelezwa kwa wanafunzi tu",
    enableComments: "Washa maoni",
    commentsEnabled:
      "Maoni yanaweza kuwaswa au kuzimwa kwa kila habari tofauti",
    commentsDisabled: "Maoni yamezimwa kwa habari zote",
    videoProcessing: "Inachakata video...",
    videoError: "Hitilafu ya kuchakata video",
    videoNotReady: "Video haija tayari bado",
    videoLoading: "Inapakia video...",
    videoNotSupported: "Kivinjari chako hakiwezi kucheza video hii",
    videoTagNotSupported: "Kivinjari chako hakiwezi kuunga mkono tag ya video.",
    videoPlaybackError: "Hitilafu ya kucheza video",
    videoQualityAuto: "Otomatiki",
    videoQuality: "Ubora",
    enableCommentsForThisNews: "Washa maoni kwa habari hii",
    enableCommentsForThisNewsDesc:
      "Ruhusu watumiaji kuacha maoni kwenye habari hii",
    searchAndFilters: "Tafuta na Vichujio",
    total: "Jumla",
    actualitesPlural: "habari",
    clearFilters: "Futa vichujio",
    searchByTitle: "Tafuta kwa kichwa",
    filterByCategory: "Chuja kwa jamii",
    actualiteLabel: "Habari",
    filterByCreationDate: "Chuja kwa tarehe ya kuunda",
    filterByTarget: "Chuja kwa lengo",
    search: "Tafuta",
    parentLabel: "Mzazi:",
    videos: "Video",
    uploadVideo: "Bofya au buruta faili za video hapa ili kuzipakia",
    videoSupport: "Inasaidia aina za video MP4, MOV, AVI, MKV",
    pendingValidation: "Inasubiri Uthibitisho",
    validated: "Imethibitishwa",
    approve: "Thibitisha",
    reject: "Kataa",
    rejected: "Imekataliwa",
    confirmReject: "Je, una uhakika unataka kukataa habari hii?",
    newsValidated: "Habari imethibitishwa kwa mafanikio",
    newsRejected: "Habari imekataliwa kwa mafanikio",
    createdByTeacher: "Imeundwa na mwalimu",
    createdByLabel: "Imeundwa na",
    statusLabel: "Hali",
    validation: "Uthibitishaji",
    validatedLabel: "Imethibitishwa",
    teacher: "Mwalimu",
    admin: "Msimamizi",
    filterByValidation: "Chuja kwa hali",
    allNews: "Zote",
    pendingOnly: "Zinasubiri",
    validatedOnly: "Zimethibitishwa",
    rejectedOnly: "Zimekataliwa",
    seeMore: "Ona zaidi",
    seeLess: "Ona kidogo",
    like: "Penda",
    liked: "Imependwa",
    commentBtn: "Toa maoni",
    writeCommentPlaceholder: "Andika maoni...",
    commentsCountLabel: "Maoni {count}",
    noLikesYet: "Kuwa wa kwanza kupenda chapisho hili",
    noCommentsYet: "Hakuna maoni bado",
    postOptions: "Chaguo",
    composerPrompt1: "Nini kipya shuleni leo?",
    composerPrompt2: "Shiriki habari za leo na jamii yote ya shule…",
    composerPrompt3: "Tangaza tukio, sherehekea mafanikio, au wafahamishe wote.",
    composerPrompt4: "Una taarifa muhimu au habari njema ya kushiriki?",
    composerPrompt5: "Wahimize wazazi, wanafunzi na timu — anza chapisho lako hapa.",
    emojiPickerLabel: "Ongeza emoji",
    sendCommentLabel: "Tuma maoni",
  },
  activityClub: {
    confirmDeletePost:
      "Je, una uhakika unataka kufuta machapisho hii ya shughuli / klabu?",
    tabNews: "Habari na Albamu",
    tabClub: "Shughuli / Klabu",
    addPost: "Ongeza shughuli / klabu",
    editPost: "Hariri shughuli / klabu",
    noPosts: "Hakuna machapisho ya shughuli / klabu",
    searchByTitle: "Tafuta kwa kichwa",
    activity: "Shughuli / Klabu",
    other: "Nyingine",
    customActivityName: "Jina la klabu",
    price: "Bei",
    registrationStartDate: "Tarehe ya kuanza usajili",
    clubStartDate: "Tarehe ya kuanza klabu",
    clubEndDate: "Tarehe ya mwisho klabu",
    maxPlaces: "Nafasi za juu",
    maxPlacesOptional: "Acha tupu bila kikomo",
    unlimited: "Bila kikomo",
    coverImage: "Picha ya jalada",
    attachments: "Viambatisho",
    pending: "Inasubiri",
    accepted: "Imekubaliwa",
    rejected: "Imekataliwa",
    subscribers: "Wanaojiandikisha",
    views: "Maoni",
    searchByName: "Tafuta kwa jina",
    allStatuses: "Hali zote",
    parentName: "Mzazi",
    studentName: "Mwanafunzi",
    status: "Hali",
    subscribedAt: "Alijiandikisha",
    accept: "Kubali",
    reject: "Kataa",
    register: "Jisajili",
    joinSuccess: "Ombi lako limetumwa",
    registrationStartsOn: "Usajili unaanza {date}",
    status_pending: "Inasubiri",
    status_accepted: "Imekubaliwa",
    status_rejected: "Imekataliwa",
    composerPrompt1: "Shiriki shughuli au klabu mpya…",
    composerPrompt2: "Tangaza usajili uliofunguliwa…",
    composerPrompt3: "Chapisha maelezo kuhusu klabu ijayo…",
  },
  etablissement: {
    reductionType: "Aina ya punguzo",
    pourcentage: "Asilimia",
    dinar: "Dinar",
    shilling: "Shilingi",
    currency: "Sarafu",
    TND: "Dinar ya Tunisia (TND)",
    KES: "Shilingi ya Kenya (KES)",
    currencyRequired: "Sarafu inahitajika",
    access: "Ufikiaji",
    editAccess: "Hariri ufikiaji",
    accessUpdated: "Ufikiaji umebadilishwa kwa mafanikio",
    editingAccess: "Kubadilisha ufikiaji",
    config: "Mipangilio",
    editConfig: "Hariri mipangilio",
    editBuilding: "Hariri taasisi",
    accessConfig: "Mipangilio imebadilishwa kwa mafanikio",
    editingConfig: "Kubadilisha mipangilio",
    alertDisableChat:
      "Washa au zima mazungumzo kati ya wazazi na walimu (ikizimwa, walimu na wazazi watapoteza ufikiaji wa mazungumzo mara moja kwenye programu za simu na wavuti)",
    alertRequirePunishmentValidation:
      "Ikiwashwa, adhabu zilizoongezwa na uongozi zitabaki zikisubiri hadi zithibitishwe na msimamizi. Ikizimwa (chaguo-msingi), zinathibitishwa moja kwa moja mara zinapoongezwa.",
    requirePunishmentValidation:
      "Hitaji uthibitisho wa adhabu zilizoongezwa na uongozi",
    alertTeacherAttendanceEnabled:
      "Washa au zima moduli ya Mahudhurio ya Walimu (kipindi, kila siku, ripoti na yanayotarajiwa dhidi ya halisi). Ikiwa imezimwa, menyu hufichwa na API huzuiliwa.",
    teacherAttendanceEnabled: "Washa Mahudhurio ya Walimu",
    alertRequireTeacherAttendanceValidation:
      "Ikiwa imewashwa, alama za mahudhurio zinabaki zikisubiri hadi idhibitishwe na meneja. Ikiwa imezimwa (chaguo-msingi), alama ni za mwisho mara moja — njia zilizopo hazibadiliki.",
    requireTeacherAttendanceValidation:
      "Hitaji uthibitisho wa mahudhurio ya walimu/wafanyakazi (hierarkia)",
    etablissements: "Taasisi",
    classe: "Darasa",
    classes: "Madarasa",
    niveaux: "Viwango",
    ajouterNiveau: "Ongeza kiwango",
    createAllLevels: "Unda viwango vyote",
    niveauxHint:
      "Weka ada kwa kila kiwango. Madarasa ya kawaida hurithi ada za kiwango chao kiotomatiki.",
    levelRequiredFirst:
      "Kiwango hiki lazima kiundwe katika kichupo cha Viwango kabla ya kuongeza darasa.",
    niveauAffectation: "Kiwango (ugaaji)",
    elevesAffectes: "Wanafunzi waliogawiwa",
    salles: "Vyumba",
    services: "Huduma",
    activites: "Shughuli",
    typeQualification: "Aina za sifa",
    anneeScolaire: "Mwaka wa shule",
    logo: "Nembo",
    name: "Jina",
    nom: "Jina",
    designation: "Uongozi",
    legalName: "Jina la kisheria",
    headMaster: "Mkuu wa Shule",
    dateEnregistrement: "Tarehe ya usajili",
    createdAt: "Tarehe ya usajili",
    phone: "Simu",
    mainPhone: "Simu kuu",
    email: "Barua pepe",
    mainEmail: "Barua pepe kuu",
    additionalEmails: "Barua pepe za ziada",
    addEmail: "Ongeza barua pepe",
    additionalPhones: "Simu za ziada",
    addPhone: "Ongeza simu",
    kenyaPhoneRequirement: "Angalau namba za simu 2 za ziada zinahitajika",
    MF: "Nambari ya kodi",
    schoolNEMISNumber: "Nambari ya NEMIS ya Shule",
    adress: "Anwani",
    geoLat: "Latitudo (GPS)",
    geoLng: "Longitudo (GPS)",
    geoRadius: "Radiusi (mita)",
    geoHint:
      "Kuratibu za shule kwa kuingia kwa walimu (nje ya eneo ikiwa nje ya radiusi).",
    postalAddress: "Anwani ya posta",
    type: "Aina",
    niveau: "Kiwango",
    fraisInscri: "Ada ya usajili",
    fraisMensuel: "Ada ya kila mwezi",
    emploi: "Ratiba",
    dateCreation: "Tarehe ya kuunda",
    capacite: "Uwezo",
    fournisseurs: "Wasambazaji",
    fournisseur: "Msambazaji",
    fournisseurNonRequis: "Msambazaji (si lazima):",
    service: "Huduma",
    responsable: "Mhusika",
    responsableActivite: "Mhusika wa shughuli",
    ordrePriorite: "Mpangilio/kipaumbele",
    order: "Mpangilio",
    dateDebut: "Tarehe ya kuanza",
    dateFin: "Tarehe ya mwisho",
    seuleFois: "Mara moja tu",
    entrerInfo: "Ingiza maelezo katika sehemu zilizo hapa chini",
    modifierEmploi: "Hariri ratiba ya {name}",
    other: "Nyingine",
    editAlert:
      "Kubadilisha mwaka wa shule hakutasababisha mabadiliko kwenye miezi ya usajili wa wanafunzi waliosajiliwa tayari, una uhakika unabadilisha?",
    clickOrDragToUpload:
      "Bonyeza au buruta faili katika eneo hili ili kuipakia",
    clickForUploadLogo: "Bonyeza ili kubadilisha nembo",
    ecole: "Shule ya msingi",
    college: "Sekondari ya chini",
    lycee: "Sekondari ya juu",
    collegeEtLycee: "Sekondari ya chini na juu",
    primaireEtCollege: "Msingi na sekondari ya chini",
    jardinEnfant: "Chekechea",
    preSchool: "Kabla ya shule",
    prePrimary: "Msingi wa chini",
    middle: "Msingi wa juu",
    junior: "Sekondari ya chini",
    senior: "Sekondari ya juu",
    cache: "Muhuri",
    choisir: "Chagua",
    matriculeFiscale: "Nambari ya kodi",
    ArabicName: "Jina kwa Kiarabu",
    delegeRegional: "Mkuu wa mkoa",
    countyLocation: "Eneo la Nchi",
    slogan: "Kaulimbiu",
    nameRequired: "Jina linahitajika",
    arabicNameRequired: "Jina la Kiarabu linahitajika",
    legalNameRequired: "Jina la kisheria linahitajika",
    delegeRegionalRequired: "Mkuu wa mkoa anahitajika",
    countyLocationRequired: "Eneo la nchi linahitajika",
    headMasterRequired: "Mkuu wa Shule anahitajika",
    headMasterFrench: "Mkuu wa Shule kwa Kifaransa",
    headMasterGender: "Jinsia ya mkuu wa shule",
    additionalDirectors: "Wakurugenzi wa ziada",
    directorName: "Jina la mkurugenzi",
    addDirector: "Ongeza mkurugenzi",
    male: "Mwanaume",
    female: "Mwanamke",
    phoneRequired: "Simu inahitajika",
    showFeesParentPayment: "Onyesha ada za malipo kwa wazazi",
    showInvoicesParentPayment:
      "Onyesha historia ya malipo kwa wazazi (ankara/stakabadhi)",
    alertShowFeesParentPayment:
      "Ikiwa imewashwa, wazazi wataweza kuona ada za malipo kwenye programu ya simu",
    alertShowInvoicesParentPayment:
      "Ikiwa imewashwa, wazazi wataweza kuona ankara na stakabadhi za malipo kwenye programu ya simu",
    tranches: "Vipande",
    fraisMensuelle: "Ada ya kila mwezi",
    addTranche: "Ongeza kipande",
    tranche: "Kipande",
    verifierTranches: "Tafuta kwa kipande",
    RIB: "RIB",
    fraisParJour: "Ada kwa siku",
    typeActivite: "Aina ya shughuli",
    nameActivite: "Izina ry'igikorwa",
    parJour: "Kwa siku",
    mensuelleParTranche: "Kila mwezi/kwa kipande",
    rib20Digits: "RIB lazima iwe na nambari 20 hasa",
    establishmentCode:  "Nambari ya uanzishaji",
  },
  comptabilite: {
    comptabilite: "Uhasibu",
    fournisseur: "Msambazaji",
    typeDepense: "Aina ya matumizi",
    tabDepenseTypes: "Aina za matumizi",
    tabDepenseCategories: "Jamii",
    tabDepenseSubcategories: "Jamii ndogo",
    tabAssociates: "Washirika",
    tabUnites: "Vitengo",
    tabCompanies: "Makampuni",
    companyLegalName: "Jina la kampuni",
    companyCode: "Msimbo",
    companyArchiveConfirm: "Una uhakika unataka kuhifadhi kampuni hii?",
    companyArchived: "Kampuni imehifadhiwa",
    tabDebiteurs: "Wadaiwa",
    tabDocumentDisplay: "Onyesho la risiti / ankara",
    documentDisplayIntro:
      "Sanidi jinsi risiti na ankara zinavyoonyeshwa kwa shule hii. Chaguo zisizosanidiwa zinabaki na tabia chaguo-msingi.",
    documentDisplayHeader: "Kichwa",
    documentDisplayFooter: "Chini ya ukurasa",
    documentDisplayPayment: "Malipo na punguzo",
    documentDisplayPrint: "Chapisha",
    documentDisplayPreview: "Hakiki",
    previewDocument: "Hakiki",
    previewHint: "Bofya Hakiki kuona matokeo kwa chaguo za sasa (zisizohifadhiwa).",
    showLogo: "Onyesha nembo",
    titleMode: "Jina la shule",
    titleModeDefault: "Jina chaguo-msingi",
    titleModeCustom: "Jina maalum",
    customTitle: "Jina maalum",
    includeSchoolTypeInTitle: "Jumuisha aina ya shule kwenye jina",
    showClass: "Onyesha darasa",
    showFooterText: "Onyesha maandishi maalum chini",
    footerText: "Maandishi maalum",
    showCachetSignatureLabel:
      "Onyesha lebo ya muhuri na saini (inafichwa picha ya muhuri ikionekana)",
    showStamp: "Onyesha picha ya muhuri",
    stampScale: "Ukubwa wa muhuri",
    stampScaleHint:
      "Rekebisha ukubwa wa picha ya muhuri kwenye PDF (0.5x hadi 2.5x).",
    showSignature: "Onyesha eneo la saini",
    showTuitionSummary: "Onyesha muhtasari wa malipo ya karo",
    showActivitySummary: "Onyesha muhtasari wa malipo ya shughuli",
    paymentSummaryHint:
      "Jumla ya kulipa, miezi / awamu zilizolipwa (debit) na zisizolipwa (credit) za mwaka wa shule.",
    showTableNote: "Onyesha maandishi maalum chini ya majedwali",
    tableNoteHint:
      "Huchapishwa kama yalivyoandikwa kwenye nafasi tupu chini ya majedwali ya malipo / muhtasari (si kwenye kijachini).",
    tableNoteText: "Maandishi maalum",
    tableNoteColor: "Rangi ya maandishi",
    tableNoteFontSize: "Ukubwa wa maandishi",
    tableNoteAlign: "Mahali pa maandishi",
    tableNoteAlignAuto: "Otomatiki (kulingana na lugha)",
    tableNoteAlignLeft: "Kushoto",
    tableNoteAlignCenter: "Katikati",
    tableNoteAlignRight: "Kulia",
    showPaymentMethodDetails: "Onyesha maelezo ya njia za malipo",
    showOnTransReduction: "Onyesha punguzo kwenye jumla",
    baseReductionDisplay: "Onyesho la punguzo la msingi",
    baseReductionHidden: "Usionyeshe",
    baseReductionTotal: "Onyesha jumla ya punguzo",
    baseReductionPercentPerLine: "Onyesha % kwa kila kipengele",
    copiesPerPage: "Muundo wa uchapishaji",
    copiesPerPage1: "Risiti / ankara 1 kwa ukurasa (wima)",
    copiesPerPage2:
      "Nakala 2 kwenye ukurasa wa mlalo (hati ile ile kushoto na kulia)",
    autoPrint: "Chapisha risiti kiotomatiki baada ya malipo",
    documentDisplayFiscal: "Kodi (ankara)",
    tvaApplicable: "VAT inatumika",
    showTva: "Onyesha VAT kwenye ankara",
    tvaRate: "Kiwango cha VAT (sehemu)",
    tvaRateHint:
      "Mfano: 0.07 kwa 7%. Acha tupu kutumia chaguo-msingi la mazingira.",
    timbreApplicable: "Muhuri wa kodi unatumika",
    showTimbre: "Onyesha muhuri kwenye ankara",
    timbreAmount: "Kiasi cha muhuri wa kodi",
    timbreAmountHint: "Acha tupu kutumia chaguo-msingi la mazingira.",
    retenueApplicable: "Kodi ya kukata kwenye chanzo inatumika",
    showRetenue: "Onyesha kodi ya kukata kwenye ankara",
    retenuePercent: "Kodi ya kukata kwenye chanzo (%)",
    retenuePercentHint:
      "Asilimia ya TTC (mantiki sawa na kodi ya kukata ya muuzaji).",
    documentNumbering: "Upangaji nambari wa hati",
    numberFormatCustom: "Muundo maalum",
    numberFormatCustomHint:
      "Imezimwa = muundo wa sasa (YYYYMM + tarakimu 3). Imewashwa = kiambishi / tarehe / mfuatano unaoweza kusanidiwa, tofauti kwa risiti na ankara.",
    numberFormatPrefix: "Kiambishi awali",
    numberFormatDatePattern: "Muundo wa tarehe",
    numberFormatDateNone: "Bila tarehe",
    numberFormatSeparator: "Kitenganishi",
    numberFormatPadding: "Tarakimu za mfuatano",
    numberFormatPattern: "Muundo huru (si lazima)",
    numberFormatPatternHint:
      "Alama: {PREFIX} {YYYY} {YY} {MM} {DD} {YYYYMM} {SEQ}. Mfano: FACT-{YYYY}-{SEQ}.",
    numberFormatExample: "Nambari zifuatazo: {example}",
    numberFormatStartNumber: "Nambari ya kuanzia",
    numberFormatStartNumberHint:
      "Endeleza nambari zilizopo (mfano: ankara ya mwisho FACT-2026-000598 → weka 599). Muundo na sifuri za mbele huhifadhiwa. Ikiwa hati tayari zipo baada ya nambari hii, mfuatano huendelea baada ya ya mwisho, bila marudio.",
    numberFormatTabReceipt:
      "Upangaji nambari wa RISITI pekee. Nenda kwenye kichupo cha Ankara kusanidi ankara.",
    numberFormatTabInvoice:
      "Upangaji nambari wa ANKARA pekee. Nenda kwenye kichupo cha Risiti kusanidi risiti.",
    numberFormatSeparatorHint:
      "Inatumika tu ikiwa muundo huru uko tupu. Acha tupu kuunganisha kiambishi+tarehe+mfuatano.",
    numberFormatPatternPlaceholder:
      "Tupu = tumia kiambishi / tarehe / kitenganishi hapo juu",
    numberFormatPresetParts: "Tumia kiambishi + tarehe",
    numberFormatPresetYyyy: "Tumia {PREFIX}-{YYYY}-{SEQ}",
    numberFormatPresetYyyymm: "Tumia {PREFIX}-{YYYYMM}-{SEQ}",
    numberFormatSeqRequired:
      "Muundo lazima uwe na {SEQ} ili kila hati iwe na nambari ya kipekee. Itaongezwa kiotomatiki unapohifadhi.",
    numberFormatUnsafeChars:
      "Herufi / \\ : * ? \" < > | haziwezi kuwa katika jina la faili la PDF: zitabadilishwa kuwa \"-\".",
    reference: "Kumbukumbu",
    expenseKind: "Aina",
    expenseKindOpex: "OPEX",
    expenseKindCapex: "CAPEX (upungufu wa thamani)",
    expenseKindOther: "Nyingine",
    capexFormula: "Fomula ya upungufu wa thamani",
    description: "Maelezo",
    category: "Jamii",
    categoryDeactivatedCascade:
      "Jamii imehifadhiwa. Jamii ndogo {subcategories} zinazohusiana pia ziliwekwa hali isiyotumika.",
    categoryDeactivateConfirm:
      "Una uhakika unataka kuhifadhi jamii hii? Jamii ndogo zote zinazotumika chini yake pia zitawekwa hali isiyotumika.",
    subcategory: "Jamii ndogo",
    parentSubcategory: "Jamii ndogo ya ziada",
    direction: "Mwelekeo",
    directionNormal: "Kawaida",
    directionInverse: "Kinyume",
    visibility: "Uonekano",
    visibilityHint: "Watu au majukumu husika (maandishi huru)",
    associateType: "Aina ya mshirika",
    associateInternal: "Ndani",
    associateExternal: "Nje",
    fullName: "Jina kamili",
    unitKind: "Aina ya kitengo",
    unitPrincipal: "Msingi",
    unitSecondary: "Sekondari",
    companyName: "Jina la kampuni",
    debtorName: "Jina la mdaiwa",
    depenseTypeDeactivatedCascade:
      "Aina ya matumizi imehifadhiwa. Jamii {categories} na jamii ndogo {subcategories} pia ziliwekwa hali isiyotumika.",
    depenseTypeDeactivateConfirm:
      "Una uhakika unataka kuhifadhi aina hii ya matumizi? Jamii zote zinazotumika na jamii ndogo zake chini yake pia zitawekwa hali isiyotumika.",
    deleteAllowed: "Futa",
    optional: "(hiari)",
    typeRecette: "Aina ya mapato",
    nom: "Jina",
    adresse: "Anwani",
    telephone: "Simu",
    email: "Barua pepe",
    codeTVA: "Msimbo wa VAT",
    depenseParametrageNotice:
      "Tumia Futa ili kuhifadhi kipengele (hali isiyotumika). Kinatoka kwenye orodha; data inahifadhiwa kwa ufuatiliaji.",
    noDeleteHint:
      "Futa huhifadhi safu (haiitumiki); haionekani tena kwenye orodha hii.",
    planComptable: "Mpango wa hesabu",
    accountingClass: "Akaunti",
    accountingParentClass: "Akaunti mzazi",
    accountingClassReference: "Akaunti (Rejea)",
    accountingClassPlaceholder: "Chagua akaunti…",
    accountingClassHint:
      "Si lazima. Chagua akaunti kutoka mpango wa hesabu wa (mfano 60 – Manunuzi).",
    accountingClassChildHint:
      "Akaunti ya mwisho hutengenezwa kiotomatiki kutoka akaunti mzazi.",
    accountingClassParentMissing:
      "Kitengo mzazi hakina akaunti bado. Iweka kwanza ili akaunti ya mtoto itengenezwe kiotomatiki.",
    accountingClassParentMissingShort: "Chagua akaunti mzazi kwanza.",
    accountingClassChangeBlocked:
      "Huwezi kubadilisha akaunti: vitengo vya watoto tayari vina akaunti zilizotengenezwa. Virekebishe kwanza.",
    accountingClassAutoGenerated: "Imetengenezwa kiotomatiki",
    accountingClassAutoGeneratedHint:
      "Msimbo wa mtoto hupewa wakati wa kuunda kutoka akaunti ya kitengo.",
    accountingClassNotAssigned: "Hakuna akaunti",
    serviceClassMissing:
      "Huduma kuu bado haina akaunti. Iweke kwanza ili kuzalisha akaunti kiotomatiki.",
    accountingClassAssign: "Pangia akaunti",
    subCategory: "Kitengo kidogo",
  },
  decaissement: {
    expenseMode: "Aina ya matumizi",
    normal: "Kawaida",
    declaree: "Yaliyotangazwa",
    beneficiaryType: "Aina ya mnufaika",
    beneficiaryName: "Jina la mnufaika",
    companyEntity: "Kampuni ya kikundi",
    amortizationEmpty:
      "Hakuna ankara za muuzaji zenye upungufu wa thamani wa CAPEX kwa mwaka huu wa shule.",
    amortizationFilterCategories: "Jamii za CAPEX",
    amortizationFilterCategoriesPlaceholder: "Jamii zote za CAPEX",
    amortizationFullyAmortizedCount: "Mali zilizopunguzwa thamani kabisa",
    amortizationKpiRemaining: "Thamani gani bado ipo?",
    amortizationKpiThisMonth: "Upungufu wa thamani wa mwezi huu?",
    amortizationStatusActive: "Inaendelea",
    amortizationStatusComplete: "Imepunguzwa kabisa",
    amortizationTab: "Upungufu wa thamani",
    amortizationTableCost: "Msingi wa gharama",
    amortizationTableRemaining: "Thamani iliyobaki",
    amortizationTableThisMonth: "Mwezi huu",
    amortizationTableStatus: "Hali",
    capexAmountColumn: "Kiasi",
    capexDepreciationPeriodMonths: "Muda wa upungufu wa thamani (miezi)",
    capexInvoiceDate: "Tarehe ya ankara (kwa upungufu wa thamani)",
    capexJulyJuneHint:
      "Upungufu wa thamani huhesabiwa kwa vipindi vya mwaka wa shule (Julai hadi Juni).",
    capexMonthsColumn: "Miezi",
    capexSchedulePreview: "Ratiba ya upungufu wa thamani (hakiki)",
    capexSchoolYearColumn: "Mwaka wa shule",
    capexSectionTitle: "Upungufu wa thamani wa CAPEX",
    capexCompleteAmountsFirst:
      "Weka kwanza kiasi cha ankara (HT, VAT, TTC); upungufu wa thamani unaonekana baada ya kuhesabiwa kwa jumla inayolipwa.",
    invoiceNumber: "Nambari ya ankara",
    invoiceDate: "Tarehe ya ankara",
    invoiceDateNotInFuture: "Tarehe ya ankara haiwezi kuwa ya baadaye.",
    depenseCreatedAt: "Tarehe ya kuundwa",
    entryDateNotInFuture: "Tarehe ya kuingiza haiwezi kuwa ya baadaye.",
    description: "Maelezo",
    amountTTC: "Kiasi cha TTC",
    amountTVA: "Kiasi cha TVA",
    amountAfterRetention: "Kiasi baada ya makato",
    applyRetention: "Tumia makato",
    attachment: "Kiambatisho",
    paymentManagement: "Usimamizi wa malipo",
    planPayment: "Panga malipo",
    payNow: "Lipa sasa",
    totalToPay: "Jumla ya kulipa",
    addSchedule: "Ongeza ratiba",
    fundSource: "Chanzo cha fedha",
    myCaisse: "Sanduku langu",
    otherCaisse: "Sanduku lingine",
    caisseBank: "Sanduku la benki",
    cashName: "Jina la sanduku",
    availableForThisPayment: "Kiasi kinachopatikana kwa njia hii ya malipo",
    caisseBalanceExceedsAvailWarning:
      "Kiasi hiki kinazidi salio kinachopatikana kwa akaunti iliyochaguliwa (kwa njia hii ya malipo).",
    receiptNumber: "Namba ya risiti (souche)",
    methodReference: "Rejeo la mbinu",
    paymentSaved: "Malipo yamehifadhiwa kwa mafanikio",
    missingRequiredFields: "Tafadhali jaza sehemu zote zinazohitajika",
    activityOrServiceRequired: "Chagua shughuli au huduma",
    formSectionGeneral: "Taarifa za jumla",
    formSectionDetails: "Maelezo ya gharama",
    formSectionAttachments: "Nyaraka za uthibitisho na maelezo",
    formSectionPayment: "Malipo au ratiba ya malipo",
    formSectionPaymentHint:
      "Chagua malipo ya papo hapo au ongeza angalau malipo moja ya awamu. Kwa gharama zilizotangazwa za mshirika/mfanyakazi, jumla ya awamu lazima ilingane na kiasi.",
    paymentTotalInvalid:
      "Ingiza kiasi halali cha gharama hapo juu kabla ya njia ya malipo.",
    validation: {
      expenseModeRequired: "Aina ya gharama inahitajika",
      invoiceDateRequired: "Tarehe ya ankara inahitajika",
      entryDateRequired: "Tarehe ya kuingiza inahitajika",
      subCategoryRequired: "Kategoria ndogo inahitajika",
      amountRequired: "Kiasi kinahitajika",
      amountMustBePositive: "Kiasi lazima kiwe zaidi ya sifuri",
      beneficiaryTypeRequired: "Aina ya mnufaika inahitajika",
      beneficiaryRequired: "Mnufaika anahitajika",
      invoiceNumberRequired: "Nambari ya ankara inahitajika",
      amountHTRequired: "Kiasi bila kodi kinahitajika",
      amountHTMustBePositive: "Kiasi bila kodi lazima kiwe zaidi ya sifuri",
      amountTTCRequired: "Kiasi pamoja na kodi kinahitajika",
      amountTTCMustBePositive: "Kiasi pamoja na kodi lazima kiwe zaidi ya sifuri",
      amountTVARequired: "Kiasi cha kodi kinahitajika",
      capexPeriodRequired: "Muda wa kupunguza thamani (miezi) unahitajika",
      capexInvoiceDateRequired: "Tarehe ya ankara ya mali imara inahitajika",
      paymentCaisseRequired: "Chagua sanduku la fedha kwa mstari wa malipo {n}",
      paymentBankRequired: "Chagua akaunti ya benki/sanduku kwa mstari wa malipo {n}",
      scheduleDateRequired: "Tarehe ya awamu {n} inahitajika",
      scheduleAmountRequired: "Kiasi cha awamu {n} lazima kiwe zaidi ya sifuri",
      selectCaisse: "Chagua sanduku la fedha",
      selectCaisseBank: "Chagua akaunti ya benki/sanduku",
      checkHighlightedFields: "Angalia sehemu zilizowekwa alama katika fomu.",
    },
    duplicateInvoiceTitle: "Ankara rudufu",
    viewExistingInvoice: "Angalia ankara iliyopo",
    invoiceNotFoundForRedirect: "Ankara iliyopo haikupatikana.",
    schedulesMustMatchInvoice:
      "Jumla ya malipo ya awamu lazima iwe sawa na jumla ya gharama (sawa na kiasi cha ankara).",
    formSubsectionBeneficiary: "Mnufaika",
    formSubsectionProvider: "Maelezo ya muuzaji",
    formSubsectionAmount: "Maelezo ya kiasi",
    activityPercent: "Sehemu (%)",
    activityPercentTotal: "Jumla iliyogawanywa",
    activityPercentSumMustBe100:
      "Asilimia za shughuli lazima ziwe jumla ya 100%.",
    activityDuplicate: "Shughuli moja haiwezi kurudiwa mara mbili.",
    addActivityAllocation: "Ongeza shughuli nyingine",
    activitySingleFullAmount: "100% ya gharama imepewa shughuli hii.",
    activityAllocations: "Shughuli (mgawanyo)",
    classRoom: "Masomo (darasa)",
    classRoomAllocations: "Masomo (mgawanyo)",
    levels: "Viwango",
    activityPlaceholder: "Chagua shughuli (si lazima)",
    classRoomPlaceholder: "Chagua darasa (si lazima)",
    addClassRoomAllocation: "Ongeza darasa",
    classRoomPercentTotal: "Jumla iliyogawanywa (madarasa)",
    classRoomPercentSumMustBe100: "Asilimia za madarasa lazima ziwe 100%.",
    classRoomDuplicate: "Kila darasa linaweza kuonekana mara moja tu.",
    classRoomSingleFullAmount: "100% ya gharama imepewa darasa hili.",
    combinedAllocationPercentTotal: "Jumla ya Masomo + Shughuli",
    combinedAllocationPercentSumMustBe100:
      "Asilimia za Masomo na Shughuli lazima ziwe jumla ya 100%.",
    combinedAllocationSingleHint: "100% imepewa kipengele hiki.",
    paymentMethod: {
      cash: "Pesa taslimu",
      cheque: "Hundi",
      virement: "Hamisho",
      prelevement: "Makato ya moja kwa moja",
      traite: "Drafti",
      tpe: "TPE",
      mixed: "Malipo mchanganyiko",
    },
    directionInverse: "Kinyume",
    directionInverseHint:
      "Aina hii ni ya kinyume: shule inatoa mkopo na mnufaika atalipa baadaye. Malipo ya papo hapo pekee yanapatikana.",
    repaymentSchedule: "Ratiba ya malipo ya kurudisha",
    repaymentScheduleHint:
      "Eleza lini mnufaika atarudisha kiasi kilichotolewa na shule.",
    methodDetailsSumError:
      "Jumla ya kiasi lazima ilingane na kiasi cha jumla cha malipo",
    chequeNum: "Nambari ya hundi",
    traiteNum: "Nambari ya drafti",
    chequeBank: "Benki",
    chequeTitulaire: "Mmiliki",
    traiteRib: "RIB",
    virementNum: "Nambari ya hamisho",
    addCheque: "Ongeza hundi",
    addTraite: "Ongeza drafti",
    addVirement: "Ongeza hamisho",
    placeholderChequeNum: "Nambari",
    placeholderTraiteNum: "Nambari",
    placeholderDueDate: "TT/MM/MMMM",
    placeholderBank: "Benki",
    placeholderTitulaire: "Mmiliki",
    placeholderRib: "Tarakimu 20",
    placeholderAmount: "0.000",
    placeholderVirementRef: "Kumbukumbu",
    legendDebtRow: "Deni",
    legendDebtRowHint: "Mistari yenye mandhari hii zinahusiana na deni.",
  },
  fournisseur: {
    title: "Wauzaji",
    companyName: "Jina la kampuni",
    codeTVA: "Nambari ya VAT",
    retenue: "Kizuizi kilichotumika",
    website: "Tovuti",
    category: "Kategoria",
    subCategory: "Kategoria ndogo",
    archiver: "Hifadhi kumbukumbu",
    archived: "Imehifadhiwa",
    active: "Hai",
    archivedNotice:
      "Muuzaji huyu amehifadhiwa na hawezi kuchaguliwa kwa gharama mpya.",
    confirmArchive: "Je, una uhakika unataka kuhifadhi muuzaji huyu?",
    invoiceHistory: "Historia ya ankara",
    creditNotesTitle: "Mkopo wa muuzaji (Avoir)",
    creditNotesEmpty: "Hakuna mkopo wa muuzaji kwa muuzaji huyu",
    schedulingStatus: "Upangaji",
    invoiceStatus: "Hali ya ankara",
    paid: "Imelipwa",
    partial: "Imelipwa kwa sehemu",
    unpaid: "Haijalipwa",
    scheduled: "Imepangwa",
    notScheduled: "Haijapangwa",
    addSchedule: "Ongeza mpango",
    editSchedule: "Hariri mpango",
    deleteSchedule: "Futa mpango",
    confirmDeleteSchedule: "Je, una uhakika unataka kufuta mpango huu?",
    scheduleExceedsRemaining: "Jumla iliyopangwa inazidi kiasi kilichobaki",
    cannotEditPaidSchedule:
      "Mipango iliyolipwa au iliyofutwa haiwezi kubadilishwa",
    dueDate: "Tarehe ya ukomo",
    scheduledAmount: "Kiasi kilichopangwa",
    totalAmount: "Kiasi cha jumla",
    totalPaid: "Jumla iliyolipwa",
    remaining: "Iliyobaki",
    invoiceSummary: "Muhtasari wa ankara",
    noSchedules: "Hakuna mipango kwa ankara hii",
    scheduleCreated: "Mpango umeundwa kwa mafanikio",
    scheduleUpdated: "Mpango umesasishwa kwa mafanikio",
    scheduleDeleted: "Mpango umefutwa kwa mafanikio",
    schedulesDisabledInvoicePaid:
      "Huwezi kuongeza ratiba za malipo wakati hali ya ankara ni «imelipwa».",
    supplierArchived: "Muuzaji amehifadhiwa kwa mafanikio",
    allSuppliers: "Wauzaji wote",
    showArchived: "Onyesha waliohifadhiwa",
    searchPlaceholder: "Tafuta kwa jina, nambari ya VAT...",
    totalInvoices: "Jumla ya ankara",
    totalRemaining: "Jumla iliyobaki",
    contactInfo: "Taarifa za mawasiliano",
    businessInfo: "Taarifa za biashara",
    financialOverview: "Muhtasari wa fedha",
    paymentBreakdown: "Mgawanyo wa malipo",
    paymentProgress: "Maendeleo ya malipo",
    scheduleProgress: "Maendeleo ya mipango",
    scheduleDueToday: "tarehe inayofuata ni leo",
    scheduleDueInDays: "tarehe inayofuata ndani ya siku {n}",
    scheduleDueInMonths: "tarehe inayofuata ndani ya miezi {n}",
    scheduleOverdueByDays: "imechelewa kwa siku {n}",
    noData: "Hakuna data",
  },
  factures: {
    title: "Ankara",
    filtersTitle: "Vichujio",
    searchPlaceholder: "Tafuta lebo, rejea, nambari ya ankara, maelezo…",
    filterInvoiceStatus: "Hali ya malipo",
    filterSchedulingStatus: "Mipango",
    filterBeneficiaryType: "Aina ya mnufaika",
    filterExpenseMode: "Aina ya gharama",
    filterProvider: "Mtoa huduma",
    filterDateRange: "Tarehe ya ankara",
    resetFilters: "Futa vichujio",
    detailTitle: "Maelezo ya ankara",
    reference: "Rejea",
    manageSchedules: "Malipo ya awamu",
    goToPaymentEntry: "Kuingiza malipo",
    viewSupplier: "Wasifu wa mtoa huduma",
    attachments: "Viambatisho",
    attachmentCount: "faili {n}",
    noAttachments: "Hakuna viambatisho",
    beneficiaryProvider: "Mtoa huduma",
    beneficiaryAssociate: "Mshirika",
    beneficiaryEmployee: "Mfanyakazi",
    beneficiaryCompany: "Kampuni ya kikundi",
    beneficiaryDebiteur: "Mdaiwa",
    tableLabel: "Lebo",
    paginationTotal: "ankara {total}",
    createNewDepense: "Gharama mpya",
    backToInvoiceList: "Rudi kwenye ankara",
  },
  saisiePaiement: {
    title: "Kuingiza malipo",
    pending: "Inasubiri",
    pendingSchedules: "Mipango inayosubiri",
    unplannedExpenses: "Gharama zisizopangwa",
    paySelected: "Lipa zilizochaguliwa",
    groupPayment: "Malipo ya pamoja",
    duplicateSchedule: "Nakili mpango",
    paymentExecuted: "Malipo yamefanywa kwa mafanikio",
    selectAtLeastOne: "Chagua mpango mmoja angalau",
    beneficiary: "Mnufaika",
    invoiceRef: "Rejea ya ankara",
    dueDate: "Tarehe ya ukomo",
    amount: "Kiasi",
    selectFundSource: "Chagua chanzo cha fedha",
    selectMethod: "Chagua njia ya malipo",
    confirmPayment: "Thibitisha malipo",
    totalSelected: "Jumla iliyochaguliwa",
    addScheduleFromHere: "Ongeza mpango",
    noUnplannedExpenses: "Hakuna gharama zisizopangwa",
    noPendingSchedules: "Hakuna mipango inayosubiri",
    filterBeneficiaryType: "Aina ya mnufaika",
    filterExpenseMode: "Aina ya gharama",
    filterDueDateRange: "Kipindi cha tarehe ya malipo",
    expenseLabel: "Gharama",
    expenseMode: "Aina",
    splitPaymentsHint:
      "Ongeza mstari kwa kila njia. Fedha taslimu hutumia sanduku kuu tu; hundi, hamisho, drafti na TPE hutumia akaunti ya benki. Jumla lazima ilingane na jumla.",
    tableSearch: "Tafuta",
    tableSearchPlaceholder:
      "Gharama, mnufaika, rejeo la ankara, aina ya mnufaika, hali au kiasi…",
    paymentLine: "Mstari wa malipo {n}",
    addPaymentLine: "Ongeza mstari wa malipo",
    removePaymentLine: "Ondoa mstari huu",
    splitsTotal: "Jumla iliyogawanywa",
    splitsSumMismatch: "Jumla iliyogawanywa lazima iwe sawa na iliyochaguliwa",
    lineAmountRequired: "Kila mstari lazima uwe na kiasi chanya",
    manageSchedules: "Simamia malipo ya ratiba",
    cannotLoadDepenseForSchedules:
      "Haiwezekani kufungua kihariri cha ratiba (data ya gharama haipo).",
    drawerDepenseSchedulesTitle: "Gharama na ratiba za malipo",
    depenseDetailsSection: "Maelezo ya ankara / gharama",
    schedulesEditHint:
      "Hariri malipo yanayosubiri, ongeza mistari, au ufute. Jumla iliyopangwa haipaswi kuzidi jumla ya gharama.",
    clickedScheduleBadge: "Kutoka orodha",
    batchPendingTotal: "Jumla ya malipo yanayosubiri",
    batchRequiredRemaining:
      "Inayohitajika (jumla ya ankara kasoro kilicholipwa)",
    batchSchedulesEmptyHint:
      "Ongeza mistari. Jumla lazima ilingane na kiasi kinachohitajika kabla ya kuhifadhi.",
    unsavedSchedulesHint: "Hifadhi au ghairi kuchagua malipo ya ratiba.",
    batchSchedulesSaved: "Mpango wa malipo umehifadhiwa.",
    selectToPaySection: "Lipa sasa (chagua malipo ya ratiba)",
  },
  paiementHistory: {
    title: "Historia ya malipo",
    paymentDetail: "Maelezo ya malipo",
    date: "Tarehe",
    paymentMode: "Aina ya malipo",
    immediate: "Papo hapo",
    scheduled: "Imepangwa",
    status: "Hali",
    validationStatus: "Hali ya uthibitisho",
    method: "Njia",
    fundSource: "Chanzo",
    createdBy: "Imeundwa na",
    rejectedBy: "Imekataliwa na",
    rejectedAt: "Imekataliwa tarehe",
    validatedBy: "Imethibitishwa na",
    validatedAt: "Imethibitishwa tarehe",
    rejectionReasonMissing: "Hakuna sababu ya kukataa iliyorekodiwa",
    searchReceipt: "Tafuta kwa nambari ya risiti",
    dateRange: "Kipindi",
    noPayments: "Hakuna malipo yaliyopatikana",
    relatedInvoices: "Ankara zinazohusiana",
    schedules: "Ratiba zinazohusiana",
    schedulesThisPayment: "Malipo ya ratiba yanayofunikwa na malipo haya",
    otherSchedules: "Ratiba nyingine",
    otherSchedulesHint:
      "Malipo mengine ya ratiba kwa gharama hizo hizo (yanayosubiri au yamelipwa tofauti).",
    debtLabel: "Jina la deni",
    debtRepaymentStatus: "Malipo ya deni",
    debtRemainingInstallments: "Malipo yanayosalia ya deni hili",
    debtNoRemainingInstallments:
      "Hakuna malipo yanayosubiri kwa deni hili (yote yamelipwa au hakuna ratiba).",
    expenseOrInvoice: "Gharama / ref.",
    statuses: {
      completed: "Imekamilika",
      pending: "Inasubiri",
      cancelled: "Imeghairiwa",
      awaiting_validation: "Inasubiri uthibitishaji",
    },
    validationStatuses: {
      pending_validation: "Inasubiri",
      validated: "Imethibitishwa",
      rejected: "Imekataliwa",
    },
  },
  encaissementValidation: {
    title: "Uthibitishaji wa mapokezi (kinyume)",
    detailTitle: "Maelezo ya ratiba ya kinyume",
    searchPayeur: "Tafuta kwa mlipaji / lebo",
    filterBenType: "Aina ya mnufaika",
    filterDateRange: "Kipindi cha tarehe ya malipo",
    colPayeur: "Mlipaji",
    colLibelle: "Lebo",
    colMontant: "Kiasi",
    colDueDate: "Tarehe ya malipo",
    colCreatedBy: "Imeundwa na",
    colDepensePaymentStatus: "Hali ya malipo ya kutoka",
    colStatut: "Hali",
    statusPending: "Inasubiri",
    statusReceived: "Imepokelewa",
    statusCancelled: "Imeghairiwa",
    confirm: "Thibitisha",
    confirmDisabledHint:
      "Malipo ya kutoka lazima yathibitishwe katika upatanisho kabla ya kuthibitisha kupokea.",
    outboundPaymentNone: "Hakuna malipo ya kutoka",
    confirmTitle: "Thibitisha kupokea malipo",
    paymentMethod: "Njia ya malipo",
    fundDestination: "Mahali pa fedha",
    receivedBy: "Imepokelewa na",
    receivedAt: "Tarehe ya kupokea",
    noSchedules: "Hakuna ratiba za kinyume zilizopatikana",
    depenseInfo: "Taarifa za gharama",
    paymentInfo: "Maelezo ya malipo yaliyopokelewa",
    otherSchedules: "Ratiba nyingine kwa gharama hii",
    repaymentSchedules: "Ratiba za malipo ya kurudisha (kinyume)",
    repaymentComplete: "Malipo ya kurudisha yamekamilika",
    scheduleTotal: "Kiasi cha ratiba cha kupokea",
    splitPaymentsHint:
      "Ongeza mstari kwa kila njia ya malipo. Jumla ya kiasi lazima ilingane na jumla ya ratiba. Kila mstari unaweza kuwa na sanduku au akaunti ya benki tofauti.",
    paymentLine: "Mstari wa malipo {n}",
    addPaymentLine: "Ongeza mstari wa malipo",
    removePaymentLine: "Ondoa mstari huu",
    splitsTotal: "Jumla iliyogawanywa",
    splitsSumMismatch:
      "Jumla iliyogawanywa lazima iwe sawa na kiasi cha ratiba",
    lineAmountRequired: "Kila mstari lazima uwe na kiasi chanya",
    pendingInverseSchedules: "Ratiba zinazosubiri",
    editRepaymentSchedulesSection: "Ratiba za malipo ya kurudisha",
  },
  reconciliation: {
    title: "Upatanisho",
    pendingValidation: "Inasubiri uthibitisho",
    validated: "Imethibitishwa",
    rejected: "Imekataliwa",
    rejectionReason: "Sababu ya kukataa",
    rejectionReasonRequired: "Sababu ya kukataa inahitajika",
    paymentValidated: "Malipo yamethibitishwa kwa mafanikio",
    paymentRejected: "Malipo yamekataliwa kwa mafanikio",
    validatePayment: "Thibitisha",
    rejectPayment: "Kataa",
    confirmValidation: "Je, una uhakika unataka kuthibitisha malipo haya?",
    createdBy: "Imeundwa na",
    noPaymentsPending: "Hakuna malipo yanayosubiri uthibitisho",
    noPaymentsRejected: "Hakuna malipo yaliyokataliwa",
    noPaymentsValidated: "Hakuna malipo yaliyothibitishwa",
    noPaymentsFound: "Hakuna malipo yaliyopatikana",
    filterValidationStatus: "Hali ya uthibitisho",
    filterPendingValidation: "Inasubiri uthibitisho",
    filterValidatedOnly: "Yaliyothibitishwa tu",
    filterRejectedOnly: "Yaliyokataliwa tu",
    filterAllPayments: "Yote (inasubiri, imethibitishwa, imekataliwa)",
    colPaymentType: "Aina",
    colCaisseDebit: "Kutoa kwenye caisse",
    paymentTypeNormal: "Ya kutoka",
    paymentTypeInverse: "Kinyume",
    caisseDebitPending: "Wakati wa uthibitisho",
    caisseDebitAlreadyApplied: "Tayari imekatwa",
    validateModalTitle: "Thibitisha malipo",
    validateModalPaymentType: "Aina ya malipo",
    validateModalAmount: "Kiasi",
    validateModalInverseIntro:
      "Matumizi ya kinyume: kiasi kitakatwa kwenye caisse unapothibitisha.",
    validateModalInverseDebitList: "Maelezo ya makato yatakayotumika:",
    validateModalInverseAlreadyDebited:
      "Kiasi tayari kimekatwa kwenye caisse. Uthibitisho huu unathibitisha operesheni.",
    validateModalNormalIntro:
      "Malipo haya yalikatiwa kwenye caisse wakati ya kuingiza. Uthibitisho unathibitisha operesheni ya uhasibu.",
    splitLineSummary: "{method} — {amount} kutoka {caisse}",
  },
  avoir: {
    title: "Hati za mkopo",
    newCreditNote: "Hati mpya ya mkopo",
    pendingReception: "Inasubiri kupokewa",
    received: "Imepokelewa",
    cancelled: "Imefutwa",
    confirmReception: "Thibitisha kupokea",
    amountExceedsInvoice: "Kiasi kinazidi jumla ya ankara",
    creditNoteCreated: "Hati ya mkopo imeundwa kwa mafanikio",
    receptionConfirmed: "Kupokea kumethibitishwa kwa mafanikio",
    selectInvoice: "Chagua ankara",
    selectProvider: "Chagua muuzaji",
    receptionMethod: "Njia ya kupokea",
    noCreditNotes: "Hakuna hati za mkopo",
    depenseMissingForDetail:
      "Ankara iliyounganishwa haikuweza kupakiwa kwa maelezo.",
    invoiceAlreadyHasAvoir:
      "Ankara hii tayari ina hati ya mkopo. Hati moja ya mkopo kwa ankara inaruhusiwa tu.",
    invoiceNotFullyPaid:
      "Unaweza kuunda hati ya mkopo tu kwa ankara ambayo imelipwa kabisa.",
    detailDrawerTitle: "Maelezo ya hati ya mkopo",
    detailSectionCreditNote: "Hati ya mkopo",
    detailSectionReception: "Mapokeo",
    detailSectionOriginalInvoice: "Ankara ya asili ya muuzaji",
    detailSupplierLabel: "Muuzaji",
    detailSchoolYear: "Mwaka wa shule",
    receptionValidatedAt: "Tarehe ya mapokeo",
    receptionValidatedBy: "Mapokeo yamehifadhiwa na",
    totalReceived: "Jumla iliyopokelewa",
    transferDestinationCaisse: "Sanduku la lengo (baada ya uhamisho)",
    receptionSplitLines: "Mapokeo kwa njia ya malipo",
    splitDestination: "Lengo",
    detailPendingReception:
      "Hati hii ya mkopo inasubiri kupokelewa; njia za malipo zitaonekana baada ya uthibitisho.",
  },
  dette: {
    title: "Usimamizi wa ahadi",
    newDebt: "Deni jipya",
    credit: "Mkopo",
    engagement: "Ahadi",
    loan: "Mkopo wa nje",
    debtType: "Aina ya deni",
    beneficiary: "Mnufaika",
    beneficiaryType: "Aina ya mnufaika",
    associate: "Mshirika",
    debiteur: "Mdaiwa",
    installmentAmount: "Kiasi cha awamu",
    numberOfInstallments: "Idadi ya awamu",
    firstInstallmentDate: "Tarehe ya awamu ya kwanza",
    generateInstallments: "Tengeneza awamu",
    sumMismatch: "Jumla ya awamu lazima iwe sawa na kiasi cha jumla",
    debtCreated: "Deni limeundwa kwa mafanikio",
    depenseTemplate: "Kigezo cha gharama",
    installments: "Awamu",
    debtInfo: "Taarifa za deni",
    totalAmount: "Kiasi cha jumla",
    noDebts: "Hakuna madeni",
    debtDetail: "Maelezo ya deni",
    schedulePending: "Inasubiri",
    schedulePaid: "Imelipwa",
    scheduleCancelled: "Imeghairiwa",
    paidOn: "Ililipwa tarehe",
    noSchedulesDetail: "Hakuna awamu za malipo kwa deni hili.",
    nextPaymentEta: "Malipo yanayofuata",
    initialReceiptStep: "Mapokezi ya fedha",
    initialReceiptHint:
      "Weka jinsi kiasi kinavyoingia katika misanduku (fedha taslimu, hundi, benki). Jumla lazima iwe sawa na deni; mistari inaonekana katika historia ya kila sanduku.",
    initialReceiptDetail: "Mapokezi ya awali ya fedha",
    receivedAt: "Ilipokewa",
    receivedBy: "Ilipokewa na",
    encaissementLines: "Mistari ya malipo (mgawanyo)",
  },
  scolarite: {
    affichageParametrage: "Mipangilio ya kuonyesha",
    matieres: "Masomo",
    modules: "Moduli",
    modulesSpec: "Moduli maalum",
    nomModule: "Jina la moduli",
    affectationDansClasses: "Ugao katika madarasa",
    affectationEnseignants: "Ugao wa walimu",
    enseignants: "Walimu",
    typePunitions: "Aina za adhabu",
    typeStudentDiscipline: "Aina ya Nidhamu ya Mwanafunzi",
    nom: "Jina",
    customName: "Jina maalum",
    coefficient: "Mkazo",
    listeMatieres: "Orodha ya masomo",
    listeModules: "Orodha ya moduli",
    infoModule: "Gawa masomo kwenye moduli ili kuongoza usimamizi wa alama!",
    listeModulesSpec: "Orodha ya moduli maalum",
    infoModuleSpec:
      "Gawa masomo kwenye moduli maalum ili kuongoza usimamizi wa alama!",
    ajouterModule: "Ongeza moduli",
    ajouterMatiere: "Ongeza somo",
    affectes: "Zilogawiwa",
    nonAffectes: "Hazijagawiwa",
    recherche: "Tafuta",
    element: "Kipengele",
    aucunDonnee: "Hakuna data",
    modifierListeMatieres: "Hariri orodha ya masomo ya moduli: {name}",
    modifierListeEnseignants: "Hariri orodha ya walimu wa darasa: {name}",
    supprime: "Imefutwa",
    aucuneClasseTrouvee: "Hakuna darasa lililopatikana",
    charcherParClasse: "Tafuta kwa jina la darasa",
    deletedClasses: "Madarasa yamefutwa",
    activeClasses: "Madarasa yanayofanya kazi",
    afficherClassesSupprimees: "Onyesha madarasa yaliyofutwa",
    other: "Nyingine",
    confirmDeleteModule:
      "Vikao vyote vinavyohusiana na moduli hii vitafutwa. Moduli hii inatumika katika madarasa haya chini",
    certification: "Kuthibitisha",
    appreciation: "Kuthamini",
    modulesVerySpec: "Moduli za kipekee",
    subsubjects: "Masomo madogo",
    subsubject: "Somo dogo",
    ajouterSubsubject: "Ongeza somo dogo",
    addNewSubsubject: "Simamia masomo madogo",
    choisirSubsubject: "Chagua somo dogo",
    mark: "Alama ya juu zaidi",
    listeModulesVerySpec: "Orodha ya moduli za kipekee",
    infoModuleVerySpec:
      "Gawa masomo kwenye moduli za kipekee ili kuongoza usimamizi wa alama!",
    totalMarksMustBe20:
      "{subject}: Jumla ya alama za masomo madogo lazima iwe 20",
    adminAppreciation: "Kuthamini kwa msimamizi",
    subjectDejaExiste: "Somo tayari lipo",
    SubSubjectDejaExiste: "Somo dogo hili tayari lipo",
    cloneParam: "Nakili mipangilio",
    selectParamToClone: "Chagua mipangilio ya kunakili",
    duppModules: "Nakili moduli kutoka robo moja hadi nyingine",
    nombreElevesManquants: "Idadi ya wanafunzi wasiokuwa na alama",
    SubModuleDejaExiste: "Moduli ndogo hii tayari ipo",
    fromSchoolYear: "Mwaka wa shule chanzo",
    toSchoolYear: "Mwaka wa shule lengo",
    incompleteDataWarning:
      "Baadhi ya masomo yana usanidi usiokamilika. Thamani za kawaida zimetumika. Tafadhali hakikisha na uhifadhi ili kurekebisha.",
  },
  autorisation: {
    accueil: "nyumbani",
    admin: "Msimamizi",
    designation: "Uongozi",
    compteAdmin: "Akaunti ya msimamizi",
    dossierMedical: "Faili la kiafya",
    listeEleves: "Orodha ya wanafunzi",
    parametrage: "Mipangilio",
    activite: "Shughuli",
    administration: "Utawala",
    scolarite: "Masomo",
    personnel: "Mfanyakazi",
    personnels: "Wafanyakazi",
    comptabilite: "Uhasibu",
    declarations: "Matamshi",
    paiements: "Malipo",
    medicalNote: "Dokezo la kiafya",
    medicalNoteContext:
      "Wazazi wanaweza kuangalia na kubadilisha madokezo ya kiafya ya watoto wao.",
    noteForTeachers: "Madokezo ya kiafya kwa walimu",
    noteForTeachersContext:
      "Wazazi wanaweza kuangalia na kubadilisha madokezo ya watoto wao kwa walimu.",
    modifierFraisClasse: "Hariri ada za madarasa",
    modifierFraisClasseHint:
      "Inaruhusu kubadilisha ada za darasa la kawaida (vinginevyo hurithiwa kutoka kiwango).",
    decaissementLegacyAccess: "Malipo — idhini kamili (ya zamani)",
  },
  utilisateur: {
    listeUtilisateur: "Orodha ya watumiaji",
    nom: "Jina",
    role: "Jukumu",
    acces: "Ufikiaji wa taasisi",
    actif: "Hai",
    nonActif: "Si hai",
    mdp: "Nenosiri",
    activerDesactiver: "Washa/Zima",
    confirmerMdp: "Thibitisha nenosiri",
    changerMdp: "Unaweza kubadilisha nenosiri",
    active: "Imewashwa",
    nonActive: "Haijawashwa",
    desactiverAlert: "Unataka kumzima mtumiaji huyu?",
    activerAlert: "Unataka kumwasha mtumiaji huyu?",
    userDesactive: "Mtumiaji amezimwa!",
    userActive: "Mtumiaji amewashwa!",
    passwordAgain: "Tafadhali ingiza nenosiri tena",
    passwordMatch: "Maelezo hayafanani!",
    sessions: "Vipindi",
    sessionOnline: "Mtandaoni",
    sessionOffline: "Nje ya mtandao",
    viewSessions: "Tazama ({count})",
    activeSessionsFor: "Vipindi vinavyotumika — {user}",
    device: "Kifaa",
    unknownDevice: "Kifaa kisichojulikana",
    ipAddress: "Anwani ya IP",
    sessionSource: "Chanzo",
    lastActive: "Shughuli ya mwisho",
    expiresAt: "Inaisha",
    actions: "Vitendo",
    withActiveSessions: "Na vipindi",
    allUsersFilter: "Wote",
    restricted: "Imezuiwa",
    sessionScopeDenied:
      "Lazima uwe na ufikiaji wa taasisi zote za mtumiaji huyu.",
    revokeSession: "Batilisha",
    revokeSessionConfirm: "Batilisha kipindi hiki?",
    revokeSessionSuccess: "Kipindi kimebatilishwa.",
    revokeAllSessions: "Batilisha vipindi vyote",
    revokeAllSessionsConfirm:
      "Batilisha vipindi vyote na umtoe mtumiaji huyu mara moja?",
    revokeSessionsSuccess: "Vipindi vyote vya mtumiaji vimebatilishwa.",
    revokeSessionsError: "Imeshindikana kubatilisha vipindi vya mtumiaji.",
    loadSessionsError: "Imeshindikana kupakia vipindi vya mtumiaji.",
  },
  parentalControl: {
    changeUserName: "Badilisha jina la mtumiaji",
    disableAccount: "Zima akaunti ya mzazi",
    enableAccount: "Washa akaunti ya mzazi",
    parentQrCode: "Msimbo wa QR wa mzazi",
    accountActive: "Akaunti imewashwa, mtumiaji anaweza kufikia programu.",
    accountInactive: "Akaunti imezimwa, mtumiaji hawezi kufikia programu.",
  },
  liste: {
    searchStudent: "Tafuta mwanafunzi",
    searchBy: "Unaweza kutafuta kwa",
    listeElevesArchive: "Orodha ya wanafunzi waliohifadhiwa",
    reactive: "Washa tena",
    showSchoolLogo: "Onyesha nembo ya shule",
    showGovLogo: "Onyesha nembo ya wizara",
    reasonArchive: "Sababu ya kuhifadhi",
    addFiles: "Ongeza faili",
    studentPhoto: "Picha ya mwanafunzi",
    studentFiles: "Faili za mwanafunzi",
    consulterProfil: "Shauriana wasifu kwa maelezo zaidi",
    nomPrenom: "Jina la ukoo na la kwanza",
    fullName: "Jina kamili",
    photoMediaConsent: "Idhini ya picha na midia (mzazi)",
    photoMediaConsentFilterLabel:
      "Idhini ya picha na midia ya mwanafunzi (akaunti ya mzazi)",
    photoMediaConsentAll: "Wote",
    photoMediaConsentAccepted: "Imekubaliwa",
    photoMediaConsentRefused: "Imekataliwa",
    photoMediaConsentPending: "Haijajibiwa",
    scolarite: "Masomo",
    ficheParent: "Karatasi ya mzazi",
    attestation: "Cheti cha uhudhuria",
    inscription: "Usajili",
    supprimerAnnuler: "Futa / Ghairi",
    inscriSupprimer: "Sajili / Futa",
    filles: "Wasichana",
    garcons: "Wavulana",
    total: "Jumla",
    nonInscrits: "Hawajasajiliwa",
    inscrits: "Wamesajiliwa",
    parents: "Wazazi",
    pere: "Baba",
    mere: "Mama",
    guardian: "Mlezi",
    enfants: "Watoto",
    email: "Barua pepe",
    ajouterEleve: "Ongeza mwanafunzi",
    nouveauPaiement: "Malipo mapya",
    ajouterDossier: "Ongeza faili",
    ajouterPersonnel: "Ongeza mfanyakazi",
    ajouterEnseignant: "Ongeza mwalimu",
    listeEleves: "Orodha ya wanafunzi",
    administration: "Utawala",
    tranches: "Awamu",
    toutesTranches: "Awamu zote",
    nom: "Jina",
    prenom: "Jina la kwanza",
    notes: "Alama",
    dateNaissance: "Tarehe ya kuzaliwa",
    sexe: "Jinsia",
    adresse: "Anwani",
    telephone: "Simu",
    classes: "Madarasa",
    ajouterParent: "Ongeza mzazi mpya",
    ajouterParentSansEleveHint:
      "Unda mzazi bila kuongeza mwanafunzi. Unaweza kumfunganisha baadaye na mwanafunzi kutoka wasifu wake.",
    parentsExis: "Wazazi waliopo",
    ficheParents: "Karatasi ya wazazi",
    nomMere: "Jina la ukoo la mama",
    prenomMere: "Jina la kwanza la mama",
    emailMere: "Barua pepe ya mama",
    adresseMere: "Anwani ya mama",
    adressePere: "Anwani ya baba",
    prenomPere: "Jina la kwanza la baba",
    telMere: "Simu ya mama",
    nomPere: "Jina la ukoo la baba",
    emailPere: "Barua pepe ya baba",
    telPere: "Simu ya baba",
    metierPere: "Kazi ya baba",
    metierMere: "Kazi ya mama",
    cinPere: "Kitambulisho cha baba (CIN)",
    cinMere: "Kitambulisho cha mama (CIN)",
    cinGardian: "Kitambulisho cha mlezi (CIN)",
    gardianName: "Jina la ukoo la mlezi",
    gardianFirstName: "Jina la kwanza la mlezi",
    gardianAdress: "Anwani ya mlezi",
    gardianPhone: "Simu ya mlezi",
    gardianJob: "Kazi ya mlezi",
    adresseParents: "Anwani ya wazazi",
    emailParents: "Barua pepe ya wazazi",
    reduction: "Punguzo kwenye ada ya usajili",
    reductionMensuel: "Punguzo kwenye ada ya kila mwezi",
    identifiantUnique: "Kitambulisho cha kipekee",
    regionalEducation: "Tume ya Elimu ya Mkoa",
    recuEn: "Imepokelewa",
    nonInscrit: "HAJASAJILIWA",
    freresSoeurs: "Orodha ya ndugu",
    studentFullName: "Jina la mwanafunzi",
    brotherSister: "Kaka / Dada",
    brother: "Kaka",
    sister: "Dada",
    parentFullName: "Jina la mzazi",
    classe: "Darasa",
    siblingGroups: "vikundi vya familia",
    noSiblingGroups: "Hakuna vikundi vya ndugu vilivyopatikana",
    changementNonEffectue: "Hakuna mabadiliko",
    champsVides: "Sehemu za kuingiza haziwezi kuwa tupu",
    imprimerLoginsEnsg: "Miingio ya walimu",
    fichePersonnel: "Karatasi ya mfanyakazi",
    nombreEnfants: "Idadi ya watoto",
    situationFamiliale: "Hali ya kifedha",
    dateEntree: "Tarehe ya kuingia",
    etablissementPrecedent: "Taasisi ya awali",
    dateSortie: "Tarehe ya kutoka",
    motifSortie: "Sababu ya kutoka",
    documents: "Hati",
    motivation: "Mhamasiko",
    nombreInscriptions: "Idadi ya usajili",
    accompanyingDocuments: "Hati za ziada",
    secondarySchool: "Shule ya sekondari",
    previousInstitution: "Taasisi ya awali",
    behavior: "Tabia",
    attendance: "Mahudhurio",
    includePhoto: "Picha ya mwanafunzi",
    parentLogins: "Miingio ya wazazi",
    printSelectionMode: "Chapisha kwa",
    fraisTranches: "Ada kwa vipande",
    paymentMode: "Njia ya malipo iliyochaguliwa ni",
    tranches: "kwa vipande",
    mensuelle: "ya kila mwezi",
    generated: "Imezalishwa:",
    listBadges: "Orodha ya vibeti",
    concInfo: "Maelezo ya muunganisho",
    elevesAssocies: "Wanafunzi wanaohusiana",
    linkConnection: "Kiungo cha muunganisho",
    linkConnectiontext: "au programu ya simu ya EdParent",
    attestationInscription: "Cheti cha usajili",
    studentsWontAppearInPdf:
      "Wanafunzi hawa hawataonekana katika PDF kwa sababu wazazi wao hawana miingio ya kujiunga:",
    studentsWithoutLogin: "Wanafunzi wasiokuwa na miingio",
    studentsWithoutLoginInfo:
      "Wanafunzi hawa hawana miingio ya kujiunga lakini wataonekana katika PDF:",
    qrCodeErrorWarning: "Tatizo la kuzalisha nambari za QR",
    qrCodeErrorDescription:
      "Watumiaji hawa walikuwa na matatizo wakati wa kuzalisha nambari zao za QR. Unaweza kuzichapisha moja kwa moja kutoka kwenye wasifu wao.",
    qrCodeErrorDescription:
      "Watumiaji hawa walikuwa na matatizo wakati wa kuzalisha nambari zao za QR. Unaweza kuzichapisha moja kwa moja kutoka kwenye wasifu wao.",
  },
  cantine: {
    cantine: "Menyu ya mkahawa",
    dateChoisie: "Tarehe iliyochaguliwa",
    choisirDate: "Chagua tarehe ya kuingiza menyu",
    ajouterRepas: "Ongeza mlo",
    ajouterMenu: "Ongeza menyu mpya kwa",
    choisirJour: "Chagua siku",
    mealName: "Jina la mlo",
    type: "Aina",
    repeter: "Rudia",
    saisirNom: "Ingiza jina la mlo",
    saisirType: "Chagua aina ya mlo",
    saisirEndDate: "Ingiza tarehe ya mwisho",
    plat: "Chakula kikuu",
    entree: "Mlo wa Kwanza",
    goute: "Vifungua Kinywa",
    boissons: "Vinywaji",
    autre: "Vingine",
    dessert: "Kinywele",
    menuIntrouvable: "Menyu haipatikani, tafadhali ongeza milo!",
    ajouterNewMenu: "Ongeza menyu mpya kwa {date}",
    modifierMenu: "Hariri menyu {name}",
    saisirDateFin: "Ingiza tarehe ya mwisho",
    addSuccessMessage: "Mlo umeongezwa.",
    editSuccessMessage: "Mlo umeharirishwa.",
    errorMessage: "Kosa limetokea katika uharirishaji!",
    errorMessageAdd: "Kosa limetokea katika kuongeza!",
    ajouterMenuHebdo: "Ongeza menyu ya wiki",
    nomMenu: "Jina la menyu",
    saisirNomMenu: "Ingiza jina la menyu",
    descriptionMenu: "Maelezo",
    saisirDescriptionMenu: "Ingiza maelezo ya menyu",
    dateDebut: "Tarehe ya kuanza",
    saisirDateDebut: "Ingiza tarehe ya kuanza",
    endDateAvantDebut:
      "Tarehe ya mwisho lazima iwe sawa au baada ya tarehe ya kuanza",
    joursWeekend: "Siku za wikendi",
    inclureSamedi: "Jumuisha Jumamosi",
    inclureDimanche: "Jumuisha Jumapili",
    imageMenu: "Picha ya menyu",
    menusHebdo: "Menyu za wiki",
    repasDuJour: "Milo ya siku",
    aucunMenuHebdo: "Hakuna menyu ya wiki kwa tarehe hii",
    samediEtDimancheInclus: "Jumamosi na Jumapili zimejumuishwa",
    modifierMenuHebdo: "Hariri menyu ya wiki {name}",
    menuHebdoAjoute: "Menyu ya wiki imeongezwa.",
    menuHebdoModifie: "Menyu ya wiki imehaririwa.",
    menuHebdoSupprime: "Menyu ya wiki imefutwa.",
    erreurSuppressionMenuHebdo: "Kosa limetokea wakati wa kufuta menyu ya wiki!",
    apercu: "Hakiki",
    samediInclus: "Jumamosi imejumuishwa",
    dimancheInclus: "Jumapili imejumuishwa",
    joursSemaineSeulement: "Siku za kazi pekee",
  },
  paiement: {
    activiteSupprimee: "Shughuli zilizofutwa",
    activiteActive: "Shughuli zinazoendelea",
    reducation: "Punguzo",
    reducationRep: "Punguzo la kurudia",
    reductionBase: "Punguzo la msingi",
    selectMonths: "Chagua miezi",
    reducationDefault: "Punguzo la chaguo-msingi",
    avoir: "Kuwa na",
    note: "Dokezo",
    paiementClasse: "Malipo/Darasa",
    nom: "Jina la mwanafunzi",
    prenom: "Jina la kwanza la mwanafunzi",
    classe: "Darasa",
    parents: "Wazazi",
    tels: "Simu za wazazi",
    etat: "Hali ya malipo",
    fraisInscri: "Ada ya usajili",
    fraisMensuel: "Ada za kila mwezi",
    dateDebut: "Tarehe ya kuanza",
    dateFin: "Tarehe ya mwisho",
    tousMois: "Miezi yote",
    mois: "Mwezi",
    tousClasses: "Madarasa yote",
    order: "Mpangilio",
    service: "Huduma",
    nbEleves: "Idadi ya wanafunzi",
    listeClasses: "Orodha ya madarasa",
    listeEleves: "Orodha ya wanafunzi",
    imprimerTab: "Chapisha jedwali",
    selectionnerMois: "Chagua mwezi",
    paye: "Imelipwa",
    inscriPaye: "Usajili umelipwa",
    inscriNonPaye: "Usajili haujalipwa",
    impaye: "Haijalipwa",
    partiel: "Imelipwa sehemu",
    selectionnerDate: "Chagua tarehe",
    reduction: "Punguzo kwenye usajili",
    reductionMensuel: "Punguzo la kila mwezi",
    activite: "Shughuli",
    annulation: "Kughairi",
    annulationSuccess: "Kughairi kumefanyika kwa mafanikio",
    listeActivites: "Orodha ya shughuli",
    filtrerParStatut: "Chuja kwa hali:",
    actives: "Zinazoendelea",
    toutes: "Zote",
    dt: "KSH",
    non: "Hapana",
    chercher: "Tafuta",
    annulerInscri: "unataka kughairi usajili?",
    eleveRequis: "Mwanafunzi mmoja angalau anahitajika",
    classRequis: "Darasa moja angalau linahitajika",
    activiteRequis: "Shughuli inahitajika",
    activitesTypeDifferent:
      "Unaweza kuchagua shughuli za aina moja tu (Za kila siku au Kila mwezi/Kipindi)",
    tagActiviteJournaliere: "Za kila siku",
    tagActiviteMensuelleTranche: "Kila mwezi/Kipindi",
    inscriptionEchecPourActivite: "Usajili umeshindwa kwa shughuli",
    inscriptionReussitePourActivites: "Usajili umefanikiwa kwa shughuli {count}",
    dateDebutRequis: "Tarehe ya kuanza inahitajika",
    dateFinRequis: "Tarehe ya mwisho inahitajika",
    msgReduction: "Weka punguzo sifuri ikiwa hutaki kuongeza punguzo",
    typeDepense: "Aina ya matumizi inahitajika",
    eleve: "Mwanafunzi anahitajika",
    paymentMode: "Chagua njia ya malipo",
    etatPaiementsPourMois: "Hali ya malipo kwa mwezi",
    etatPaiementsTousMois: "Hali ya malipo kwa miezi yote",
    num: "Nambari",
    paymentStatusActivity: "Hali_malipo_shughuli",
    impaye: "Haijalipwa",
    paye: "Imelipwa",
    paymentStatusScolarite: "Hali_malipo_masomo",
    totalInscriptions: "Jumla ya usajili",
    totalPaiements: "Jumla ya malipo",
    totalMontant: "Jumla ya kiasi",
    lignes: "mistari",
    trancheLabel: "Kipande",
    inscriptionLabel: "Usajili",
    title: "Kuingiza malipo",
    pendingSchedules: "Mipango inayosubiri",
    unplannedExpenses: "Gharama zisizopangwa",
    invoiceRef: "Rejea ya ankara",
    beneficiary: "Mnufaika",
    dueDate: "Tarehe ya ukomo",
    amount: "Kiasi",
  },
  inscription: {
    nom: "Jina kamili",
    dateNaissance: "Tarehe ya kuzaliwa",
    sexe: "Jinsia",
    tels: "Simu za wazazi",
    parent: "Mzazi",
    nouvInscri: "Usajili mpya",
    nbEleves: "Idadi ya wanafunzi: {number}",
    ficheParentClasse: "Karatasi ya darasa / mzazi",
    ficheClasse: "Karatasi ya darasa",
    confirmEnrollmentTooltip:
      "Usajili wa darasa {name} utapatikana kwa wazazi",
    cancelEnrollmentConfirmationTooltip:
      "Usajili wa darasa {name} hautapatikana tena kwa wazazi",
    enrollmentVisibleTag: "Inapatikana kwa wazazi",
    enrollmentHiddenTag: "Haipatikani kwa wazazi",
    enrollmentVisibleTooltip:
      "Usajili wa darasa {name} unapatikana kwa wazazi",
    enrollmentHiddenTooltip:
      "Usajili wa darasa {name} haupatikani kwa wazazi",
    enrollmentAllVisibleTooltip:
      "Usajili wa madarasa yote unapatikana kwa wazazi",
    enrollmentAllHiddenTooltip:
      "Usajili wa madarasa yote haupatikani kwa wazazi",
    confirmAllClassesBtn: "Fanya madarasa yote yapatikane kwa wazazi",
    cancelAllConfirmationBtn: "Sifanya madarasa yote yapatikane kwa wazazi",
    confirmAllClassesContent:
      "Usajili wa madarasa yote utapatikana kwa wazazi.",
    cancelAllConfirmationContent:
      "Usajili wa madarasa yote hautapatikana tena kwa wazazi.",
    enrollmentConfirmedMsg:
      "Usajili wa darasa {name} sasa unapatikana kwa wazazi",
    enrollmentUnconfirmedMsg:
      "Usajili wa darasa {name} haupatikani tena kwa wazazi",
    allClassesConfirmedMsg:
      "Usajili sasa unapatikana kwa wazazi kwa madarasa yote",
    allClassesUnconfirmedMsg:
      "Usajili haupatikani tena kwa wazazi kwa madarasa yote",
    inscription: "Usajili",
    enfant: "Mtoto",
    fraisInscri: "Ada ya usajili",
    fraisMensuel: "Ada za kila mwezi",
    remise: "Punguzo",
    remiseInscri: "Punguzo kwenye usajili",
    remiseMensuel: "Punguzo la kila mwezi",
    rechercher: "Tafuta",
    mensuel: "Ya kila mwezi",
    chercherParActivite: "Tafuta kwa jina la shughuli",
    sureToInscri: "Una uhakika unataka kumsajili mwanafunzi huyu?",
    downloadTitle: "Pakua orodha ya wanafunzi kwa shughuli",
    activityListSelectColumnsHint:
      "Chagua taarifa za wanafunzi za kujumuisha kwenye orodha ya shughuli.",
    noStudentInActivity:
      "Hakuna wanafunzi waliosajiliwa katika shughuli zifuatazo",
    unableToGeneratePdf:
      "Haiwezekani kuzalisha PDF - Hakuna wanafunzi waliosajiliwa katika shughuli zilizochaguliwa",
    changeClassroom: "Badilisha darasa",
    studentsList: "Orodha ya wanafunzi waliosajiliwa katika shughuli",
    activityList: "Orodha_ya_shughuli",
    num: "Nambari",
    ecolePrimairePrivee: "Shule ya msingi ya binafsi",
    formulaireParent: "Fomu ya mzazi",
    anneeScolaireLabel: "Mwaka wa masomo",
    numero: "Nambari",
    nomPrenom: "Jina kamili",
    dateNaissance: "Tarehe ya kuzaliwa",
    nomParent: "Jina la mzazi",
    telephone: "Simu",
    delegeRegionalEducation: "Mamlaka ya Elimu ya Kikanda",
    ficheParentPDF: "Fomu_ya_Mzazi",
    nonDisponible: "Haipatikani",
    classe: "Darasa",
    pere: "Baba",
    mere: "Mama",
    identifiantUnique: "Kitambulisho cha kipekee",
    nomComplet: "Jina kamili",
    sexe: "Jinsia",
    garcon: "Mvulana",
    fille: "Msichana",
    nombreTotal: "Idadi ya jumla",
    nombreGarcons: "Idadi ya wavulana",
    nombreFilles: "Idadi ya wasichana",
    listeElevesPDF: "Orodha_ya_Wanafunzi",
    installmentFees: "Amafaranga y'inyongera",
    installment: "Inyongera",
    selectedPaymentMode: "Uburyo bwo kwishyura wahisemo ni",
    byInstallments: "mu byiciro",
    monthly: "buri kwezi",
    fees: "Amafaranga",
    included: "Birimo",
    discount: "Punguzo",
    changeGroup: "Hindura itsinda",
    monthlyPayment: "Malipo ya kila mwezi",
    installmentPayment: "Malipo kwa vipande",
    paymentMode: "Njia ya malipo",
    monthly: "Kila mwezi",
    byInstallment: "Kwa vipande",
    globalStatus: "Hali ya jumla",
    notSpecified: "Haijabainishwa",
    sureToCancel: "Una uhakika unataka kughairi?",
    sureToDelete: "Una uhakika unataka kufuta?",
    selectionnerModePaiement: "Chagua njia ya malipo",
    fraisDesTranches: "Ada za vipande",
    tranche: "Kipande",
    lesFraisAPayer: "Ada za kulipa",
    modePaiementSelectionne: "Njia ya malipo iliyochaguliwa ni",
    parTranches: "kwa vipande",
    mensuelle: "ya kila mwezi",
    selectionnerJours: "Chagua siku",
    datesSelectionnees: "Tarehe zilizochaguliwa",
    toutEffacer: "Futa zote",
    aucuneDateSelectionnee: "Hakuna tarehe iliyochaguliwa",
    frais: "Ada",
    inclus: "Imejumuishwa",
    selectionnerAuMoinsUnJour:
      "Tafadhali chagua angalau siku moja kwa shughuli hii ya kila siku",
    ajouterDate: "Ongeza tarehe",
    ajouter: "Ongeza",
    selectionnerTranches: "Chagua vipande",
    tranchesSelectionnees: "Vipande vilivyochaguliwa",
    selectionnerMois: "Chagua miezi",
    moisSelectionnes: "Miezi iliyochaguliwa",
    elementsSelectionnes: "Vipengele vilivyochaguliwa",
  },
  buildingType: {
    jardinEnfantsPrive: "Shule ya binafsi ya kikurasa",
    ecolePrimairePrivee: "Shule ya msingi ya binafsi",
    collegePrive: "Shule ya sekondari ya binafsi",
    lyceePrive: "Shule ya chuo cha kwanza ya binafsi",
    collegeLyceePrives: "Shule ya sekondari na chuo cha kwanza ya binafsi",
    collegeEcolePrives: "Shule ya msingi na sekondari ya binafsi",
    jardinEnfantEcolePrives: "Shule ya binafsi ya kikurasa na msingi",
    jardinEnfantCollegePrives: "Shule ya binafsi ya kikurasa na sekondari",
    jardinEnfantLyceePrives: "Shule ya binafsi ya kikurasa na chuo cha kwanza",
    ecoleLyceePrives: "Shule ya msingi na chuo cha kwanza ya binafsi",
    jardinEnfantEcoleCollegePrives:
      "Shule ya binafsi ya kikurasa, msingi na sekondari",
    jardinEnfantCollegeLyceePrives:
      "Shule ya binafsi ya kikurasa, sekondari na chuo cha kwanza",
    jardinEnfantEcoleLyceePrives:
      "Shule ya binafsi ya kikurasa, msingi na chuo cha kwanza",
    jardinEnfantEcoleCollegeLyceePrives:
      "Shule ya binafsi ya kikurasa, msingi, sekondari na chuo cha kwanza",
    collegeEcoleLyceePrives:
      "Shule ya msingi, sekondari na chuo cha kwanza ya binafsi",
    ecolePrivee: "Shule ya binafsi",
    // Kenya school types
    preSchoolPrive: "Shule ya kabla ya shule ya binafsi",
    prePrimaryPrive: "Shule ya msingi wa chini ya binafsi",
    middlePrive: "Shule ya msingi wa juu ya binafsi",
    juniorPrive: "Shule ya sekondari ya chini ya binafsi",
    seniorPrive: "Shule ya sekondari ya juu ya binafsi",
    prePrimaryMiddlePrives:
      "Shule ya msingi wa chini na msingi wa juu ya binafsi",
    prePrimaryJuniorPrives:
      "Shule ya msingi wa chini na sekondari ya chini ya binafsi",
    prePrimarySeniorPrives:
      "Shule ya msingi wa chini na sekondari ya juu ya binafsi",
    middleJuniorPrives:
      "Shule ya msingi wa juu na sekondari ya chini ya binafsi",
    middleSeniorPrives: "Shule ya msingi wa juu na sekondari ya juu ya binafsi",
    juniorSeniorPrives: "Shule ya sekondari ya chini na juu ya binafsi",
    prePrimaryMiddleJuniorPrives:
      "Shule ya msingi wa chini, msingi wa juu na sekondari ya chini ya binafsi",
    prePrimaryMiddleSeniorPrives:
      "Shule ya msingi wa chini, msingi wa juu na sekondari ya juu ya binafsi",
    prePrimaryJuniorSeniorPrives:
      "Shule ya msingi wa chini, sekondari ya chini na juu ya binafsi",
    middleJuniorSeniorPrives:
      "Shule ya msingi wa juu, sekondari ya chini na juu ya binafsi",
    prePrimaryMiddleJuniorSeniorPrives:
      "Shule ya msingi wa chini, msingi wa juu, sekondari ya chini na juu ya binafsi",
    preSchoolPrePrimaryPrives:
      "Shule ya kabla ya shule na msingi wa chini ya binafsi",
    preSchoolMiddlePrives:
      "Shule ya kabla ya shule na msingi wa juu ya binafsi",
    preSchoolJuniorPrives:
      "Shule ya kabla ya shule na sekondari ya chini ya binafsi",
    preSchoolSeniorPrives:
      "Shule ya kabla ya shule na sekondari ya juu ya binafsi",
    preSchoolPrePrimaryMiddlePrives:
      "Shule ya kabla ya shule, msingi wa chini na msingi wa juu ya binafsi",
    preSchoolPrePrimaryJuniorPrives:
      "Shule ya kabla ya shule, msingi wa chini na sekondari ya chini ya binafsi",
    preSchoolPrePrimarySeniorPrives:
      "Shule ya kabla ya shule, msingi wa chini na sekondari ya juu ya binafsi",
    preSchoolMiddleJuniorPrives:
      "Shule ya kabla ya shule, msingi wa juu na sekondari ya chini ya binafsi",
    preSchoolMiddleSeniorPrives:
      "Shule ya kabla ya shule, msingi wa juu na sekondari ya juu ya binafsi",
    preSchoolJuniorSeniorPrives:
      "Shule ya kabla ya shule, sekondari ya chini na juu ya binafsi",
    preSchoolPrePrimaryMiddleJuniorPrives:
      "Shule ya kabla ya shule, msingi wa chini, msingi wa juu na sekondari ya chini ya binafsi",
    preSchoolPrePrimaryMiddleSeniorPrives:
      "Shule ya kabla ya shule, msingi wa chini, msingi wa juu na sekondari ya juu ya binafsi",
    preSchoolPrePrimaryJuniorSeniorPrives:
      "Shule ya kabla ya shule, msingi wa chini, sekondari ya chini na juu ya binafsi",
    preSchoolMiddleJuniorSeniorPrives:
      "Shule ya kabla ya shule, msingi wa juu, sekondari ya chini na juu ya binafsi",
    preSchoolPrePrimaryMiddleJuniorSeniorPrives:
      "Shule ya kabla ya shule, msingi wa chini, msingi wa juu, sekondari ya chini na juu ya binafsi",
  },
  punition: {
    createdBy: "Imeundwa na",
    eleve: "Mwanafunzi",
    nom: "Jina la ukoo",
    prenom: "Jina la kwanza",
    details: "Maelezo",
    seenByParents: "Imeonwa na wazazi",
    noParentSeen: "Hakuna mzazi ambaye ameona adhabu hii bado.",
    notVisibleToParents: "Haionekani kwa wazazi",
    notVisibleToParentsHint:
      "Adhabu zilizothibitishwa pekee ndizo zinazoonekana kwa wazazi.",
    punition: "Adhabu",
    studentDiscipline: "Nidhamu ya Mwanafunzi",
    studentDisciplineList: "Orodha ya Nidhamu ya Mwanafunzi",
    temps: "Muda",
    raison: "Sababu",
    description: "Maelezo",
    validation: "Uthibitishaji",
    valides: "Imethibitishwa",
    rejetes: "Imekataliwa",
    nonEvalues: "Haijatathminiwa",
    dateAjout: "Tarehe ya kuongeza",
    dateEvalution: "Tarehe ya tathmini",
    valider: "Thibitisha",
    rejeter: "Kataa",
    rejectReason: "Sababu ya kukataa adhabu",
    rejectReasonDiscipline: "Sababu ya kukataa nidhamu ya mwanafunzi",
    reasonRequired: "Sababu ya kukataa inahitajika",
    typeRequired: "Aina ya adhabu inahitajika",
    typeRequiredDiscipline: "Aina ya nidhamu ya mwanafunzi inahitajika",
    eventTime: "Muda wa tukio",
    autoValidationMessage:
      "Adhabu hii itathibitishwa kiotomatiki. Je, unataka kuendelea?",
    autoValidationMessageDiscipline:
      "Nidhamu hii ya mwanafunzi itathibitishwa kiotomatiki. Je, unataka kuendelea?",
    pendingValidationMessage:
      "Adhabu hii itabaki pending hadi ithibitishwe na msimamizi. Je, unataka kuendelea?",
    pendingValidationMessageDiscipline:
      "Nidhamu hii ya mwanafunzi itabaki pending hadi ithibitishwe na msimamizi. Je, unataka kuendelea?",
    errorLoadingPunishments: "Hitilafu wakati wa kupakia adhabu",
    errorLoadingDisciplines: "Hitilafu wakati wa kupakia nidhamu ya mwanafunzi",
    noPunishmentTypeFound: "Hakuna aina ya adhabu iliyopatikana",
    noDisciplineTypeFound: "Hakuna aina ya nidhamu ya mwanafunzi iliyopatikana",
    timeRequired: "Muda wa tukio unahitajika",
  },
  days: {
    sunday: "Jumapili",
    monday: "Jumatatu",
    tuesday: "Jumanne",
    wednesday: "Jumatano",
    thursday: "Alhamisi",
    friday: "Ijumaa",
    saturday: "Jumamosi",
  },
  emploi: {
    validated: "Ratiba sasa inapatikana kwa darasa {name}",
    unvalidated: "Ratiba haipatikani tena kwa darasa {name}",
    hideEmploin: "Ratiba ya darasa hili haitapatikana tena kwa wazazi",
    validateEmploin: "Ratiba ya darasa hili itapatikana kwa wazazi",
    emplois: "Ratiba za masaa",
    temps: "Muda",
    trimestre: "Muhula",
    listeClasses: "Orodha ya madarasa",
    listeEnseignants: "Orodha ya walimu",
    emploiEnseignants: "Ratiba za masaa za walimu",
    imprimerEmploi: "Chapisha ratiba",
    imprimerEmploiAdministrative: "Chapisha ratiba ya utawala",
    pdfRepublique: "Jamhuri ya Tunisia - Wizara ya Elimu",
    pdfDelegation: "Uwakilishi wa Kikanda wa {delegation}",
    pdfDelegationKE: "Eneo la Nchi: {delegation}",
    pdfAnnee: "Mwaka wa Masomo: {year}",
    pdfImprime: "Imechapishwa tarehe: {date}",
    pdfEcole: "Shule ya Msingi ya Kibinafsi: {name}",
    pdfEmploi: "Ratiba ya {className}",
    pdfEmploiTeacher: "Ratiba ya {teacher}",
    pdfEmploiAdmin: "Ratiba ya Utawala",
    enseignant: "Mwalimu",
    matiere: "Somo",
    salle: "Chumba",
    duree: "Muda",
    classe: "Darasa",
    choisirEnseignant: "Chagua mwalimu",
    choisirMatiere: "Chagua somo",
    chooseSubmodule: "Chagua moduli ndogo",
    choisirSalle: "Chagua chumba",
    choisirDuree: "Chagua muda",
    choisirClasse: "Chagua darasa",
    ajouterSeance: "Ongeza kipindi",
    modifierSeance: "Hariri kipindi",
    disponible: "Inapatikana",
    indisponible: "Haipatikani",
    modeModif: "Hali ya uharirishaji imewashwa!",
    desc: "Unaweza kubadilisha mahali na muda wa vipindi!",
    totaleHeures: "Jumla ya masaa",
    moyenneHeuresJour: "Wastani wa masaa/siku",
    maximunHeuresJour: "Masaa ya juu zaidi/siku",
    totaleClasses: "Jumla ya madarasa",
    totaleTeachers: "Jumla ya walimu",
    seance: "Kipindi",
    seanceListe: "Orodha ya vipindi",
    choisirName: "Chagua jina la kipindi",
    name: "Jina la kipindi",
    includedSubjects: "Mwalimu anaweza kufikia",
    hideTeacherUpdated: "Mwalimu amefichwa kwa mafanikio",
    hideEmploi: "Ratiba haitapatikani tena kwa wazazi",
    validateEmploi: "Ratiba itapatikana kwa wazazi",
    validatedClassroom: "Ratiba itapatikana kwa wazazi",
    unvalidatedClassroom: "Ratiba haitapatikani tena kwa wazazi",
    hideTeacher: "Ficha mwalimu",
    choisirTemps: "Chagua muda",
    addSession: "Ongeza kipindi",
    selectedTime: "Muda uliochaguliwa",
    selectedDay: "Siku iliyochaguliwa",
    selectedClass: "Darasa lililochaguliwa",
    group: "Kikundi",
    groupOption: "Chagua kikundi",
    fullClass: "Darasa kamili",
    week: "Wiki",
    weekLabel: "Wiki",
    weekOption: "Chagua wiki",
    weekBoth: "Wiki zote mbili",
    weekA: "Wiki A",
    weekB: "Wiki B",
    modulesPedagogiques: "Moduli za Elimu",
    modulesPilotes: "Moduli za Uongozi",
    additionalSubject: "Somo la Ziada",
    pedagogicalModule: "Moduli ya Elimu",
    pilotModule: "Moduli ya Uongozi",
    today: "Leo",
    month: "Mwezi",
    day: "Siku",
    startTime: "Muda wa kuanza",
    duration: "Muda",
    subject: "Somo",
    teacher: "Mwalimu",
    room: "Chumba",
    notes: "Maelezo",
    minutes: "dakika",
    hour: "saa",
    hours: "masaa",
    durationFormat: "{hours} S {minutes} D",
    pleaseSelectDay: "Tafadhali chagua siku",
    pleaseSelectStartTime: "Tafadhali chagua muda wa kuanza",
    pleaseSelectDuration: "Tafadhali chagua muda",
    pleaseSelectSubject: "Tafadhali chagua somo",
    pleaseSelectTeacher: "Tafadhali chagua mwalimu",
    pleaseSelectRoom: "Tafadhali chagua chumba",
    selectDay: "Chagua siku",
    selectStartTime: "Chagua muda wa kuanza",
    selectDuration: "Chagua muda",
    selectSubject: "Chagua somo",
    selectTeacher: "Chagua mwalimu",
    selectRoom: "Chagua chumba",
    selectGroup: "Chagua kikundi",
    addNotes: "Ongeza maelezo",
    deleteSession: "Futa kipindi",
    deleteSessionQuestion: "Unataka kufuta kipindi hiki?",
    deleteSessionOptions: "Chagua chaguo:",
    deleteOnlyThis: "Futa kipindi hiki tu",
    deleteRecurring:
      "Futa kipindi hiki na vipindi vyote vinavyofanana vya kurudia (vilivyopita na vijavyo)",
    updateSessionOptions: "Chaguo za kusasisha",
    updateSessionQuestion: "Unataka kusasisha kipindi hiki vipi?",
    updateSessionDescription:
      "Chagua kama unataka kusasisha kipindi hiki tu au vipindi vyote vinavyofanana.",
    updateOnlyThis: "Sasisha kipindi hiki tu",
    updateOnlyThisDescription: "Kipindi hiki tu kitabadilishwa.",
    updateAllSimilar: "Sasisha vipindi vyote vinavyofanana",
    updateAllSimilarDescription:
      "Vipindi vyote vilivyo na sifa sawa vitasasishwa.",
    updateDuration: "Muda wa kusasisha",
    untilEndOfYear: "Kipindi hiki na vipindi vyote vinavyofuata",
    untilEndOfYearDescription:
      "Sasisha kipindi hiki na vipindi vyote vinavyofuata hadi mwisho wa mwaka wa shule.",
    wholeSchoolYear: "Vipindi vyote vya mwaka wa shule",
    wholeSchoolYearDescription:
      "Sasisha vipindi vyote vya mwaka wa shule, pamoja na vipindi vilivyopita.",
    customDuration: "Muda maalum",
    customDurationDescription: "Chagua muda maalum kwa miezi.",
    enterDurationMonths: "Ingiza muda kwa miezi",
    durationInMonths: "Muda kwa miezi (1-12)",
    enterValidDuration: "Tafadhali ingiza muda halali",
    sessionPreview: "Hakiki ya kipindi",
    sessionName: "Jina la Kipindi",
    sessionTime: "Muda wa Kipindi",
    selectEndDate: "Chagua tarehe ya mwisho",
    selectEndDateDescription: "Chagua tarehe ya mwisho ya kusasisha kwa wingi",
    selectedDate: "Tarehe iliyochaguliwa",
    restoreSession: "Rudisha kipindi",
    restoreSessionConfirm: "Una uhakika unataka kurudisha kipindi hiki?",
    cancelSessionWarning: "Ghairi kipindi",
    cancelSessionDescription: "Hii itaghairi kipindi na matukio yake yote",
    cancellationReason: "Sababu ya Kughairi",
    cancelUntil: "Ghairi hadi",
    cancelUntilDescription: "Chagua tarehe ya kughairi kipindi hadi",
    sessionDetails: "Maelezo ya Kipindi",
    confrimCancel: "Thibitisha Kughairi",
    cancellationReasonRequired: "Sababu ya kughairi inahitajika",
    deleteRecuring: "Futa vipindi vya kurudia",
    cancelSession: "Ghairi kipindi",
    confirmCancel: "Thibitisha kughairi",
    enterCancellationReason: "Ingiza sababu ya kughairi",
    selectCancelUntilDate: "Chagua tarehe ya kughairi hadi",
    sessionCanceled: "Kipindi kimeghairiwa",
    cancelUntilRequired: "Tarehe ya mwisho ya kughairi inahitajika",
    cancelUntilCannotBePast:
      "Tarehe ya mwisho ya kughairi haiwezi kuwa ya zamani",
    chooseSubmodule: "Chagua moduli ndogo",
  },
  bulletin: {
    bulletins: "Ripoti za shule",
    annualReport: "Ripoti ya mwaka",
    displayOptions: "Chaguo za onyesho",
    teachersByClassroom: "Walimu (kwa darasa)",
    showDate: "Onyesha tarehe",
    configSaved: "Mipangilio imehifadhiwa",
    pvAnnuel: "PV ya mwaka",
    ficheNotes: "Karatasi ya alama",
    exporterExcel: "Hamisha kwenye Excel",
    imprimerPV: "Chapisha PV",
    imprimerConseilClasse: "Chapisha PV ya baraza la darasa",
    imprimerPVParNiveau: "Chapisha PV kwa kiwango",
    notesWillBeDeleted: "Alama hizi zitaondolewa",
    loading: "Inapakia...",
    deletingNotes: "Inaondoa alama...",
    classroom: "Darasa",
    numberOfAffectedNotes: "Idadi ya alama zilizoathiriwa",
    student: "Mwanafunzi",
    subjects: "Masomo",
    duplicateSettings: "Nakili Mipangilio",
    source: "Chanzo",
    targets: "Lengo (Malengo)",
    parameters: "Vigezo",
    templates: "Viole",
    schoolYear: "Mwaka wa Shule",
    selectSchoolYear: "Chagua mwaka wa shule",
    selectTemplate: "Chagua viole",
    selectTypes: "Chagua aina",
    selectLevels: "Chagua viwango",
    selectTrimesters: "Chagua muhula",
    allDataDuplicatedSuccess: "Data zote zimekiliwa kwa mafanikio",
    pleaseRefreshPage: "tafadhali onyesha upya ukurasa ili kuona athari kamili",
    duplicationHappened:
      "Kitendo cha kunakili mipangilio kimetokea, tafadhali onyesha upya ukurasa ili kuona athari kamili",
    configureDisplay: "Sanidi Onyesho",
    generalConfiguration: "Usanidi wa Jumla",
    studentName: "Jina la Mwanafunzi",
    className: "Jina la Darasa",
    trimesterName: "Jina la Muhula",
    schoolYear: "Mwaka wa Shule",
    orientation: "Mwelekeo",
    positionX: "Nafasi X",
    font: "Herufi",
    size: "Ukubwa:",
    color: "Rangi:",
    vertical: "Wima",
    horizontal: "Usawa",
    centered: "Katikati",
    atBeginning: "Mwanzo",
    selectFont: "Chagua herufi",
    textSize: "Ukubwa wa Maandishi",
    arabicAndFrench: "Kiarabu na Kifaransa",
    arabicOnly: "Kiarabu Tu",
    amiriNormal: "Amiri (Kawaida)",
    amiriBold: "Amiri (Nene)",
    notoNaskhArabicNormal: "Noto Naskh Arabic (Kawaida)",
    notoSansArabicBold: "Noto Sans Arabic (Nene)",
    alJazeeraArabicBold: "Al Jazeera Arabic (Nene)",
    imprimerPVNiveaux: "Chapisha PV za viwango",
    changePositions: "Badilisha nafasi",
    fuseSubSubject: "Unganisha masomo madogo",
    showSubModule: "Jina la moduli ndogo",
    hideDate: "Ficha tarehe",
    hideSubject: "Ficha masomo",
    useSubModule: "Tumia moduli ndogo",
    subModule: "Moduli ndogo",
    managerSubModule: "Simamia moduli ndogo",
    manageCertType: "Simamia vyeti kwa:",
    pvSortBy: "Panga kwa",
    pvSortOrder: "Mwelekeo wa kupanga",
    pvSortAverage: "Wastani",
    pvSortName: "Jina",
    pvSortAsc: "Kupanda",
    pvSortDesc: "Kushuka",
    defaultModule: "Moduli za chaguo-msingi",
    defaultModuleConfirm:
      "Tendo hili litafuta moduli iliyopo. Unataka kuendelea na kuweka moduli za chaguo-msingi?",
    defaultDone: "Moduli za chaguo-msingi zimehifadhiwa kwa mafanikio",
    alert: "Haiwezekani kubadilisha: tafadhali hariri katika ripoti maalum",
    avg: "Wastani wa moduli",
    coefTrimester1: "Mkazo wa muhula wa 1",
    coefTrimester2: "Mkazo wa muhula wa 2",
    coefTrimester3: "Mkazo wa muhula wa 3",
    moyenneGeneral: "Wastani wa jumla",
    moyenneTrimestreGeneral: "Wastani wa jumla wa muhula",
    moyenneTrimestreGeneralMatieresBase:
      "Wastani wa jumla wa muhula katika masomo ya msingi",
    bulletinCoefs: "Mikazo ya ripoti",
    coefBulletinsSaved: "Mikazo ya ripoti imehifadhiwa kwa mafanikio",
    exempt: "Ameruhusiwa",
    alreadyExempt: "Tayari ameruhusiwa",
    confirmExemptStudent: "Una uhakika unataka kumruhusu mwanafunzi huyu?",
    confirmUnexemptStudent:
      "Una uhakika unataka kughairi ruhusa ya mwanafunzi huyu?",
    decisionConseil: "Uamuzi wa baraza",
    ConsielClass: "Baraza la darasa",
    finalBulletin: "Ripoti ya mwaka",
    syncClass: "Sawazisha darasa",
    syncSubject: "Sawazisha somo",
    syncMarks: "Sawazisha alama",
    sureToSync: "Unataka kubatilisha alama?",
    syncDone: "Alama zimesawazishwa kwa mafanikio",
    date: "Tarehe ya kuchapisha",
    parametrageSaved: "Mipangilio ya ripoti imehifadhiwa kwa mafanikio",
    label: "Lebo",
    moyennePersonalized: "Wastani wa kibinafsi kwa shule",
    moyenneSpecifique: "Wastani maalum",
    moyenneVerySpecifique: "Wastani wa kipekee",
    moyennePedagogique: "Wastani wa kiufundishaji",
    formulePersonalized: "Formula ya kibinafsi",
    imprimerFichModuleVide: "Karatasi tupu",
    imprimerFichModule: "Karatasi iliyojazwa",
    imprimerFichModuleVideAll: "Karatasi zote tupu",
    imprimerFichModuleAll: "Karatasi zote zilizojazwa",
    certByMoyenne: "Vyeti kulingana na wastani wa wanafunzi",
    imprimerBulletin: "Chapisha ripoti ya shule",
    note: "Alama",
    nom: "Jina la mwanafunzi",
    bulletin: "Ripoti ya shule",
    bulletinV1: "Ripoti ya shule (Toleo la zamani)",
    notes: "Alama",
    matieres: "Masomo",
    bulletinPedagogique: "Ripoti ya kiufundishaji",
    bulletinSpecifique: "Ripoti ya mwongozi",
    bulletinVerySpecifique: "Ripoti maalum",
    performancesMatiere: "Utendaji wa somo",
    plus15: "Zaidi ya 15",
    plus12: "Zaidi ya 12",
    plus9: "Zaidi ya 9",
    mois9: "Chini ya 9",
    listeClasses: "Orodha ya madarasa",
    classesActives: "Madarasa hai",
    nombreClassesNonNote: "Idadi ya madarasa yasiyo na alama",
    tousClassesSontNotes: "Madarasa yote yana alama!",
    nombreMatieresNonNote: "Idadi ya masomo yasiyo na alama",
    tousMatieresSontNotes: "Masomo yote yana alama!",
    nombreElevesNonNotes: "Idadi ya wanafunzi wasiokuwa na alama",
    tousElevesSontNotes: "Wanafunzi wote wana alama!",
    classes: "madarasa",
    toutMatieres: "Masomo yote",
    toutEleves: "Wanafunzi wote",
    activeStudents: "Wanafunzi hai",
    archivedStudents: "Wanafunzi waliyohifadhiwa",
    enregistrerTout: "Hifadhi yote",
    parEleve: "Kwa mwanafunzi",
    parMatiere: "Kwa somo",
    typeIntrouvable: "Aina haipatikani",
    saisirSchoolType:
      "Tafadhali ingiza aina ya taasisi yako katika mipangilio - taasisi!",
    aucuneDonnee: "Hakuna data inayopatikana kwa robo hii",
    confirmPrintMatieres:
      "Alama za masomo hapa chini ({count}) lazima zijazwe ili kuzalisha ripoti ya shule!",
    confirmPrintEleves:
      "Alama za wanafunzi hapa chini ({count}) lazima zijazwe ili kuzalisha ripoti ya shule!",
    generateAnyway: "Zalisha hata hivyo",
    listeClassesNonNote: "Orodha ya madarasa yasiyo na alama",
    listeMatiereNonNote: "Orodha ya masomo yasiyo na alama",
    listeEleveNonNote: "Orodha ya wanafunzi wasiokuwa na alama",
    performancesNotes: "Utendaji wa alama",
    notePlusHaute: "Wastani wa juu zaidi",
    noteEleve: "Alama ya mwanafunzi",
    notePlusBasse: "Wastani wa chini zaidi",
    moyennesModules: "Wastani wa moduli",
    maximaleMoyenne: "Wastani wa juu zaidi",
    moyenne: "Wastani",
    minimaleMoyenne: "Wastani wa chini zaidi",
    imprimerTout: "Chapisha yote",
    imprimerFichModuleVideexcel: "Karatasi zote tupu Excel",
    imprimerFichModuleexcel: "Karatasi ZOTE zilizojazwa Excel",
    moyenneTrimestre: "wastani wa muhula: {moyenne}",
    moyenneMax: "Wastani wa juu zaidi: {moyenne}",
    moyenneMin: "Wastani wa chini zaidi: {moyenne}",
    validated: "Ripoti za shule sasa zinapatikana kwa darasa {name}",
    unvalidated: "Ripoti za shule hazipatikani tena kwa darasa {name}",
    hideBulletin: "Ripoti za shule hazitapatikana kwa wazazi",
    validateBulletin: "Ripoti za shule zitapatikana kwa wazazi",
    cancelValidation: "Sifanya zipatikane kwa wazazi",
    validatedClassroom: "Fanya zipatikane kwa wazazi",
    deleteMark: "Unataka kufuta alama hii?",
    markDeletedSucc: "Alama imefutwa kwa mafanikio",
    markDeletedFail: "Alama haikuweza kufutwa, tafadhali jaribu tena!",
    showStamp: "Onyesha muhuri",
    PersonalizedAverage: "Tumia wastani wa kibinafsi",
    notesManquantes: "Alama zinazokosekana",
    Module: "Moduli",
    SubModule: "Moduli-ndogo",
    noTemplateFound: "Ripoti haijasanidiwa tafadhali ongeza usanidi kwanza",
    showNbrStudents: "Onyesha idadi ya wanafunzi waliosajiliwa",
    bulletinNotDispo: "Ripoti haipatikani",
    bulletinDispo: "Ripoti inapatikana",
    parentVisibility: "Kuonekana kwa mzazi",
    directorNotesOnBehaviorAndAttendance:
      "Maelezo ya mkurugenzi kuhusu tabia na uwasiliano",
    destination: "Lengo",
    pleaseSelectOrTypeAppreciation: "Tafadhali chagua au andika ukaguzi",
    pv: "PV",
    pvExcel: "PV (Excel)",
    format: "Muundo",
    formatAnnuel: "Muundo wa Mwaka",
    cannotModifyEditIn:
      "Haiwezi kubadilishwa: tafadhali hariri katika {type}, moduli: {name}",
    module: "moduli",
    noLevelsAvailable: "Hakuna viwango vya kiwango vya shule kinahitajika",
  },
  markHistory: {
    action: "Kitendo",
    action_create: "Imeundwa",
    action_delete: "Imefutwa",
    action_update: "Imesasishwa",
    after: "Baada",
    before: "Kabla",
    date: "Tarehe",
    empty: "Hakuna mabadiliko ya alama yaliyorekodiwa",
    role: "Jukumu",
    title: "Historia ya mabadiliko ya alama",
    user: "Mtumiaji",
    viewHistory: "Historia",
  },
  bulletinStatistics: {
    totalWithoutAverage: "Jumla bila wastani",
    totalWithAverage: "Jumla na wastani",
    schoolStatistics: "Takwimu za shule",
    level: "Kiwango",
    equalsOrExceeds16: "Sawa au zaidi ya 16",
    between15And1599: "Kati ya 15 na 15.99",
    between10And1499: "Kati ya 10 na 14.99",
    lessThan10: "Chini ya 10 kati ya 20",
    exceeds15: "Zaidi ya 15",
    exceeds10To15: "Zaidi ya 10 hadi 15",
    equals10: "Sawa na 10 kati ya 20",
    from5ToLessThan10: "Kutoka 5 hadi chini ya 10 kati ya 20",
    lessThan5: "Chini ya 5 kati ya 20",
    student: "Mwanafunzi",
    levelSuffix: "",
  },
  personnel: {
    nom: "Jina la ukoo",
    prenom: "Jina la kwanza",
    adresse: "Anwani",
    telephone: "Simu",
    qualification: "Sifa",
    dateNaissance: "Tarehe ya kuzaliwa",
    typeContrat: "Aina ya mkataba",
    salaire: "Mshahara",
    cin: "Kitambulisho",
    idCard: "Namba ya Kitambulisho",
    etatCivil: "Hali ya ndoa",
    niveau: "Kiwango",
    experiences: "Uzoefu",
    dateEntretien: "Tarehe ya mahojiano",
    qualifications: "Sifa",
    tauxHoraire: "Kiwango cha kila saa",
    detailPaiement: "Maelezo ya malipo",
    jourSemaine: "Siku kwa wiki",
    expectedHoursPerDay: "Masaa yanayotarajiwa / siku",
    daysOff: "Siku za mapumziko",
    daysOffPlaceholder: "Chagua siku za mapumziko",
    weekday_0: "Jumapili",
    weekday_1: "Jumatatu",
    weekday_2: "Jumanne",
    weekday_3: "Jumatano",
    weekday_4: "Alhamisi",
    weekday_5: "Ijumaa",
    weekday_6: "Jumamosi",
    expectedTeachingHours: "Masaa ya kufundisha / somo / wiki",
    expectedTeachingHoursHint: "Chagua somo na weka masaa kwa wiki",
    hoursPerWeek: "Masaa / wiki",
    addSubjectHours: "Ongeza somo",
    attendanceConfig: "Usanidi wa mahudhurio",
    cnss: "CNSS",
    rib: "RIB",
    pin: "PIN (Kodi)",
    sha: "SHA (Afya)",
    nssf: "NSSF (Mfuko wa Usalama wa Jamii)",
    bankAccountNo: "Namba ya Akaunti ya Benki",
    bankName: "Jina la Benki",
    bankBranch: "Tawi la Benki",
    autre: "Nyingine",
    notes: "Alama",
    infoBase: "Maelezo ya msingi",
    infoContrat: "Maelezo ya mkataba",
    chercher: "Tafuta",
    listeQualifications: "Orodha ya sifa",
    staff: "Wafanyakazi",
    personalList: "Orodha ya wafanyakazi",
    totalSalary: "Jumla ya mishahara",
    listPersonnelPDF: "Orodha_wafanyakazi",
    etatPaiePersonnels: "Hali ya malipo ya wafanyakazi",
    gestionPaiements: "Usimamizi wa malipo ya wafanyakazi",
    chercherParNom: "Tafuta kwa jina",
    nbPersonnel: "Idadi ya wafanyakazi",
    infoPersonnel: "Maelezo ya mfanyakazi",
    type: "Aina",
    personnel: "Mfanyakazi",
    enseignant: "Mwalimu",
  },
  enseignant: {
    advisorAddExercice: "Uwezekano wa kuongeza mazoezi",
    advisorAddNews: "Uwezekano wa kuongeza habari",
    advisorValidateNews: "Uwezekano wa kuthibitisha habari",
    newsPermissions: "Ruhusa za habari",
    addAccess: "Ongeza ufikiaji kwa mwalimu",
    selectClassMessage:
      "Tafadhali chagua darasa kutoka yale yaliyogawiwa kwa mwalimu",
    nom: "Jina la ukoo",
    prenom: "Jina la kwanza",
    adresse: "Anwani",
    telephone: "Simu",
    qualification: "Sifa",
    dateNaissance: "Tarehe ya kuzaliwa",
    typeContrat: "Aina ya mkataba",
    salaire: "Mshahara",
    cin: "Kitambulisho",
    etatCivil: "Hali ya ndoa",
    niveau: "Kiwango",
    experiences: "Uzoefu",
    dateEntretien: "Tarehe ya mahojiano",
    qualifications: "Sifa",
    tauxHoraire: "Kiwango cha kila saa",
    detailPaiement: "Maelezo ya malipo",
    jourSemaine: "Siku kwa wiki",
    cnss: "CNSS",
    rib: "RIB",
    autre: "Nyingine",
    notes: "Alama",
    infoBase: "Maelezo ya msingi",
    infoContrat: "Maelezo ya mkataba",
    chercher: "Tafuta",
    listeQualifications: "Orodha ya sifa",
    matiere: "Somo",
    specialite: "Utaalamu",
    grade: "Daraja",
    email: "Barua pepe",
    mdp: "Ufikiaji",
    compte: "Akaunti",
    detailPedagogiques: "Maelezo ya kiufundishaji",
    usernameEmail: "Jina la mtumiaji/barua pepe",
    photo: "Picha",
    conseillersPedagogiques: "Washauri wa kiufundishaji",
    ajouterConseillerPedagogique: "Ongeza mshauri wa kiufundishaji",
    enterInfoConseillerPedagogique:
      "Ingiza maelezo ya mshauri wa kiufundishaji katika sehemu zilizo hapa chini",
    niveauxSuperviser: "Viwango vya kusimamia",
    niveauxRequis: "Viwango vinahitajika",
    listeNiveaux: "Orodha ya viwango",
    aucunConseillerPedagogique: "Hakuna mshauri wa kiufundishaji aliyepatikana",
    needValidation: "Uthibitishaji wa otomatiki wa masomo na mazoezi",
    needValidation2: " na mazoezi",
    needNewsValidation: "Uthibitishaji wa otomatiki wa habari",
    teacherAddNews: "Uwezekano wa kuongeza habari",
    permissionsValidation: "Ruhusa za uthibitishaji",
    listeEnseignantsPDF: "Orodha_Walimu",
    listeConseillersPedagogiquesPDF: "Orodha_Washauri_Kiufundishaji",
    listeConseiller: "Orodha ya washauri wa kiufundishaji",
    deactivateOrActivateTeacherAccount: "Kuzima au kuamsha akaunti ya mwalimu",
    teacherQrCode: "Msimbo QR wa mwalimu",
    modifyTeacherAccessSubtitle:
      "Badilisha ufikiaji wa walimu ili kuwezesha usimamizi wa alama na maudhui ya kielimu katika EdTeacher.",
    educationalAdvisor: "Mshauri wa kielimu",
    duplicate: "Nakili",
    duplicateAccessForTeacher: "Nakili ufikiaji wa mwalimu",
    duplicateAllTeachers: "Nakili walimu wote",
    duplicateAccessForAllTeachers: "Nakili ufikiaji kwa walimu wote",
    accessLevelAddedSuccessfully:
      "Kiwango cha ufikiaji kimeongezwa kwa mafanikio",
    accessLevelNotAdded: "Kiwango cha ufikiaji hakijaongezwa",
    revokedAccessFrom: "Ufikiaji umefutwa kutoka kwa",
    onModules: "kwenye moduli",
    unknownModule: "Moduli isiyojulikana",
  },
  etatPaiement: {
    personnel: "Mfanyakazi",
    salaire: "Mshahara",
    avance: "Mkopo",
    nbJours: "Idadi ya siku",
    mois: "Mwezi",
    etatPaiement: "Hali ya malipo",
    virementBancaire: "Uhamishaji wa benki?",
    paiementAction: "Malipo",
    selectionnerMois: "Chagua mwezi",
    totalAvances: "Jumla ya mikopo",
    paiementsPersonnels: "Malipo ya kibinafsi",
    attendanceReference: "Rejeleo la mahudhurio (mwalimu)",
    attendanceReferenceHint:
      "Maelezo ya kurejelea kwa mwezi uliochaguliwa. Sehemu za siku/saa hazijazwi kiotomatiki.",
    noAttendanceData: "Hakuna data ya mahudhurio kwa mwezi huu.",
    attendanceDetails: "Maelezo",
    attendanceDetailsTitle: "Maelezo ya vipindi",
    attendanceSource: "Chanzo",
    attendanceSourceCheckin: "Kuingia",
    attendanceSourceManual: "Mwongozo",
    reste: "Iliyobaki",
    selectionnerFrais: "Chagua ada za kulipa",
    frais: "Ada",
    montant: "Kiasi",
    fraisAPayer: "Ada za kulipa",
    inscription: "Usajili",
    tranche: "Kipande",
    toutAfficher: "Onyesha zote",
    toutMasquer: "Ficha zote",
    payerAvecAvance: "Lipa kwa mkopo",
    sansAvance: "Bila mkopo",
    activerPaiementAvance: "Washa malipo ya mkopo",
    montantAvance: "Kiasi cha mkopo (KSH)",
    saisirMontant: "Ingiza kiasi",
    fraisNonPayes: "ada zisizolipwa",
    avanceAppliquee: "Mkopo umetumika",
    restePayer: "Iliyobaki kulipa",
    paiementPartiel: "Malipo ya sehemu - kiasi kilichobaki kulipa",
    montantInvalide:
      "Kiasi cha mkopo kilichoingizwa hakiruhusu kufidia ada hii. Tafadhali ingiza kiasi cha mkopo cha juu zaidi.",
    selectionnerTout: "Chagua zote",
    deselecTout: "Ondoa uchaguzi wa zote",
    montantSupTotal:
      "Kiasi cha mkopo kilichoingizwa ni cha juu zaidi kuliko kiasi cha jumla cha ada za kulipa. kiasi cha mkopo lazima kiwe cha chini au sawa na",
    montantInsuffisant:
      "Kiasi cha mkopo kilichoingizwa hakiruhusu kufidia ada zote. Tafadhali ingiza kiasi cha mkopo cha juu zaidi.",
    scolarite: "Masomo",
    activite: "Shughuli",
  },
  virement: {
    rib: "RIB",
    nom: "Jina la ukoo",
    prenom: "Jina la kwanza",
    etatPaiement: "Hali ya malipo",
    salaire: "Mshahara",
    mois: "Mwezi",
    nbJours: "Idadi ya siku",
    chercher: "Tafuta",
  },
  hr: {
    nbHeures: "Masaa kwa wiki",
    nbJours: "Siku kwa wiki",
    espece: "Fedha taslimu",
    cheque: "Hundi",
    modePaiement: "Njia ya malipo",
    modifierPaiement: "Hariri malipo",
    paiementModifie: "Malipo yamebadilishwa kwa mafanikio",
    paiementSupprime: "Malipo yamefutwa kwa mafanikio",
  },
  recette: {
    fournisseurProfil: "Wasifu wa msambazaji",
    checksDueThisWeek: "Hundi zinazopokea wiki hii",
    anneeScolaire: "Mwaka wa masomo",
    dateAjout: "Tarehe ya kuongeza",
    doneBy: "Imeongezwa na",
    cancelledBy: "Imeghairiwa na",
    actions: "Vitendo",
    detailsReglement: "Maelezo ya malipo",
    infosGenerales: "Taarifa za jumla",
    repartitionMontants: "Mgawanyo wa kiasi",
    lignesReglement: "Safu za malipo",
    periodeHint:
      "Kipindi kinatumika tu kwa miaka ya masomo iliyochaguliwa. Ankara na risiti za miaka mingine hazijumuishwi, hata zikiwa ndani ya tarehe hizo.",
    montantRequis: "Kiasi kinahitajika na lazima kiwe nambari",
    montantCheque: "Kiasi cha hundi",
    montantEspece: "Kiasi cha fedha taslimu",
    montantTraite: "Kiasi cha drafti",
    montantTPE: "Kiasi cha TPE",
    montantVirement: "Kiasi cha uhamishaji",
    montantTotal: "Kiasi cha jumla",
    typePaiement: "Aina ya malipo",
    montant: "Kiasi",
    nom: "Jina la mteja",
    typeRecete: "Aina ya mapato",
    typeReglement: "Aina ya kanuni",
    modePaiement: "Njia ya malipo",
    receiptType: "Aina ya stakabadhi",
    montantHT: "Kiasi bila kodi",
    montantTTC: "Kiasi pamoja na kodi",
    type: "Aina",
    datePaiement: "Tarehe ya malipo",
    numCheque: "Nambari ya hundi",
    imprimer: "Chapisha",
    csv: "CSV",
    tous: "Yote",
    cheque: "Hundi",
    espece: "Fedha taslimu",
    chequeEtEspece: "Hundi na fedha taslimu",
    detailsPaymentDist: "Maelezo ya hundi",
    numero: "Nambari",
    titulaire: "Mmiliki",
    banque: "Benki",
    dateEcheance: "Tarehe ya kulipa",
    chequeMontantTotal: "Jumla ya kiasi cha hundi",
    relatedPayments: "Malipo yanayohusiana",
    fermer: "Funga",
    ok: "Sawa",
    typeJournal: "Aina ya jarida",
    dateDebutPlaceholder: "Chagua tarehe ya kuanza",
    dateFinPlaceholder: "Chagua tarehe ya mwisho",
    selectionnerDate: "Chagua tarehe",
    motCles: "Maneno muhimu",
    chercher: "Tafuta",
    bouillard: "Sanduku la Bouillard",
    annule: "Imeghairiwa",
    personnel: "Mfanyakazi",
    salaire: "Mshahara",
    avance: "Mkopo",
    avanceAPayer: "Mkopo wa kulipa",
    invoicesCanOnlyBeCredited: "Ankara zinaweza tu kupewa mkopo (kuwa na)",
    listeReglements: "Orodha ya malipo",
    nbJours: "Idadi ya siku",
    mois: "Mwezi",
    etatPaiement: "Hali ya malipo",
    virementBancaire: "Uhamishaji wa benki?",
    typeDepense: "Aina ya matumizi",
    date: "Tarehe",
    fournisseur: "Msambazaji",
    numSerie: "Nambari ya mfululizo",
    nomParent: "Jina la mzazi",
    dateAnnulation: "Tarehe ya kughairi",
    facture: "Ankara?",
    impression: "Uchapishaji",
    annulation: "Kughairi",
    paiementQuoi: "Ada",
    selectionnerParent: "Chagua mzazi",
    selectionnerEnfant: "Chagua mtoto",
    titre: "Kichwa",
    valider: "Thibitisha",
    recuPaiement: "Stakabadhi ya malipo",
    facturePaiement: "Ankara ya malipo",
    paiementTotal: "Malipo ya jumla?",
    paiementPour: "Malipo kwa",
    restePayer: "Iliyobaki kulipa",
    payer: "Lipa",
    payerMain: "Lipa sasa?",
    reducRepet: "Punguzo la kurudia",
    reducFact: "Punguzo kwenye ankara hii",
    reducRecu: "Punguzo kwenye stakabadhi hii",
    reducInscri: "Punguzo kwenye usajili",
    reductionMensuel: "Punguzo la kila mwezi",
    fraisInscri: "Ada ya usajili",
    fraisMensuel: "Ada za kila mwezi",
    ajouterPaiement: "Ongeza malipo",
    montantRestant: "Kiasi kilichobaki",
    inscription: "Usajili",
    telephone: "Simu",
    frais: "Ada",
    enfant: "Mtoto",
    activite: "Shughuli",
    tousMois: "Miezi yote",
    montantHTVA: "Kiasi bila VAT",
    nonSeule: "Hapana (mara moja tu)",
    payeQues: "Imelipwa?",
    recus: "Stakabadhi",
    factureTag: "Ankara",
    traite: "Drafti",
    virement: "Uhamishaji wa benki",
    TPE: "TPE",
    avantReduction: "Kabla ya punguzo",
    apresReduction: "Baada ya punguzo",
    reduction: "Punguzo",
    saisirInfoCheque: "Ingiza maelezo ya hundi",
    saisirInfoChequeEtEspace: "Ingiza maelezo ya hundi na fedha taslimu",
    timbreFiscal: "Muhuri wa kodi",
    associatedCheques: "Hundi zinazohusiana",
    associatedTraites: "Drafti zinazohusiana",
    associatedTPE: "TPE zinazohusiana",
    associatedVirements: "Uhamishaji unaohusiana",
    saisirInfoTraite: "Ingiza maelezo ya drafti",
    saisirInfoTPE: "Ingiza maelezo ya TPE",
    versable: "Inaweza kulipwa?",
    transactionId: "Kitambulisho cha muamala",
    nonTransfere: "Haijahamisishwa",
    transfere: "Imehamisishwa",
    paiementEffectue: "Malipo yamefanywa",
    saisirInfoVirement: "Ingiza maelezo ya uhamishaji",
    replacedCheques: "Hundi zilizobadilishwa na fedha taslimu",
    chequeTraite: "Hundi na drafti",
    borderaux: "Hati",
    stat: "Takwimu",
    file: "Faili",
    replacedBy: "Ilibadilishwa na",
    viewFile: "Angalia faili",
    uploadFile: "Pakia faili",
    erreurChargementDonnees: "Hitilafu wakati wa kupakia data",
    selectionnerModePaiement: "Chagua njia ya malipo",
    montantsNonEgaux: "Kiasi kilichoingizwa si sawa na jumla ya kiasi",
    paiementAjoute: "Malipo yameongezwa",
    paiementNonEffectuer: "Malipo hayajafanywa",
    typeFactureFeesRestants:
      "Huwezi kuchagua aina 'Fakturi' wakati ada zilizochaguliwa zina kiasi kilichobaki kulipwa. Tafadhali kwanza maliza kiasi kilichobaki au chagua aina 'Risiti'.",
    sommeMontantsEgal: "Jumla ya kiasi lazima iwe sawa na {amount}",
    montantEgal: "Kiasi lazima kiwe sawa na {amount}",
    parentAnd: "Na",
    nonValid: "Huwezi kuthibitisha malipo ya kiasi sawa na sifuri",
    payWithAvance: "Lipa kwa mapema",
    payWithoutAvance: "Lipa bila mapema",
    selectAdvances: "Chagua mapema yanayotumika",
    parentBalance: "Salio la mzazi",
    advanceAmountLabel: "Kiasi cha mapema",
    advanceAmountPlaceholder: "Kiasi cha mapema",
    remainingToPay: "Kilichobaki kulipa",
    index: "Faharasa",
    payable: "Inalipika",
    nonPayable: "Hailipiki",
    addCheque: "Ongeza hundi",
    chequeAmount: "Kiasi cha hundi",
    cashAmount: "Kiasi cha pesa taslimu",
    incorrectAmountsInfo:
      "Taarifa kuhusu kiasi cha hundi na kiasi cha pesa taslimu si sahihi, tafadhali zirekebishe kabla ya kusambaza kiasi",
    totalAmountMustBe: "Jumla ya kiasi lazima iwe",
    selectFeesToPay: "Chagua ada za kulipa",
    education: "Elimu",
    addDate: "Tarehe ya kuongeza",
    chequeAmountColumn: "Kiasi cha hundi",
    advanceAmountColumn: "Kiasi cha mapema",
    invoiceNumber: "Fakturi N.",
    receiptNumber: "Risiti N.",
    fullName: "Jina na jina la familia",
    child: "Mtoto",
    baseReduction: "punguzo la msingi",
    totalAmountIs: "Jumla ya kiasi ni",
    page: "Ukurasa",
    advanceDebited: "Mapema yamekatwa kutoka salio la mzazi kwa mafanikio",
    sumChequeCashEqual:
      "Jumla ya kiasi cha hundi na pesa taslimu lazima iwe sawa na {amount}",
    paymentMethod: {
      ESPESE: "Fedha taslimu",
      CHEQUE: "Hundi",
      TPE: "TPE",
      TRAITE: "Drafti",
      VIREMENT: "Uhamishaji",
      VERSEMENT: "Amana",
    },
    fluxType: {
      ALIMENTATION_P: "Kujaza sanduku kuu",
      ALIMENTATION_SOUS_CAISSES: "Kujaza masanduku madogo",
      VERSEMENT: "Amana",
      COLLECTE_SOUS_CAISSES: "Kukusanya kutoka masanduku madogo",
      CHEQUE_TRAITE_BANQUE: "Uhamishaji wa hundi/drafti kwa benki",
      CHEQUE_TRAITE_CASH_REPLACEMENT:
        "Kubadilisha hundi/drafti na fedha taslimu",
    },
    stats: {
      financialDashboard: "Takwimu za hundi, drafti na uhamishaji",
      paymentsOverview: "Muhtasari wa malipo na miamala",
      bankStatus: "Hali ya benki",
      generalStatus: "Hali ya jumla",
      rejectedChequesAlert: "Tahadhari: Malipo yaliyokataliwa hayajatatuliwa",
      rejectedPayments: "malipo yaliyokataliwa",
      rejectedPayment: "malipo yaliyokataliwa",
      forTotalAmount: "kwa jumla ya kiasi cha",
      elements: "vipengele",
      transactions: "miamala",
      loadingStatsError: "Kosa la kupakia takwimu",
    },
    pdfGenerationError: "Kosa limetokea wakati wa kuchapisha",
    pdfDailyFeesCount: "{count} vipindi",
    effectuePar: "Limefanywa na",
    parent: "Mzazi",
    nSerie: "Nambari ya mfululizo",
    toutesDates: "Tarehe zote",
    depensesAnnule: "Matumizi yaliyoghairiwa",
    montantTotalText: "Jumla ya kiasi ni",
    tags: "Alama",
    totalSansReduction: "Jumla bila punguzo",
    totalHTVA: "Jumla bila VAT",
    tva: "VAT",
    totalTTC: "Jumla pamoja na kodi",
    dateRangeFrom: "Kutoka",
    dateRangeTo: "hadi",
    csvLabelTypeDepense: "Aina ya matumizi",
    csvLabelDate: "Tarehe",
    csvLabelMontantTTC: "Kiasi pamoja na kodi",
    csvLabelFournisseur: "Mtoaji",
  },

  encaissement: {
    paymentMethod: "Njia ya malipo",
    cash: "Fedha taslimu",
    cheque: "Hundi",
    tpe: "TPE",
    draft: "Drafti",
    transfer: "Uhamishaji",
    cashRegister: "Sanduku",
    selectCashRegister: "Chagua sanduku",
    period: "Kipindi",
    monthlyPayment: "Malipo ya kila mwezi",
    singlePayment: "Malipo moja kwa moja",
    installmentPayment: "Malipo kwa vipande",
    activity: "Shughuli",
    schooling: "Masomo",
    fees: "Ada",
    monthly: "Ya kila mwezi",
    installments: "Kwa vipande",
    stateOfReceipts: "Hali ya stakabadhi",
    creditNote: "Dokezo la mkopo",
    summaryByPaymentMethod: "Muhtasari kwa njia ya malipo",
    totalGeneral: "JUMLA YA JUMLA",
    stateOfUnpaid: "Hali ya yasiyolipwa",
    schoolingStateOfUnpaid: "Masomo: Hali ya yasiyolipwa",
    activitiesStateOfUnpaid: "Shughuli: Hali ya yasiyolipwa",
    invoicesCanOnlyBeCredited: "Ankara zinaweza tu kupewa mkopo (kuwa na)",
    quantite: "Idadi",
    eleve: "Mwanafunzi",
    pdfTableHeaders: {
      clientName: "Jina la mteja",
      telephone: "Simu",
      child: "Mtoto mbali",
      fees: "Ada",
      amount: "Kiasi",
      total: "Jumla",
    },
    pdfTotal: "Jumla",
    pdfCurrencySuffix: "KES",
    pdfFileName: "Hali_ya_yasiyolipwa",
  },
  scolaritePdf: {
    total: "Jumla",
    registration: "Usajili",
    schooling: "Masomo",
    activities: "Shughuli",
    levels: "Viwango",
    allLevels: "Viwango vyote",
    installment: "Kipande {number}",
    legendPaid: "Imelipwa",
    legendUnpaid: "Haijalipwa",
    legendPaidPartially: "Imelipwa kidogo",
    legendPaidWithDiscount: "Imelipwa kwa punguzo",
    totalDiscountAmount: "Jumla ya kiasi cha punguzo",
    totalAdvancePayments: "Jumla ya malipo ya mapema",
  },
  caisse: {
    caisse: "Sanduku",
    SUBCAISSE: "Sanduku dogo",
    BANK: "Benki",
    PRINCIPAL: "Kuu",
    fermerCaisse: "Funga sanduku",
    ouvrirCaisse: "Fungua sanduku",
    caisseOuverte: "Sanduku limefunguliwa kwa mafanikio",
    caisseFermee: "Sanduku limefungwa kwa mafanikio",
    caisseFermeeMessage: "Sanduku limefungwa",
    caisseOuvertureAutomatique:
      "Sanduku litafunguliwa kiotomatiki baada ya malipo",
    erreurOuverture: "Kosa wakati wa kufungua sanduku",
    erreurFermeture: "Kosa wakati wa kufunga sanduku",
    confirmationOuverture: "Uthibitishaji wa kufungua",
    confirmationFermeture: "Uthibitishaji wa kufunga",
    messageOuverture: "Una uhakika unataka kufungua sanduku?",
    messageFermeture: "Una uhakika unataka kufunga sanduku?",
    erreurAlimentation: "Kosa wakati wa kujaza sanduku",
    aucuneCaisseAssigne: "Hakuna sanduku lililogatwa",
    aucuneCaisseAssigneDesc: "Huna sanduku lolote lililogatwa kwa sasa.",
    ajouterCaisse: "Ongeza sanduku",
    modifierCaisse: "Hariri sanduku",
    gererCaisses: "Simamia masanduku",
    detailsCaisse: "Maelezo ya sanduku",
    proprietaire: "Mmiliki",
    proprietaires: "Wamiliki",
    selectionnerCaisse: "Chagua sanduku",
    toutesLesAnnees: "Miaka yote ya masomo",
    anneeScolaireColonne: "Mwaka wa masomo",
    balance: "Mizani",
    statut: "Hali",
    type: "Aina",
    nom: "Jina",
    reference: "Kumbuka",
    banque: "Benki",
    disponibilite: "Upatikanaji",
    actif: "Hai",
    inactif: "Si hai",
    ouverte: "Limefunguliwa",
    fermee: "Limefungwa",
    enregistrer: "Hifadhi",
    desactiver: "Zima",
    activer: "Washa",
    general: "Ya jumla",
    modifier: "Hariri",
    acces: "Ufikiaji",
    transfers: "Uhamishaji",
    historique: "Historia",
    totalDebits: "Jumla ya madeni",
    totalCredits: "Jumla ya mikopo",
    debit: "Deni",
    credit: "Mkopo",
    nombreCheques: "Idadi ya hundi",
    montantCheques: "Kiasi cha hundi",
    montantTotalCheques: "Jumla ya kiasi cha hundi",
    nombreTraites: "Idadi ya drafti",
    montantTraites: "Kiasi cha drafti",
    montantTotalTraites: "Jumla ya kiasi cha drafti",
    nombreTPE: "Idadi ya TPE",
    montantTPE: "Kiasi cha TPE",
    montantTotalTPE: "Jumla ya kiasi cha TPE",
    nombreVirements: "Idadi ya uhamishaji",
    montantVirements: "Kiasi cha uhamishaji",
    montantTotalVirements: "Jumla ya kiasi cha uhamishaji",
    montantEspeces: "Kiasi cha fedha taslimu",
    alerteGestionTransactions:
      "Usimamizi wa miamala kati ya masanduku unapatikana tu katika wasifu wa sanduku kuu.",
    nomRequis: "Jina linahitajika",
    referenceRequise: "Kumbuka inahitajika",
    typeRequis: "Aina inahitajika",
    nomBanque: "Jina la benki",
    caisseAjouteeSucces: "Sanduku limeongezwa kwa mafanikio",
    erreurAjoutCaisse: "Kosa wakati wa kuongeza sanduku",
    erreurChargementCaisses: "Kosa wakati wa kupakia masanduku",
    erreurChargementCaisse: "Kosa wakati wa kupakia sanduku",
    settings: "Mipangilio",
    label: "Lebo",
    lePorteur: "Mbeba",
    disponibiliteUpper: "UPATIKANAJI",
    typeUpper: "AINA",
    statutUpper: "HALI",
    actions: "VITENDO",
    caisseModifieeSucces: "Sanduku limeharirishwa kwa mafanikio",
    erreurModificationCaisse: "Kosa wakati wa kuhariri sanduku",
    caisseDesactiveeSucces: "Sanduku limezimwa kwa mafanikio",
    erreurDesactivationCaisse: "Kosa wakati wa kuzima sanduku",
    caisseActiveeSucces: "Sanduku limewashwa kwa mafanikio",
    erreurActivationCaisse: "Kosa wakati wa kuwasha sanduku",
    utilisateursAutorises: "Watumiaji walioruhusiwa",
    accesALaCaisse: "Ufikiaji wa sanduku",
    selectionnerUtilisateur: "Chagua mtumiaji",
    roles: "Majukumu",
    lire: "SOMA",
    ecrire: "ANDIKA",
    proprietaireRole: "MMILIKI",
    roleDepense: "MATUMIZI",
    roleDepenseEncaissement: "Matumizi — mapato (risiti, noti za mkopo)",
    ajouterUtilisateur: "Ongeza mtumiaji",
    enregistrerAcces: "Hifadhi ufikiaji",
    veuillezRemplirChamps: "Tafadhali jaza sehemu zote zinazohitajika",
    exactementUnProprietaire: "Lazima iwe na mmiliki mmoja tu (MMILIKI)",
    auMoinsUnProprietaire: "Sanduku lazima liwe na angalau mmiliki mmoja (MMILIKI)",
    utilisateurEnDouble: "Mtumiaji anaweza kuorodheshwa mara moja tu kwenye ufikiaji",
    accesMisAJour: "Ufikiaji umesasishwa",
    erreurMiseAJourAcces: "Kosa wakati wa kusasisha ufikiaji",
    erreurChargementUtilisateurs: "Kosa wakati wa kupakia watumiaji",
    nouveauTransfert: "Uhamishaji mpya",
    reglesCollectePartielle: "Kanuni za ukusanyaji",
    montantDemande: "Kiasi kilichoombwa",
    especesDisponibles: "Pesa taslimu zilizopo",
    collectePartielleEspecesUniquement:
      "Kiasi kilichoombwa kinazidi pesa taslimu zilizopo.",
    collecteTotaleTousModes:
      "Ukusanyaji kamili unaweza kujumuisha aina zote za malipo bila kizuizi.",
    modesNonEspecesCollecteTotale:
      "TPE na aina nyingine za malipo haziwezi kukusanywa kwa sehemu. Lazima zikusanywe kikamilifu.",
    pourMontantPrecis: "Ili kupata kiasi maalum",
    etapeCollecterTout:
      "Kusanya salio lote kwa kutumia “Kusanya yote”.",
    etapeTransfererMontant:
      "Kisha hamisha kiasi unachotaka kwenda kwenye sanduku dogo.",
    typeDeFlux: "Aina ya mtiririko",
    libelle: "Lebo",
    montant: "Kiasi",
    toutCollecterBtn: "Kusanya yote",
    veillezSelectionnerTypeFlux:
      "Tafadhali chagua kwanza aina ya mtiririko ili kuendelea kuingiza uhamishaji.",
    veillezSelectionnerTypeFluxMessage: "Tafadhali chagua aina ya mtiririko",
    veillezSaisirLibelle: "Tafadhali ingiza lebo",
    veillezSaisirMontant: "Tafadhali ingiza kiasi",
    selectionnerTypeAlimentation: "Chagua aina ya kujaza",
    veillezSelectionnerType: "Tafadhali chagua aina",
    caisseSource: "Sanduku la chanzo",
    caisseDestination: "Sanduku la ufikiaji",
    selectionnerCaisseSource: "Chagua sanduku la chanzo",
    selectionnerCaisseDestination: "Chagua sanduku la ufikiaji",
    veillezSelectionnerCaisseSource: "Tafadhali chagua sanduku la chanzo",
    veillezSelectionnerCaisseDestination:
      "Tafadhali chagua sanduku la ufikiaji",
    commentaire: "Maoni",
    ajouterCommentaire: "Ongeza maoni (si lazima)",
    commentaireMaxCaracteres: "Maoni yasipashavuka herufi 500",
    paymentsEffectues: "Malipo yaliyofanywa",
    valider: "Thibitisha",
    transactionsDeLaCaisse: "Miamala ya sanduku",
    alimentationEffectueeSucces: "Kujaza kumefanyika kwa mafanikio",
    alimentationCaissePrincipale: "Kujaza sanduku kuu",
    alimentationSousCaisses: "Kujaza masanduku madogo",
    versement: "Amana",
    collecteSousCaisses: "Kukusanya kutoka masanduku madogo",
    caisseBanque: "Sanduku la benki",
    augmentationCapital: "Kuongeza mtaji",
    fonds: "Fedha",
    historiqueTransactions: "Historia ya miamala",
    dateColonne: "Tarehe",
    typeDeFluxColonne: "Aina ya mtiririko",
    montantColonne: "Kiasi",
    sourceColonne: "Chanzo",
    destinationColonne: "Ufikiaji",
    utilisateurColonne: "Mtumiaji",
    actionsColonne: "Vitendo",
    details: "Maelezo",
    detailsTransaction: "Maelezo ya muamala",
    utilisateurTransaction: "Mtumiaji",
    typeDeCollecte: "Aina ya ukusanyaji",
    totale: "Jumla",
    partielle: "Sehemu",
    etatCaisses: "Hali ya masanduku wakati wa muamala",
    etatCaisseSource: "Hali ya sanduku la chanzo",
    etatCaisseDestination: "Hali ya sanduku la ufikiaji",
    erreurChargementTransactions: "Kosa wakati wa kupakia miamala",
    erreurRecuperationSolde: "Kosa wakati wa kupata mizani ya sanduku",
    transactions: "Miamala",
    erreurChargementStatistiques: "Kosa wakati wa kupakia takwimu",
    nombrePaiementEspeces: "Idadi ya malipo ya fedha taslimu",
    montantTotalPaiementEspeces: "Jumla ya kiasi cha malipo ya fedha taslimu",
    nombrePaiementTPE: "Idadi ya malipo ya TPE",
    montantTotalPaiementTPE: "Jumla ya kiasi cha malipo ya TPE",
    typeEncaissement: "Mapato",
    typeInverseEncaissement: "Mapato ya kinyume",
    typeAvoirCredit: "Mkopo wa muuzaji (Avoir)",
    inverseDetailMissing:
      "Hakuna ratiba ya mapokeo iliyounganishwa na malipo haya.",
    typeDecaissement: "Matumizi",
    typeColonne: "Aina",
    descriptionColonne: "Maelezo",
    journalCaisseTitle: "Jarida la Sanduku",
    dateImpression: "Tarehe ya kuchapisha",
    dateHeure: "Tarehe na saa",
    touteLaPeriode: "Kipindi chote",
    statutCollecte: "Hali ya ukusanyaji",
    totalRecettes: "Jumla ya mapato",
    totalDepenses: "Jumla ya matumizi",
    balanceTable: "Mizani",
    totalEncaissements: "Jumla ya mapato",
    totalDecaissements: "Jumla ya matumizi",
    facturesAnnulees: "Ankara / risiti zilizoghairiwa",
    depenseLabel: "Malipo ya gharama",
    beneficiary: "Mfaidika",
  },
  tresorerie: {
    chequeTraitePdf: "sheki-nyandiko",
    bordereauPdf: "Inyemezabwishyu",
    avoirs: "Kuwa na",
    chequesTraites: "Hundi na drafti",
    bordereaux: "Hati za amana",
    statistiques: "Takwimu",
    listeReglementAnnule: "Orodha ya kanuni zilizoghairiwa",
    recherche: "Utafutaji wa jumla",
    type: "Aina",
    statut: "Hali",
    statutDepot: "Hali ya amana",
    numero: "Nambari",
    description: "Maelezo",
    montant: "Kiasi",
    date: "Tarehe",
    dateCreation: "Tarehe ya kuunda",
    dateDepotPrevue: "Tarehe ya amana iliyotarajiwa",
    dateDepotEffective: "Tarehe ya amana halisi",
    caisse: "Sanduku",
    banque: "Benki",
    titulaire: "Mmiliki",
    note: "Dokezo",
    selectionnerType: "Chagua aina",
    filtrerParNom: "Chuja kwa jina",
    recherchreParNumeroDescription: "Tafuta kwa nambari au maelezo",
    statutBanque: "Hali ya benki",
    statutGeneral: "Hali ya jumla",
    statutDuDepot: "Hali ya amana",
    statutDuBordereau: "Hali ya hati ya amana",
    selectionnerTypeBordereau: "Chagua aina ya hati ya amana",
    dateDepotPrevuePlaceholder: "Tarehe ya amana iliyotarajiwa",
    dateDepotEffectivePlaceholder: "Tarehe ya amana halisi",
    nomTitulaire: "Jina la mmiliki",
    noteOptionnelle: "Dokezo la hiari",
    descriptionBordereau: "Maelezo ya hati ya amana",
    selectionnerCaisse: "Chagua sanduku",
    nouveauBordereau: "Hati mpya ya amana",
    toutSelectionner: "Chagua vyote",
    toutDeselectionner: "Ondoa vyote",
    modifier: "Hariri",
    supprimer: "Futa",
    voir: "Ona",
    details: "Maelezo",
    gererCheques: "Simamia hundi",
    enAttente: "Inasubiri",
    valide: "Imethibitishwa",
    rejete: "Imekataliwa",
    nonDepose: "Haijawekwa amana",
    depose: "Imewekwa amana",
    traite: "Imesindika",
    annulation: "Kughairi",
    avoir: "Kuwa na",
    cheque: "Hundi",
    traiteType: "Drafti",
    numSerie: "Nambari ya mfululizo",
    nomParent: "Jina la mzazi",
    nomClient: "Jina la mteja",
    typeReglement: "Aina ya kanuni",
    facture: "Imeangarwa",
    dateAnnulation: "Tarehe ya kughairi",
    annulePar: "Imeghairiwa na",
    typesReglement: "Aina za kanuni",
    anneeScolaire: "Mwaka wa masomo",
    detailsBordereau: "Maelezo ya hati ya amana",
    modifierBordereau: "Hariri hati ya amana",
    creerBordereau: "Unda hati ya amana",
    modifierCheque: "Hariri hundi",
    gestionCheques: "Usimamizi wa hundi",
    oui: "Ndiyo",
    non: "Hapana",
    erreurChargementDonnees: "Kosa wakati wa kupakia data",
    erreurSauvegarde: "Kosa wakati wa kuhifadhi",
    erreurSuppression: "Kosa wakati wa kufuta",
    erreurCreation: "Kosa wakati wa kuunda",
    bordereau: {
      creeSucces: "Hati ya amana imeundwa kwa mafanikio",
      modifieSucces: "Hati ya amana imeharirishwa kwa mafanikio",
      supprimeSucces: "Hati ya amana imefutwa kwa mafanikio",
    },
    verificationPermissions: "Inaverifikasiya ruhusa...",
    aucunAcces: "Huna ufikiaji wa tab yoyote katika sehemu hii.",
    pasAccesOnglet: "Huna ufikiaji wa tab hii",
    reglementsAnnules: "Kanuni zilizoghairiwa",
    exportCSV: "Hamisha CSV",
    rechercherCheques: "Tafuta hundi",
    rechercherTraites: "Tafuta drafti",
    periode: "Kipindi",
    factureLabel: "Ankara",
    espece: "Fedha taslimu",
    remplacerParEspece: "Badilisha na fedha taslimu",
    confirmationRemplacement:
      "Una uhakika unataka kubadilisha hundi {numero} na malipo ya fedha taslimu ya {montant}?",
    chequeRemplaceSucces: "Hundi imebadilishwa na fedha taslimu kwa mafanikio",
    erreurRemplacementCheque: "Kosa wakati wa kubadilisha hundi",
    chequeNonEligible: "Hundi haistahili kubadilishwa",
    chequeNonTrouve: "Hundi haipatikani",
    remplacementChequeNote:
      "Kubadilisha hundi {numero} na malipo ya fedha taslimu",
    elements: "vipengele",
    sur: "juu ya",
    modifierLe: "Hariri",
    numeroChequeTraite: "Nambari ya hundi/drafti",
    dateEcheance: "Tarehe ya kulipa",
    informationsNonModifiables: "Maelezo yasiyoweza kubadilishwa",
    modification: "Inaharirishwa...",
    numeroRequis: "Nambari inahitajika",
    banqueRequis: "Benki inahitajika",
    dateEcheanceRequis: "Tarehe ya kulipa inahitajika",
    titulaireRequis: "Mmiliki anahitajika",
    virement: "Uhamishaji",
    actif: "Hai",
    inactif: "Si hai",
    chequeModifieSucces: "Hundi imeharirishwa kwa mafanikio",
    erreurModification: "Kosa wakati wa kuharirishwa",
    cheques: "Hundi",
    traites: "Drafti",
    chequesPluriel: "hundi",
    traitesPluriel: "drafti",
    valides: "zilizothibitishwa",
    gererLesCheques: "Simamia hundi",
    aucunCheque: "Hakuna hundi",
    confirmationSuppressionBordereau:
      "Una uhakika unataka kufuta hati hii ya amana?",
    impossibleSupprimerBordereau:
      "Haiwezekani kufuta hati ya amana yenye hundi zilizothibitishwa",
    selectionnes: "zilizochaguliwa",
    aucunSelectionne: "Hakuna",
    modificationEnCours: "Inaharirishwa...",
    creationEnCours: "Inaundwa...",
    creer: "Unda",
    typeBordereauRequis: "Aina ya hati ya amana inahitajika",
    statutRequis: "Hali inahitajika",
    caisseRequise: "Sanduku linahitajika",
    auMoinsUnElementRequis: "Angalau kipengele kimoja kinahitajika",
    num: "Nambari",
    rib: "RIB",
    erreurChargementCaisses: "Kosa wakati wa kupakia masanduku",
    erreurChargementElements: "Kosa wakati wa kupakia vipengele",
    erreurCreationBordereau: "Kosa wakati wa kuunda hati ya amana",
    rechercheParNumeroTitulaireBanque: "Tafuta kwa nambari, mmiliki, benki...",
    rechercheParNumeroBanque: "Tafuta kwa nambari, benki...",
    informationsDuBordereau: "Maelezo ya hati ya amana",
    total: "Jumla",
    montantTotal: "Kiasi cha jumla",
    listeDes: "Orodha ya",
    aucuneDescription: "Hakuna maelezo",
    fermer: "Funga",
    erreurGenerationBordereau: "Kosa la kuzalisha hati ya amana.",
    chequesTraites: "Hundi na drafti",
    echeance: "Tarehe ya kulipa",
    nombreTotalElements: "Jumla ya idadi ya vipengele",
    repartitionParType: "Ugawaji kwa aina",
    repartitionParStatut: "Ugawaji kwa hali",
    virements: "Uhamishaji wa fedha",
    pdfGeneratedSuccessfully: "PDF imezalishwa kwa mafanikio",
    pdfGenerationError: "Kosa la kuzalisha PDF",
    summary: "Muhtasari",
    bordereaux: "Hati za amana",
    nombreBordereaux: "Idadi ya hati za amana",
    nombreTotalCheques: "Jumla ya idadi ya hundi",
    nombreCheques: "Idadi ya hundi",
    montantTTC: "Kiasi pamoja na kodi",
    creationDate: "Tarehe ya Uumbaji",
    numberOfElements: "Idadi ya Vipengele",
    actions: "Vitendo",
    errorLoadingBordereaux: "Hitilafu wakati wa kupakia bordereaux",
    errorDuringDeletion: "Hitilafu wakati wa kufuta",
    errorRetrievingBordereau: "Hitilafu wakati wa kupata bordereau",
    errorGeneratingPdf: "Hitilafu wakati wa kutengeneza PDF",
    erreurTelechargementCSV: "Hitilafu wakati wa kupakua CSV",
    borderaux: "Hati za amana",
  },
  choisir: {
    enseignant: "Chagua mwalimu",
    matiere: "Chagua somo",
    salle: "Chagua chumba",
    duree: "Chagua muda",
    classe: "Chagua darasa",
    repas: "Chagua aina ya chakula",
    jour: "Chagua siku za chakula hiki",
    dateDebut: "Chagua tarehe ya kuanza",
    dateFin: "Chagua tarehe ya mwisho",
    niveauClass: "Chagua kiwango cha darasa",
    template: "kiolezo ",
  },
  requis: {
    nameActivite: "Izina ry'igikorwa inahitajika",
    template: "Kiolezo kinahitajika",
    smsContenue: "Maudhui ya ujumbe wako yanahitajika.",
    message: "Ujumbe unahitajika",
    required: "inahitajika",
    coefficient: "Mkazo unahitajika",
    red: "Weka punguzo kuwa sifuri kama hutaki kuongeza punguzo",
    activite: "Shughuli inahitajika",
    cnss: "CNSS inahitajika",
    rib: "RIB inahitajika",
    specialite: "Utaalamu unahitajika",
    niveau: "Kiwango kinahitajika",
    etatCivil: "Hali ya ndoa inahitajika",
    jourSemaine: "Siku za wiki zinahitajika",
    tauxHoraire: "Kiwango cha saa kinahitajika",
    dateEntretien: "Tarehe ya mahojiano inahitajika",
    matiere: "Somo linahitajika",
    typeContrat: "Aina ya mkataba inahitajika",
    qualification: "Sifa inahitajika",
    telephone: "Nambari ya simu lazima iwe na nambari 10",
    telephoneKE: "Nambari ya simu lazima iwe na nambari 10",
    phoneRequired: "Nambari ya simu inahitajika",
    birthCertificate: "Kitambulisho cha kuzaliwa linahitajika",
    cin01:
      "Nambari ya kitambulisho cha kitaifa lazima iwe na tarakimu 8 na ianze na 0 au 1",
    cin8: "Nambari ya kitambulisho lazima iwe na nambari 8",
    cin: "Nambari ya kitambulisho cha kitaifa inahitajika",
    pourcentage: "Asilimia ya punguzo inahitajika",
    dinar: "Kiasi cha shilingi kinahitajika",
    order: "Mpangilio unahitajika",
    mail: "Ingiza barua pepe yako!",
    mois: "Mwezi unahitajika",
    mdp: "Nywila inahitajika",
    noWhitespace: "Sehemu haiwezi kuwa na nafasi",
    alphabeticOnly: "Lazima iwe na herufi tu na nafasi",
    confirmation: "Uthibitishaji wa nywila unahitajika",
    username: "Jina la mtumiaji linahitajika",
    usernameEmail: "Jina la mtumiaji au barua pepe linahitajika",
    titre: "Kichwa kinahitajika",
    categorie: "Jamii inahitajika",
    designation: "Uteuzi unahitajika",
    cible: "Lengo linahitajika",
    salaire: "Mshahara unahitajika",
    role: "Jukumu linahitajika",
    repas: "Ingiza jina la chakula",
    depense: "Aina ya matumizi inahitajika",
    fournisseur: "Msambazaji anahitajika",
    nom: "Jina linahitajika",
    min: "Alama ya chini inahitajika",
    max: "Alama ya juu inahitajika",
    nomPersonnel: "Jina la mfanyakazi linahitajika",
    date: "Tarehe inahitajika",
    selection: "Uchaguzi wa wazazi unahitajika",
    nomPere: "Jina la baba linahitajika",
    nomMere: "Jina la mama linahitajika",
    prenom: "Jina la kwanza linahitajika",
    prenomPere: "Jina la kwanza la baba linahitajika",
    prenomMere: "Jina la kwanza la mama linahitajika",
    telPere: "Simu ya baba inahitajika",
    telMere: "Simu ya mama inahitajika",
    email: "Barua pepe si sahihi!",
    carac: "Angalau herufi 4 kwa nywila",
    genre: "Jinsia inahitajika",
    adresse: "Anwani inahitajika",
    service: "Huduma lazima ichaguliwe",
    fraisInscri: "Ada ya usajili inahitajika",
    fraisMensuel: "Ada za kila mwezi zinahitajika",
    ajoutLogo: "Ongeza nembo mpya",
    dateNaissance: "Tarehe ya kuzaliwa inahitajika",
    nbJours: "Idadi ya siku inahitajika",
    montant: "Kiasi kinahitajika na lazima kiwe nambari",
    modePaiement: "Njia ya malipo inahitajika",
    avance: "Mkopo unahitajika",
    selectionEnfant: "Uchaguzi wa mtoto unahitajika",
    etatPaiement: "Hali ya malipo inahitajika",
    specification: "Ubainishi unahitajika",
    observation: "Uchunguzi unahitajika",
    reductionInscro:
      "Punguzo kwenye ada ya usajili linahitajika (weka sifuri kama hakuna punguzo)",
    reductionMensuel:
      "Punguzo kwenye ada za kila mwezi linahitajika (weka sifuri kama hakuna punguzo)",
    supp: "Una uhakika unataka kufuta?",
    supp2:
      "Ukifuta mwanafunzi hali yake ya malipo itasasishwa, miezi yote isiyolipwa itafutwa. Una uhakika unataka kufuta?",
    annu: "Ukighairi usajili, hali ya usajili wa mwanafunzi kwa mwaka wa sasa wa masomo itasasishwa. Una uhakika unataka kughairi usajili?",

    appreciation: "Kuthamini kunahitajika",
    subject: "Mada inahitajika",
    grade: "Daraja linahitajika",
    reqcoverpicture: "Picha ya jalada inahitajika",
    reqdescription: "Maelezo yanahitajika",
    reqtags: "Angalau lebo moja inahitajika",
    fraisParJour: "Ada za kila siku zinahitajika.",
  },
  phoneInput: {
    countryCodeLabel: "Msimbo wa nchi",
    countrySelectorError: "Chagua nchi",
    phoneNumberLabel: "Nambari ya simu",
    example: "Mfano:",
    descriptionTN: "Nambari 8 (Tunisia)",
    descriptionKE: "Nambari 10 (Kenya)",
    required: "Nambari ya simu inahitajika",
  },
  success: {
    niveauAjout: "Kiwango kimeongezwa",
    niveauxCrees: "Viwango vimeundwa",
    niveauMSA: "Kiwango kimesasishwa",
    niveauSupp: "Kiwango kimefutwa",
    appreciationOptionAjout: "Thamani imeongezwa",
    appreciationOptionMSA: "Thamani imesasishwa",
    appreciationOptionSupp: "Thamani imefutwa",
    certificationAjout: "Cheti kimeongezwa",
    certificationMSA: "Cheti kimesasishwa",
    certificationSupp: "Cheti kimefutwa",
    modification: " imesasishwa kwa mafanikio",
    suppression: " imefutwa kwa mafanikio",
    ajout: "imeongezwa kwa mafanikio",
    decisionConseilAjout: "Uamuzi umeongezwa",
    decisionConseilMSA: "Uamuzi umesasishwa",
    decisionConseilSupp: "Uamuzi umefutwa",
    decisionConseilApplied: "Uamuzi wa baraza umetumika kwa mafanikio",
    noteEnregistre: "Alama imehifadhiwa kwa mafanikio",
    noteToutesEnregistre: "Alama zote zimehifadhiwa kwa mafanikio",
    noteRemoved: "Alama imeondolewa kwa mafanikio",
    notesRemoved: "Alama zimeondolewa kwa mafanikio",
    smsEnvoye: "SMS imetumwa kwa mafanikio",
    modificationsEnseignantsEffectue:
      "Mabadiliko ya walimu yamekamilika kwa mafanikio!!",
    modificationsMatieresEffectue:
      "Mabadiliko ya masomo yamekamilika kwa mafanikio!!",
    operationEffectue: "Operesheni imekamilika kwa mafanikio",
    cacheAjout: "Muhuri umepakiwa",
    cacheSupp: "Muhuri umefutwa",
    inscriAjout: "Usajili umeongezwa",
    eleveInscrit: "wanafunzi wamejisajili kwa mafanikio",
    inscriSupp: "Usajili umefutwa",
    inscriAnnule: "Usajili umekatizwa",
    submoduleAdded: "Kipengele kidogo kimeongezwa",
    eleveRective: "Mwanafunzi amerudishwa",
    pubAjout: "Chapisho limeongezwa",
    pubModif: "Chapisho limesasishwa",
    pubSupp: "Chapisho limehifadhiwa",
    photoAjout: "Picha imeongezwa",
    compte: "Aina ya akaunti imeongezwa",
    autorisationMSA: "Ruhusa imesasishwa",
    autorisationSupp: "Ruhusa imefutwa",
    utilisateurAjout: "Mtumiaji ameongezwa",
    utilisateurMSA: "Mtumiaji amebadilishwa",
    utilisateurSupp: "Mtumiaji amehifadhiwa",
    utilisateurDesac: "Mtumiaji amezimwa",
    utilisateurActiv: "Mtumiaji amewashwa",
    repasAjout: "Chakula kimeongezwa",
    repasMSA: "Chakula kimebadilishwa",
    repasSupp: "Chakula kimefutwa",
    depenseMSA: "Matumizi yamesasishwa",
    depenseSupp: "Matumizi yamehifadhiwa",
    reglementSupp: "Malipo yameondolewa",
    paiementAjout: "Malipo yameongezwa",
    paiementModifie: "Malipo yamebadilishwa kwa mafanikio",
    paiementSupprime: "Malipo yamefutwa kwa mafanikio",
    subsubjectAdded: "Somo dogo limeongezwa",
    dossierMSA: "Faili imesasishwa",
    dossierSupp: "Faili imeondolewa",
    buildingMSA: "Jengo {name} limesasishwa kwa mafanikio",
    eleveAjout: "Mwanafunzi ameongezwa",
    eleveMSA: "Mwanafunzi amesasishwa",
    bulletinMSA: "Ripoti ya shule imesasishwa",
    typeDepenseAjout: "Aina ya matumizi imeongezwa",
    typeDepenseModif: "Aina ya matumizi imesasishwa",
    typeDepenseArchiv: "Aina ya matumizi imehifadhiwa",
    fournisseurAjout: "Msambazaji ameongezwa",
    fournisseurMSA: "Msambazaji amesasishwa",
    fournisseurArchiv: "Msambazaji amehifadhiwa",
    typeRecetteMSA: "Aina ya mapato imesasishwa",
    typeRecetteAjout: "Aina ya mapato imeongezwa",
    typeRecetteArchiv: "Aina ya mapato imehifadhiwa",
    activiteAjout: "Shughuli imeongezwa",
    activiteSupp: "Shughuli imehifadhiwa",
    activiteMSA: "Shughuli imesasishwa",
    emploiMSA: "Ratiba imesasishwa",
    accessRevoked: "Ufikiaji umeondolewa kwa mafanikio",
    logoMSA: "Nembo limebadilishwa",
    fileUploadedPleaseSave:
      "Faili {name} imepakiwa kwa mafanikio, tafadhali hifadhi!",
    seanceAjout: "Kipindi kimeongezwa",
    seanceMSA: "Kipindi kimesasishwa",
    seanceSupp: "Kipindi kimehifadhiwa",
    punitionValid: "Adhabu imekaguliwa",
    disciplineValid: "Nidhamu ya mwanafunzi imekaguliwa",
    personnelAjout: "Wafanyakazi wameongezwa",
    personnelMSA: "Wafanyakazi wamesasishwa",
    personnelSupp: "Wafanyakazi wamehifadhiwa",
    personnelNonSupp: "Wafanyakazi hawajafutwa",
    enseignantAjout: "Mwalimu ameongezwa",
    enseignantMSA: "Mwalimu amesasishwa",
    enseignantSupp: "Mwalimu amefutwa",
    enseignantNonSupp: "Mwalimu hajafutwa",
    classeAjout: "Darasa limeongezwa",
    classeMSA: "Darasa limesasishwa",
    classeSupp: "Darasa limehifadhiwa",
    moduleSupp: "Kipengele kimeondolewa",
    typePunitionAjout: "Aina ya adhabu imeongezwa",
    typePunitionMSA: "Aina ya adhabu imesasishwa",
    typePunitionArchiv: "Aina ya adhabu imehifadhiwa",
    typeStudentDisciplineAjout: "Aina ya nidhamu ya mwanafunzi imeongezwa",
    typeStudentDisciplineMSA: "Aina ya nidhamu ya mwanafunzi imesasishwa",
    typeStudentDisciplineArchiv: "Aina ya nidhamu ya mwanafunzi imehifadhiwa",
    typeQualificationAjout: "Aina ya sifa imeongezwa",
    typeQualificationMSA: "Aina ya sifa imesasishwa",
    typeQualificationArchiv: "Aina ya sifa imehifadhiwa",
    matiereAjout: "Somo limeongezwa",
    matiereMSA: "Somo limesasishwa",
    matiereSupp: "Somo limehifadhiwa",
    anneeAjout: "Mwaka wa shule umeongezwa",
    anneeMSA: "Mwaka wa shule umesasishwa",
    anneeSupp: "Mwaka wa shule umehifadhiwa",
    serviceAjout: "Huduma imeongezwa",
    serviceMSA: "Huduma imesasishwa",
    serviceSupp: "Huduma imefutwa",
    salleAjout: "Chumba kimeongezwa",
    salleMSA: "Chumba kimesasishwa",
    salleSupp: "Chumba kimehifadhiwa",
    eleveMSA: "Mwanafunzi amesasishwa",
    eleveSupp: "Mwanafunzi amehifadhiwa",
    eleveSupp2: "Mwanafunzi amefutwa",
    parentAjout: "Mzazi ameongezwa",
    parentMSA: "Mzazi amesasishwa",
    parentSupp: "Mzazi amehifadhiwa",
    eleveAjoutAuClasse: "Mwanafunzi ameongezwa kwa darasa kwa mafanikio!",
    eleveDemeangeAuClasse: "Mwanafunzi amehamishwa kwa {name} kwa mafanikio",
    InscriptionAnnulee: "Usajili umekatizwa kwa mafanikio.",
    imageTelecharge: "Faili {name} imepakiwa kwa mafanikio.",
    videoAdded: "Video {name} imeongezwa kwa mafanikio",
    conseillerPedagogiqueAjout: "Mshauri ameongezwa",
    conseillerPedagogiqueMSA: "Mshauri amesasishwa",
    newsValidationSettingUpdated:
      "Uthibitishaji wa kiotomatiki wa habari umevipokea mabadiliko",
    conseillerPedagogiqueSupp: "Mshauri amehifadhiwa",
    productUpdate: "Bidhaa imesasishwa kwa mafanikio.",
    fetchCommands: "Inapakia amri...",
    commandSupp: "Amri imefutwa kwa mafanikio.",
    commandUpdate: "Amri imesasishwa kwa mafanikio.",
    prodSupp: "Umezima bidhaa kwa mafanikio",
    prodReactivate: "Bidhaa imerudishwa kwa mafanikio",
    libraryAddDoc: "Hati imeongezwa",
    libraryUpdateDoc: "Hati imesasishwa",
    libraryArchiveDoc: "Hati imehifadhiwa",
    libraryReactiveDoc: "Hati imerudishwa",
    moduleOrderUpdated: "Utaratibu wa vipengele umesasishwa kwa mafanikio",
    studentPhotoUploaded: "Picha ya mwanafunzi imepakiwa kwa mafanikio",
    studentPhotoDeleted: "Picha ya mwanafunzi imefutwa kwa mafanikio",
    studentExemptionRemoved: "Ruhusa ya mwanafunzi imeondolewa kwa mafanikio",
    studentExempted: "Mwanafunzi ameruhusiwa kwa mafanikio",
    sessionsUpdated: "Vipindi {count} vimesasishwa kwa mafanikio",
    sessionsCanceled: "Vipindi {count} vimekatizwa kwa mafanikio",
    sessionsRestored: "Vipindi {count} vimerudishwa kwa mafanikio",
    recurringSessionsDeleted:
      "Vipindi vya kurudia {count} vimefutwa kwa mafanikio",
    changementEffectue: "Mabadiliko yamekamilika kwa mafanikio",
    parentMisAJour: "Taarifa za mzazi zimesasishwa",
    groupUpdated: "Kikundi kimesasishwa",
    studentRemovedFromGroup: "Mwanafunzi ameondolewa kutoka kikundi",
    excelGenerated: "Faili la Excel limezalishwa kwa mafanikio.",
  },
  error: {
    oops: "Yoo! Habayeho ikosa",
    dateFinPlusGrande:
      "Tarehe ya mwisho lazima iwe kubwa kuliko tarehe ya mwanzo",
    impoAjoutAppreciationOption: "Ntibishobotse kongera ishimwe",
    aucCert: "Nta byemezo byabonetse",
    impoAjoutCertification: "Ntibishobotse kongera icyemezo",
    impoEnregistrerVide: "Ntushobora kubika agaciro karimo ubusa",
    fetchError: "Ikosa ryo gupakurura amakuru",
    fetchingStudents: "Ikosa ryo gupakurura urutonde rw'abanyeshuri",
    invalidNote: "Amanota atemewe! Agomba kuba hagati ya 0 na 20",
    smsFormat: "Imiterere siyo, nimero zigomba gutandukanywa na (,)!",
    noPhoneNumber: "Nta numero",
    invalid: "siyo",
    notEnrolled: "Ntiyiyandikishije",
    noStudentFound: "Nta mwana wabonetse",
    noClassFound: "Hakuna darasa lililopatikana kwa kiwango kilichochaguliwa",
    phoneNumberExists: "Nimero imaze kuboneka muri sisitemu",
    eleveDejaInscritPourMois:
      "Umwana yamaze kwiyandikisha kuri aya mezi mwahisemo",
    impoModifiEleve: "Ntibishobotse kuvugurura umwana",
    impoModifi: "Ntibishobotse kuvugurura",
    eleveNonAjoutAuClasse:
      "Kwandikisha ntibyabayeho, banza usambure iyandikwa ubone gushyira umwana mu yindi shuri!",
    InscriptionNonModifi:
      "Kwandikisha ntibyavuguruwe, banza usambure iyandikwa ubone gushyira umwana mu ishuri rishya!",
    matiereNonAffecte: "Ibigo byose n'amanota yabyo bigomba kuzuzwa!",
    subsubjectNonAffecte: "{subject}: Ibice byose bigomba kuzuzwa!",
    capacite: "Ubushobozi bw'icyumba bwarenze umubare w'abanyeshuri",
    fichiers: "Ushobora kujya ukohereza amafoto JPG, JPEG cyangwa PNG gusa!",
    fileTooLarge: "Ukubwa wa faili lazima uwe chini ya MB 5",
    fichiersPNG: "Ushobora kohereza amafoto ya PNG gusa!",
    fichiersPDFWord:
      "Ushobora kohereza JPG, JPEG, PNG, PDF, cyangwa Word (.doc, .docx) gusa!",
    fileTypeNotAllowed:
      "Wemerewe gusa kohereza amashusho, PDF, amadosiye ya Office (Word, Excel, PowerPoint) n'amashusho (MP4, WebM)",
    onlyPDFAllowed: "Unaweza kupakia faili za PDF tu!",
    onlyImagesAndPDFAllowed:
      "Unaweza kupakia picha (JPEG, PNG, WebP) au faili za PDF tu!",
    onlyImagesPDFWordExcel:
      "Unaweza kupakia picha (JPEG, PNG, WebP), PDF, Word, au Excel tu!",
    onlyAudioFilesAllowed:
      "Faili za sauti tu zinaruhusiwa (mf. MP3, WAV, M4A).",
    allowedFileTypes: "Aina za faili zilizoruhusiwa ni: {types}",
    allowedImageTypes: "Aina za picha zilizoruhusiwa ni: {types}",
    classe: "Icyiciro nticyabonetse",
    activite: "Igikorwa nticyabonetse",
    service: "Serivisi ntishobotse kongerwa",
    inscription: "Iyandikwa",
    aucScol: "Nta kwiyandikisha mu ishuri byabonetse",
    aucClasse: "Nta cyiciro cyabonetse",
    aucEleve: "Nta mwana wabonetse",
    aucInscri: "Nta kwandikisha igikorwa byabonetse",
    aucPersonnel: "Nta bakozi babonetse",
    aucService: "Nta serivisi yabonetse",
    aucActivite: "Nta gikorwa kibonetse",
    aucActualite: "Nta makuru abonetse",
    aucRole: "Nta mwanya uboneka",
    aucEtablissement: "Nta kigo kibonetse",
    aucRecette: "Nta bwoko bw'amafaranga bwinjiye bubonetse",
    aucMatiere: "Nta somo ryabonetse",
    aucSubsubject: "Nta gice cy'igikorwa kibonetse",
    aucUser: "Nta muntu wabonetse",
    aucFournisseur: "Nta utanga ibikoresho wabonetse",
    aucDepense: "Nta mafaranga asohoka yabonetse",
    aucQualification: "Nta bwoko bw'ibyiciro bwabonetse",
    aucEnseignant: "Nta mwarimu wabonetse",
    aucAnnee: "Nta mwaka w'ishuri wabonetse",
    aucSalle: "Nta cyumba cyabonetse",
    aucModule: "Nta moderi yabonetse",
    verifier: "Gerageza ijambobanga",
    modif: "Ikosa mu kuvugurura",
    ajout: "Ikosa mu kongera",
    supp: "Ikosa mu gusiba",
    impoInscriSupp: "Ntibishobotse gusiba ubu bwanditsi",
    impoPubAjout: "Ntibishobotse gushyiraho ubutumwa",
    impoPubModif: "Ntibishobotse guhindura ubutumwa",
    impoPubSupp: "Ntibishobotse gusiba ubutumwa",
    impoAjoutType: "Ntibishobotse kongera ubwoko",
    impoAjoutActivite: "Ntibishobotse kongera igikorwa",
    impoAjoutAnnee: "Ntibishobotse kongera umwaka w'ishuri",
    impoAjoutClasse: "Ntibishobotse kongera icyiciro cy'ishuri",
    impoAjoutSalle: "Ntibishobotse kongera icyumba",
    impoAjoutService: "Ntibishobotse kongera serivisi",
    impoAjoutFournisseur: "Ntibishobotse kongera utanga ibikoresho",
    impoAjoutCeType: "Ntibishobotse kongera ubu bwoko",
    impoModifiMatieres: "Ntibishobotse guhindura amasomo",
    impoModifiEnseignants: "Ntibishobotse guhindura abarimu",
    image: "Ifoto igomba kuba munsi ya 5 MB",
    image50: "Amafoto agomba kuba munsi ya 50 MB",
    maxImage: "Umubare ntarengwa w'amafoto ni 15",
    maxFiles: "Umubare ntarengwa w'amadosiye ni 15",
    videoFormat:
      "Aina za video MP4, MOV, AVI, MKV na WebM peke ndizo zinaruhusiwa",
    maxVideos: "Kiwango cha juu cha video 5 kinaruhusiwa",
    videoSize: "Ukubwa wa video lazima uwe chini ya 500MB",
    nonAjoute: "Ntabwo byongewe",
    autorisationNonMSA: "Uburenganzira ntibwavuguruwe",
    autorisationNonSupp: "Uburenganzira ntibusibwe",
    eleveNonMSA: "Umwana ntiyavuguruwe",
    impoTelecharger: "Ntibishobotse gukuramo ifoto",
    dossier: "Ntibishobotse kubona dosiye y'umwana",
    dossierNonMSA: "Dosiye ntiyavuguruwe",
    nonValid: "Ntushobora kwemeza ubwishyu bungana na zeru",
    recetteNonAjoute: "Amafaranga yinjiye ntayongewe",
    recetteNonMSA: "Amafaranga yinjiye ntiyavuguruwe",
    recetteNonSupp: "Amafaranga yinjiye ntayasibwe",
    qualificationNonAjoute: "Icyiciro nticyongerewe",
    qualificationNonMSA: "Icyiciro ntiyavuguruwe",
    qualificationNonSupp: "Icyiciro ntayasibwe",
    serviceNonSupp: "Serivisi ntibusibwe",
    erreur: "Habaye ikibazo",
    depenseNonMSA: "Igurisha ntiyavuguruwe",
    depenseNonSupp: "Igurisha ntirisibwe",
    buildingEchoue: "Ntibishobotse kuvugurura inyubako {name}",
    inscriEchoue: "Iyandikwa iranze",
    personnelNonAjoute: "Umukozi ntiyongerewe",
    personnelNonMSA: "Umukozi ntiyavuguruwe",
    enseignantNonAjoute: "Mwarimu ntiyongerewe",
    enseignantNonMSA: "Mwarimu ntiyavuguruwe",
    listeNonTrouve: "Urutonde rw'abanyeshuri ntirwabonywe",
    anneeNonAjoute: "Umwaka ntiyongewe",
    anneeNonMSA: "Umwaka ntiyavuguruwe",
    punitionNonAjoute: "Igihano ntiyongerewe",
    punitionNonMSA: "Igihano ntiyavuguruwe",
    serviceNonAjoute: "Serivisi ntiyongerewe",
    serviceNonMSA: "Serivisi ntiyavuguruwe",
    depenseNonAjoute: "Igurisha ntiyongerewe",
    depenseNonMSA: "Igurisha ntiyavuguruwe",
    fournisseurNonAjoute: "Umutanga ntashobotse kongerwa",
    fournisseurNonMSA: "Umutanga ntiyavuguruwe",
    fournisseurNonSupp: "Umutanga ntasibwe",
    activiteNonMSA: "Igikorwa ntigishobora kuvugururwa, gerageza kongera!",
    moduleNonAjoute: "Module ntiyongerewe",
    moduleNonMSA: "Module ntiyavuguruwe",
    matiereNonAjoute: "Isomo ntiyongewe",
    matiereNonMSA: "Isomo ntiyavuguruwe",
    activiteNonSupp: "Ntibishobotse gusiba igikorwa",
    classeNonSupp: "Ntibishobotse gusiba icyiciro",
    classeIndis: "Icyiciro ntibiboneka",
    salleIndis: "Icyumba ntibiboneka",
    enseignantIndis: "Mwarimu ntiboneka",
    selectEnseignant: "Hitamo umwarimu",
    selectSeance: "Hitamo isomo",
    teacherConflictFuture:
      "Umwarimu {teacherName} asanzwe ateganyijwe kuri aya masaha n'umunsi mu minsi iri imbere",
    classConflictFuture:
      "Icyiciro {className} cyateganyijwe kuri aya masaha n'umunsi mu minsi iri imbere",
    teacherConflictUpdate:
      "Umwarimu {teacherName} ari kumwe n'abandi kuri aya masaha",
    classConflictUpdate: "Icyiciro {className} cyafashwe kuri aya masaha",
    conflictDetails: "Ibisobanuro by'umwiryane",
    conflictingTeacher: "Umwarimu utavugwaho rumwe",
    conflictingClass: "Icyiciro kitavugwaho rumwe",
    conflictTime: "Igihe",
    conflictDate: "Itariki",
    conflictGroup: "Itsinda",
    conflictWeek: "Icyumweru",
    conflictEndTime: "Isaha yo kurangiza",
    classroomGroupConflict: "Habonetse ikibazo cy'itsinda mu cyumba",
    classroomGroupConflictDesc:
      "Amatsinda atandukanye ntashobora guteganyirizwa icyumba kimwe icyarimwe",
    classroomMixedConflict: "Habonetse ikibazo cyo kuvanga amatsinda mu cyumba",
    classroomMixedConflictDesc:
      "Ntushobora kuvanga amatsinda n'amasomo asanzwe mu cyumba kimwe icyarimwe",
    teacherGroupConflict: "Habonetse ikibazo cy'itsinda kuri mwarimu",
    teacherGroupConflictDesc:
      "Umwarimu ntashobora kwigisha amatsinda atandukanye icyarimwe",
    teacherMixedConflict:
      "Habonetse ikibazo cyo kuvanga amatsinda kuri mwarimu",
    teacherMixedConflictDesc:
      "Ntushobora kuvanga amatsinda n'amasomo asanzwe kuri mwarimu icyarimwe",
    selectClasse: "Hitamo icyiciro",
    sallePriseEntre:
      "Icyumba {room} cyafashwe n'icyiciro {name} hagati ya {start} na {end}",
    classPriseEntre: "Icyiciro {name} gifashwe hagati ya {start} na {end}",
    enseignantEnseigneClasse:
      "Umwarimu {fullname} yigisha icyiciro {name}, isomo {subject} hagati ya {start} na {end}",
    conflictingSessionInfo:
      "Bihura na: {subject} — {teacher} — {className} — {date} {start}-{end}{extra}",
    teacherGroupConflict:
      "Ikibazo cya mwarimu: Ntushobora guteganya amatsinda atandukanye icyarimwe",
    teacherWeekConflict:
      "Ikibazo cya mwarimu: Ntushobora guteganya ibyumweru bitandukanye icyarimwe",
    teacherMixedConflict:
      "Ikibazo cya mwarimu: Ntushobora kuvanga amasomo y'amatsinda n'asanzwe icyarimwe",
    classroomGroupConflict:
      "Ikibazo cy'icyumba: Ntushobora guteganya amatsinda atandukanye icyarimwe",
    classroomWeekConflict:
      "Ikibazo cy'icyumba: Ntushobora guteganya ibyumweru bitandukanye icyarimwe",
    classroomMixedConflict:
      "Ikibazo cy'icyumba: Ntushobora kuvanga amasomo y'amatsinda n'asanzwe icyarimwe",
    teacherGroupConflictDesc:
      "Umwarimu amaze guteganywa mu yandi matsinda kuri iyi saha. Abarimu ntibaba mu matsinda menshi icyarimwe.",
    teacherWeekConflictDesc:
      "Umwarimu amaze guteganywa mu cyumweru (A/B) kuri iyi saha. Ntushobora gushyiraho ibyumweru byinshi kuri mwarimu icyarimwe.",
    teacherMixedConflictDesc:
      "Umwarimu amaze guteganywa mu masomo asanzwe kuri iyi saha. Ntushobora kuvanga amasomo y'amatsinda n'asanzwe.",
    classroomGroupConflictDesc:
      "Icyumba cyamaze guteganywa mu yandi matsinda kuri iyi saha. Amatsinda atandukanye ashobora gukoresha icyumba kimwe.",
    classroomWeekConflictDesc:
      "Icyumba cyamaze guteganywa mu cyumweru (A/B) kuri iyi saha. Ibyumweru bitandukanye bishobora gukoresha icyumba kimwe.",
    classroomMixedConflictDesc:
      "Icyumba cyamaze guteganywa mu masomo asanzwe kuri iyi saha. Ntushobora kuvanga amasomo y'amatsinda n'asanzwe.",
    anneeNonSupp: "Umwaka ntiwashoboye gusibwa",
    utilisateurNonAjoutDiff:
      "Ntibishoboka kongera umukoresha, gerageza izina rindi!",
    conseillerPedagogiqueNonAjoute: "Umujyanama w’uburezi ntiyongewe",
    conseillerPedagogiqueNonMSA: "Umujyanama w’uburezi ntiyavuguruwe",
    conseillerPedagogiqueNonSupp: "Umujyanama w’uburezi ntiyasibwe",
    invalidFormat: "Imiterere y'idosiye ntikwiye",
    maxStudentsReached:
      "Umubare ntarengwa w'abanyeshuri wagezweho. Ongera gris abonnment yawe wongere abanyeshuri.",
    maxUsersReached:
      "Umubare ntarengwa w'abakoresha wagezweho. Ongera gris abonnment yawe wongere abakoresha.",
    productUpdate: "Ntibishobotse kuvugurura igicuruzwa. Gerageza kongera.",
    autorisationSupp: "Ntiwemerewe gusiba iyi commande.",
    prodReactivate: "Ntibishobotse kongera gukoresha igicuruzwa",
    libraryAddDoc: "Inyandiko ntiyongerewe",
    libraryUpdateDoc: "Inyandiko ntiyavuguruwe",
    libraryArchiveDoc: "Inyandiko ntiyabitswe",
    libraryReactiveDoc: "Inyandiko ntiyongeye gukoreshwa",
    failedToUpdateModuleOrder:
      "Ntibishobotse kuvugurura gahunda ya module. Gerageza ukundi",
    alreadyAssigned: "Yamaze gutangwa kuri",
    studentPhotoUploadError: "Ntibishobotse kohereza ifoto y'umunyeshuri",
    studentPhotoDeleteError: "Ntibishobotse gusiba ifoto y'umunyeshuri",
    fileUploadError: "Ikosa mu kohereza idosiye. Gerageza ukundi.",
    noDataToUpdate: "Nta makuru yo kuvugurura",
    updateSessions: "Ikosa mu kuvugurura ibyicaro",
    deleteRecurringSessions: "Ikosa mu gusiba ibyicaro byisubiramo",
    classNotFound: "Icyiciro ntikibonetse!",
    studentListNotFound: "Urutonde rw'abanyeshuri ntirubonetse",
    unexpectedError: "Habayeho ikosa rutunguranye.",
    groupUpdateFailed: "Ikosa mu kuvugurura itsinda",
    fetchingData: "Ntibishobotse kubona amakuru. Gerageza ukundi.",
    usernameExists: "Izina ry'umukoresha ntiriboneka",
    allSubModuleNeedToBeSelected: "Hitamo moduli ndogo zose",
    noSubMoudoleIsfound: "Nta moduli ndogo ibonetse",
    moduleNonSupp: "Iki moduli ntishobora gusibwa",
    subModuleNonAjoute: "Moduli ndogo ntiyongewe",
    deleteSession: "Ikosa mu gusiba kipindi",
    selectionnerDates: "Tafadhali chagua darasa na kipindi",
    dateDebutApresFin: "Tarehe ya kuanza lazima iwe kabla ya tarehe ya mwisho",
    erreurRecuperationSeances: "Kosa wakati wa kupata vipindi",
    erreurRecuperationAssiduite: "Kosa wakati wa kupata data za mahudhurio",
    erreurGenerationPdf: "Kosa wakati wa kutengeneza PDF",
    subsubjectNonAjoute: "Somo dogo halijaongezwa",
    activiteHasPayments:
      "Haiwezekani kubadilisha mwaka wa shule, kwa sababu shughuli ina usajili katika mwaka wa shule wa sasa",
    failedToLoadFinancialStats: "Imeshindwa kupakia takwimu za kifedha",
    failedToLoadAnalytics: "Imeshindwa kupakia uchambuzi wa {tab}",
    errorLoadingSchoolYears: "Hitilafu wakati wa kupakia miaka ya shule",
  },
  warning: {
    verifieDonnees: "Thibitisha data",
    connectionProblem: "Shida ya muunganisho, tafadhali onyesha upya ukurasa!",
    selectModePaiement: "Chagua njia ya malipo",
    paiementNonEffectuer: "Malipo hayajafanywa",
    invalidMarks: "Tafadhali hakikisha alama zako ziko kati ya 0 na 20.",
    notCorrectMarks: "Tafadhali hakikisha alama zako zimeingizwa kwa usahihi.",
    missedSubsubjects:
      "Tafadhali kamilisha alama zote zilizokosekana kwa ({name})",
  },
  stats: {
    userStats: "Takwimu za watumiaji",
    connectedStats: "Watumiaji waliounganishwa",
    connects: "Muunganisho",
    connect: "Unganisha",
    disconnect: "Tenganisha",
    seen: " imeonekana",
    published: " imechapishwa",
    mainStats: "Idadi ya watumiaji waliounganishwa kwa tarehe",
    nb_connections: "Idadi ya muunganisho",
    connection_duration: "Muda wa muunganisho",
    mainStatSelected: "Muda wa muunganisho (masaa) kwa {name} kwa tarehe",
    secondaryStatsteacher: "Uchapishaji wa masomo/mazoezi kwa siku",
    secondaryStatsparent: "Uchunguzi wa masomo/mazoezi kwa siku",
    secondaryStatSelectedteacher:
      "Uchapishaji wa masomo/mazoezi kwa {name} kwa siku",
    secondaryStatSelectedparent:
      "Uchunguzi wa masomo/mazoezi kwa {name} kwa siku",
    detailedStats: "Maelezo ya muunganisho",
    detailedStatSelected: "Maelezo ya muunganisho kwa {name}",
    lastConnection: "Muunganisho wa mwisho",
    duration: "Muda wa muunganisho",
    neverLoggedIn: "Hajawahi kuingia",
    hasLoggedIn: "Ameingia",
    noConnectionHistory: "Hakuna historia ya uhusiano",
    fullName: "Jina kamili",
    childName: "Jina la mtoto",
  },
  bulletinBuilder: {
    contradictoryWith: "Chaguo hili linapatikana na {option}",
    subjectsOptions: "Chaguo za masomo/masomo madogo",
    modulesOptions: "Chaguo za moduli/moduli ndogo",
    otherOptions: "Chaguo za kosa",
    hideSubjectMark: "Ficha wastani wa masomo/masomo madogo",
    hideModuleMark: "Ficha wastani wa moduli/moduli ndogo",
    hideSubModuleMark: "Ficha wastani wa moduli ndogo",
    certif: "cheti",
    adminAppreciation: "Kuthamini kwa msimamizi",
    pedaLike: "Kurundisha kona za mstatili",
    onlyForForceOnePage:
      "Inatumika kwa kulazimisha ukurasa mmoja au kunyoosha hadi ukurasa mzima",
    textuelle: "Vipengele vya maandishi",
    images: "Picha",
    couleurs: "Rangi",
    taillesPolice: "Ukubwa wa herufi",
    optionsAvancees: "Chaguo za kina",
    enTete: "Kichwa",
    corps: "Mwili",
    cote: "Kando",
    espacement: "Nafasi",
    arrierePlanQR: "Chinichini na QR",
    schoolName: "Jina la shule",
    schoolarYear: "Mwaka wa masomo",
    className: "Jina la darasa",
    studentName: "Jina la mwanafunzi",
    birthDate: "Tarehe ya kuzaliwa",
    nbInscription: "Nambari ya usajili",
    uniqueIden: "Kitambulisho cha kipekee",
    schoolLogo: "Nembo ya shule",
    studentImage: "Picha ya mwanafunzi",
    govLogo: "Nembo ya wizara",
    subsubjectMark: "Alama ya somo dogo",
    subjectMark: "Alama ya somo",
    moduleMark: "Alama ya moduli",
    appreciation: "Kuthamini",
    minPerClass: "Chini zaidi kwa darasa",
    maxPerClass: "Juu zaidi kwa darasa",
    lineReturn: "Kurudi mstari baada ya kichwa",
    normal: "Wastani wa jumla",
    peda: "Wastani wa kiufundishaji",
    personalized: "Wastani wa kibinafsi",
    afficherNomEcole: "Onyesha jina la shule",
    afficherAnneeScolaire: "Onyesha mwaka wa masomo",
    afficherNomClasse: "Onyesha jina la darasa",
    afficherTextMinistere: "Onyesha maandishi ya wizara",
    afficherNomEleve: "Onyesha jina la mwanafunzi",
    afficherDateNaissance: "Onyesha tarehe ya kuzaliwa",
    afficherNbInscription: "Onyesha nambari ya usajili",
    afficherIdentifiantUnique: "Onyesha kitambulisho cha kipekee",
    enteteTrimestre: "Kichwa cha muhula",
    afficherLogoEcole: "Onyesha nembo ya shule",
    afficherImageEleve: "Onyesha picha ya mwanafunzi",
    afficherLogoMinistere: "Onyesha nembo ya wizara",
    personnaliserCouleurs: "Binafsisha rangi",
    paletteCouleurs: "Pani ya rangi",
    noteSousMatiere: "Alama ya somo dogo",
    noteMatiere: "Alama ya somo",
    noteModule: "Alama ya moduli",
    appreciation: "Kuthamini",
    minParClasse: "Chini zaidi kwa darasa",
    maxParClasse: "Juu zaidi kwa darasa",
    fusionnerSousMatieres: "Unganisha masomo madogo",
    masquerMatieres: "Ficha masomo",
    masquerMinParMatiere: "Ficha chini zaidi kwa somo",
    masquerMaxParMatiere: "Ficha juu zaidi kwa somo",
    pasEncoreDisponible: "Kipengele hiki bado hakipatikani",
    slowingFactor: "Chaguo hili linaweza kupunguza kasi ya kuzalisha PDF",
    nonDisponiblePourEnTeteBas: "Haipatikani kwa vichwa vya chini",
    forcerUnePage: "Lazimisha kwenye ukurasa mmoja",
    sensitiveOption: "Chaguo hizi ni nyeti, zitumie kwa uangalifu",
    etirerPageEntiere: "Tanua kwenye ukurasa mzima",
    margeGauche: "Ukingo wa kushoto",
    trimersterLineMargin: "Ukingo wa kichwa",
    margeInferieure: "Ukingo wa chini",
    ajouterQRCode: "Ongeza msimbo wa QR",
    ajouterArrierePlan: "Ongeza chinichini",
    cliquezGlisser: "Bofya au buruta faili",
    supportImageUnique: "Inategemea picha tu",
    apercuBulletin: "Muonekano wa ripoti ya shule",
    selectionnerEleve: "Chagua mwanafunzi",
    selectionnerTemplate: "Chagua kiolezo",
    actualiser: "Sasisha",
    selectionnerEleveDabord: "Tafadhali chagua mwanafunzi kwanza",
    visualiserBulletin: "Ona ripoti ya shule",
    configurer: "Sanidi",
    titre: "Kichwa",
    valeur: "Thamani",
    position: "Nafasi",
    centre: "Katikati",
    gauche: "Kushoto",
    droit: "Kulia",
    bas: "Chini",
    ordre: "Mpangilio",
    changerPositions: "Badilisha nafasi",
    optionsAffichage: "Chaguo za kuonyesha",
    afficherMinimum: "Onyesha chini zaidi",
    afficherMaximum: "Onyesha juu zaidi",
    afficherRang: "Onyesha mpangilio",
    recommandeActiver: "Inashauriwa kuwasha wastani 2 kati ya 3 tu.",
    couleurMoyenne: "Rangi ya wastani",
    couleurRang: "Rangi ya mpangilio",
    couleurMin: "Rangi ya chini zaidi",
    couleurMax: "Rangi ya juu zaidi",
    legende: "Ufafanuzi",
    libelle: "Lebo",
    coefficientMoyenne: "Mkazo wa wastani",
    coefficientMoyennePedagogique: "Mkazo wa wastani wa kiufundishaji",
    modifierCouleurs: "Hariri rangi",
    couleurPrincipale: "Rangi kuu",
    enteteTrimestreTitres: "Kichwa cha muhula na vichwa",
    bordureCouleurPrincipale: "Mpaka wa rangi kuu",
    couleurSecondaire: "Rangi ya pili",
    titresMoyennes: "Vichwa vya wastani",
    bordureCouleurSecondaire: "Mpaka wa rangi ya pili",
    couleurTertiaire: "Rangi ya tatu",
    arrierePlanMinMaxRang: "Chinichini cha chini/juu/mpangilio",
    bordureCouleurTertiaire: "Mpaka wa rangi ya tatu",
    configurerPolice: "Sanidi herufi",
    taille: "Ukubwa",
    couleur: "Rangi",
    font: "Herufi",
    additionalImages: "Picha za Ziada",
    customGovLogo: "Badilisha nembo ya wizara",
    showSubmodule: "Onyesha jina la moduli ndogo",
    showSubmoduleMoy: "Onyesha wastani wa moduli ndogo",
    noStampFound: "Hakuna muhuri uliopatikana",
    errorPrintingBulletin:
      "Kosa limetokea wakati wa kuchapisha ripoti ya shule",
    errorGettingBulletinData:
      "Kosa limetokea wakati wa kupata data ya ripoti ya shule",
    selectStudentFirst: "Tafadhali chagua mwanafunzi kwanza",
    scaleImagesTooltip:
      "Chaguo hili hukuruhusu kupunguza au kuongeza ukubwa wa picha katika ripoti ya shule, tumia kwa tahadhari.",
    scaleImages: "Kiwango cha picha",
    certifUsePersonalizedMoy: "Cheti na wastani wa kibinafsi",
    veuillezVerifierChamps: "Tafadhali kagua sehemu",
    afficherMoyenne: "Onyesha wastani",
    afficherMoyennePedagogique: "Onyesha wastani wa kiufundishaji",
    afficherMoyennePersonnalise: "Onyesha wastani wa kibinafsi",
    afficherCertif: "Onyesha cheti",
    afficherCache: "Onyesha muhuri",
    afficherDate: "Onyesha tarehe",
    selectFont: "Chagua herufi",
    positionX: "Nafasi X",
    parametresEnregistres: "Mipangilio imehifadhiwa",
    parametresNonEnregistres: "Mipangilio haijahifadhiwa",
    checkInputs: "Tafadhali kagua maingizo yako",
    positionUsedBy: "Nafasi hii inatumiwa na",
    restaureParametres: "Imerejeshwa kwa mipangilio ya kawaida",
    modeleSelectionne: "Kiolezo kimechaguliwa",
    arabicAndFrench: "Kiarabu na Kifaransa",
    arabicOnly: "Kiarabu tu",
    selectionnerElevePourVisualiser: "Chagua mwanafunzi ili kuona ripoti",
    parametresEnregistresAvecSucces: "Mipangilio imehifadhiwa kwa mafanikio",
  },
  teacherGradePermissions: {
    title: "Ruhusa za alama za walimu",
    subTitle:
      "kudhibiti kama walimu wanaweza kuhariri alama za wanafunzi baada ya kuwasilisha",
    gradeEditingEnabled: "Uharirishaji wa alama umewashwa",
    gradeEditingDisabled: "Uharirishaji wa alama umezimwa",
    selectTeachers: "Chagua walimu",
    allTeachers: "Walimu wote",
    specificTeachers: "Walimu maalum",
    permissionSaved: "Ruhusa za alama zimehifadhiwa kwa mafanikio",
    chooseTrimester: "Chagua muhula",
    gradeEditing: "Uharirishaji wa alama",
    teacherAccessMode: "Toa ufikiaji kwa",
    canEdit: "Anaweza kuhariri alama",
    searchTeachers: "Tafuta kwa jina la mwalimu",
    filterAccess: "Chuja kwa ufikiaji wa mwalimu",
    withAccess: "Walimu wenye ufikiaji",
    withoutAccess: "Walimu wasiokuwa na ufikiaji",
    selectTeachersError:
      "Tafadhali chagua angalau mwalimu mmoja wakati hali ya 'Walimu maalum' imewashwa.",
  },
  aiFeedback: {
    title: "Ripoti mahiri",
    lastUpdated: "Ilisasishwa mwisho",
    summary: "Muhtasari",
    strengths: "Nguvu",
    weaknesses: "Mambo ya kuboresha",
    recommendations: "Mapendekezo",
    generalAppreciation: "Kuthamini kwa jumla",
    noFeedback: "Hakuna ripoti inapatikana",
    generateReport: "Zalisha ripoti na AI",
    initiatedMessage: "Uchambuzi wa AI unaendelea",
    initiatedDescription:
      "Tunachambua utendaji wa mwanafunzi. Hii inaweza kuchukua muda kidogo.",
    information: "Maelezo ya ripoti",
    generatedByAI: "Imezalishwa na AI",
    generatedAt: "Imezalishwa",
    pdfGenerationError: "Kosa wakati wa kuzalisha ripoti",
    pdfGeneratedSuccessfully: "Ripoti imezalishwa kwa mafanikio",
  },
  invoice: {
    addressedTo: "imeelekezwa kwa",
    editAddressedTo: "Hariri imeelekezwa kwa",
    type: "Aina",
    selectType: "Chagua aina",
    particular: "Binafsi",
    entreprise: "Kampuni",
    MF: "MF",
    representative: "Mwakilishi",
    enterMF: "Ingiza MF",
    selectRepresentative: "Chagua mwakilishi",
    father: "Baba",
    mother: "Mama",
    other: "Nyingine",
    addressedToName: "Jina",
    enterName: "Ingiza jina",
    typeRequired: "Aina inahitajika",
    nameRequired: "Jina linahitajika",
    representativeRequired: "Mwakilishi anahitajika",
    MFRequired: "MF inahitajika",
    selectAddressedTo: "Chagua anwani",
    loadingParentsInfo: "Inapakia taarifa za wazazi...",
    selectParent: "Chagua mzazi",
    multipleParentsFound: "Wazazi wengi wamepatikana",
    parentFound: "Mzazi amepatikana",
    selectParentForDocument: "Tafadhali chagua mzazi kwa anwani ya hati",
    documentAddressedTo: "Hati inaelekezwa kwa",
    noParentFound: "Hakuna mzazi aliyepatikana",
    fatherLabel: "Baba",
    motherLabel: "Mama",
    parentMissingInfo: "Mzazi (taarifa hazipo)",
    errorLoadingParents: "Kosa wakati wa kupakia wazazi",
    facture: "Ankara",
    factureAvoir: "Ankara - Kuwa na",
    recu: "Stakabadhi",
    recuAvoir: "Stakabadhi - Kuwa na",
    nomPrenomEleve: "Jina na jina la kwanza (mwanafunzi)",
    designation: "Uteuzi",
    frais: "Ada",
    quantite: "Idadi",
    prixUnitaireHT: "Bei ya kipengele bila kodi",
    montantHT: "Kiasi bila kodi",
    montantTTC: "Kiasi pamoja na kodi",
    qte: "Idadi",
    prixUnitaire: "Bei ya kipengele",
    total: "Jumla",
    totalHTBrut: "Jumla bila kodi ghafi",
    remise: "Punguzo",
    totalHT: "Jumla bila kodi",
    totalTVA: "Jumla ya VAT",
    timbre: "Muhuri",
    retenueALaSource: "Kodi ya kukata kwenye chanzo",
    netAPayer: "SAFI YA KULIPA",
    reste: "Iliyobaki",
    adresseeA: "Imeelekezwa kwa:",
    cachetSignature: "Muhuri na saini",
    arreteePresenteFacture: "Imesimamishwa ankara hii kwa jumla ya:",
    dinarsEt: "shilingi na",
    millimes: "senti",
    ecolePrimairePrivee: "Shule ya msingi ya kibinafsi",
    page: "Ukurasa",
    mf: "MF",
    tel: "Simu",
    mail: "Barua pepe",
    numeroLabel: "Nambari:",
    dateLabel: "Tarehe:",
    avanceLabel: " ( mapema )",
    signature: "Saini",
    paymentMethods: "Njia za malipo",
    tuitionSummary: "Muhtasari wa malipo ya karo",
    activitySummary: "Muhtasari wa malipo ya shughuli",
    summaryTotalToPay: "Jumla ya kulipa",
    summaryDebitPaid: "Debit – Imelipwa",
    summaryCreditUnpaid: "Credit – Haijalipwa",
    summaryTotalPaid: "Jumla iliyolipwa",
    summaryTotalUnpaid: "Jumla isiyolipwa",
    summaryPartial: "sehemu",
    chequeDetail: "Hundi",
    transactionCode: "Msimbo wa muamala",
    pmNumber: "Na.",
    pmReference: "Kumb.",
    pmHolder: "Mmiliki",
    pmBank: "Benki",
    pmRib: "RIB",
    pmDueDate: "Tarehe ya mwisho",
    pmDate: "Tarehe",
    baseReduction: "Punguzo la msingi",
    baseReductionShort: "Pung.",
    baseReductionTotal: "Jumla ya punguzo la msingi",
    schoolCopy: "Nakala ya shule",
  },
  promotion: {
    button: "Upandishaji otomatiki",
    title: "Upandishaji otomatiki wa wanafunzi",
    subtitle:
      "Wapandishe wanafunzi kwenda mwaka unaofuata kulingana na kiwango chao.",
    back: "Rudi",
    fromYear: "Mwaka wa chanzo",
    toYear: "Mwaka lengwa",
    noNextYearShort: "Hakuna mwaka unaofuata",
    noNextYearTitle: "Hakuna mwaka wa masomo unaofuata",
    noNextYearDesc:
      "Unda mwaka wa masomo unaofuata kwanza ili kuendesha upandishaji.",
    missingTitle: "Madarasa ya kawaida yanakosekana",
    missingDesc:
      "Unda viwango vifuatavyo (madarasa ya ugawaji) kwa mwaka lengwa kabla ya kuendesha upandishaji:",
    doneTitle: "Upandishaji umekamilika",
    promoted: "waliopandishwa",
    kept: "waliobaki (wanaorudia)",
    archived: "waliohifadhiwa",
    skipped: "waliorukwa (tayari wamewekwa)",
    noStudents: "Hakuna wanafunzi wa kupandisha.",
    toPromote: "Wa kupandisha",
    toKeep: "Wa kubaki",
    toArchive: "Wa kuhifadhi",
    students: "wanafunzi",
    endOfCycle: "Mwisho wa mzunguko",
    keptShort: "waliobaki",
    archivedShort: "waliohifadhiwa",
    terminalHint:
      "Wanafunzi hawa watahifadhiwa. Chagua wanaorudia ili kuwabakiza katika mwaka mpya.",
    terminalHintNoKeep:
      "Wanafunzi hawa watahifadhiwa (hakuna darasa la ugawaji la kiwango sawa la kuwabakiza).",
    alreadyPlaced: "tayari amewekwa",
    confirmText: "Thibitisha kuwahamisha wanafunzi mwaka unaofuata?",
    confirmOk: "Thibitisha",
    execute: "Endesha upandishaji",
    notReady: "Rekebisha mahitaji kabla ya kuendesha upandishaji.",
  },
  inscriptionStats: {
    tabNormal: "Madarasa",
    tabAffectation: "Ugawaji",
    tabIndicators: "Viashiria",
    total: "Jumla ya wanafunzi",
    enrolled: "Wanafunzi walioandikishwa",
    affected: "Wanafunzi waliogawiwa",
    unplaced: "Wanafunzi wasiopangwa",
    repartition: "Mgawanyo wa wanafunzi",
    effectifParClasse: "Wanafunzi kwa kila darasa",
    parNiveau: "Idadi kwa kiwango",
    bandAffectation: "Ugawaji (kiwango)",
    bandNormal: "Madarasa",
    eleves: "wanafunzi",
    moyenne: "Wastani",
    imbalance: "Kutolingana kwa idadi",
    imbalanceTag: "Hakulingani",
    imbalanceHint:
      "Kiwango huonyeshwa wakati tofauti kati ya darasa lililojaa zaidi na lililo na wachache ni kubwa. Nyekundu = lililojaa zaidi, machungwa = lenye wachache.",
    aucuneDonnee: "Hakuna data inayopatikana",
    loadError: "Imeshindwa kupakia viashiria",
  },
  errorCode: {
    LEVEL_REQUIRED_FIRST:
      "Kiwango hiki lazima kiundwe katika kichupo cha Viwango kabla ya kuongeza darasa.",
    LEVEL_ALREADY_EXISTS: "Kiwango hiki tayari kipo kwa mwaka huu wa masomo.",
    LEVEL_HAS_PAYMENTS:
      "Kiwango hiki hakiwezi kufutwa kwa sababu kuna malipo yaliyounganishwa nacho.",
    LEVEL_HAS_STUDENTS:
      "Kiwango hiki hakiwezi kufutwa kwa sababu bado kuna wanafunzi walipewa kiwango hiki.",
    EXACTLY_ONE_OWNER_REQUIRED: "Lazima kuwe na mmiliki mmoja tu kwa sanduku.",
    AT_LEAST_ONE_OWNER_REQUIRED: "Sanduku lazima liwe na angalau mmiliki mmoja.",
    DUPLICATE_CAISSE_USER:
      "Mtumiaji anaweza kuorodheshwa mara moja tu kwenye sanduku.",
    CAISSE_REFERENCE_ALREADY_EXISTS: "Sanduku lingine tayari linatumia rejea hii.",
    PRINCIPAL_CAISSE_ALREADY_EXISTS:
      "Sanduku kuu tayari lipo. Moja tu inaruhusiwa.",
    CAISSE_SELECTION_REQUIRED:
      "Una ufikiaji wa masanduku kadhaa, chagua sanduku la kutumia.",
    NOT_OWNER_OF_CAISSE:
      "Huwezi kufanya malipo hii kwa sababu huna mmiliki wa sanduku.",
    CAISSE_NOT_PERMITTED:
      "Sanduku au akaunti ya benki haipo au huna ruhusa ya kulipa kutoka humo.",
    DUP_CIN: "Mwalimu mwenye CIN hii tayari yupo!",
    DUP_EMAIL: "Mwalimu mwenye barua pepe hii tayari yupo!",
    DB_NOT_FOUND: "Shule haijapatikana.",
    CREATE_TEACHER_FAILED:
      "haiwezekani kuongeza mwalimu, tafadhali jaribu tena!",
    UPDATE_EMPLOYEE_FAILED:
      "haiwezekani kusasisha mfanyakazi, tafadhali jaribu tena!",
    CREATE_EMPLOYEE_FAILED:
      "haiwezekani kuongeza mfanyakazi, tafadhali jaribu tena!",
    EMPLOYEE_DUP_CIN: "Mfanyakazi mwenye CIN hii tayari yupo!",
    ENCAISSEMENT_BANK_INCOMPATIBLE_METHOD:
      "Akaunti ya benki haiwezi kupokea pesa taslimu. Tumia hundi, trete, uhamisho benki, au TPE.",
    ENCAISSEMENT_NON_CASH_REQUIRES_BANK:
      "Hundi, trete, uhamisho benki, na TPE lazima ziwekwe kwenye akaunti ya benki.",
    OUTBOUND_PAYMENT_NOT_READY:
      "Malipo ya kutoka lazima yathibitishwe katika upatanisho kabla ya kuthibitisha kupokea.",
    INSUFFICIENT_BALANCE: "Mizani haitorshi",
    PACK_PERMISSION_ERROR: "Huna ruhusa ya kufanya kitendo hiki",
    NO_AUTO_APPRECIATION:
      "Hakuna kanuni za uthamini wa kiotomatiki za kunakili kwa somo na mwaka huu wa shule.",
    AUTO_APPRECIATION_MISSING_TEACHER_ACCESS:
      "Haiwezekani kutumia uthamini wa kiotomatiki kwa moduli {moduleName}. Hakuna ruhusa ya mwalimu kwa madarasa yafuatayo: {classrooms}.",
    AUTO_APPRECIATION_NO_TEACHER_SUBJECT_ACCESS:
      "Uwekaji wa tathmini ya kiotomatiki umeshindikana kwa sababu hakuna mwalimu aliyepewa somo hili katika baadhi ya madarasa. Tafadhali sasisha ruhusa za masomo ya walimu kisha ujaribu tena.",
    CLUB_ACTIVITY_REQUIRED: "Tafadhali chagua shughuli au weka jina la klabu",
    CLUB_POST_NOT_FOUND: "Chapisho la shughuli / klabu halijapatikana",
    CLUB_JOIN_NOT_FOUND: "Ombi la kujiunga halijapatikana",
    CLUB_STUDENT_NOT_FOUND: "Mwanafunzi hajapatikana",
    CLUB_CLASSROOM_NOT_FOUND: "Darasa halijapatikana",
    CLUB_REGISTRATION_NOT_STARTED: "Usajili bado haujaanza",
    CLUB_REGISTRATION_CLOSED: "Usajili umefungwa",
    CLUB_NO_PLACES_LEFT: "Hakuna nafasi zilizobaki",
    CLUB_INVALID_STUDENT: "Mwanafunzi si sahihi",
    CLUB_ALREADY_REGISTERED: "Tayari umejiandikisha",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR: "Kichwa cha mwaka wa shule hakipo",
    ACTIVITY_GROUP_ACTIVITY_ID_REQUIRED: "Shughuli inahitajika",
    ACTIVITY_GROUP_ID_REQUIRED: "Kikundi kinahitajika",
    ACTIVITY_GROUP_INVALID_ID: "Kikundi si sahihi",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "Shughuli haipatikani",
    ACTIVITY_GROUP_NOT_FOUND: "Kikundi cha shughuli hakipatikani",
    ACTIVITY_GROUP_NAME_EXISTS: "Kikundi chenye jina hili tayari kipo",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND: "Usajili wa shughuli haupatikani",
    ACTIVITY_GROUP_LIST_FAILED: "Imeshindikana kupakia vikundi vya shughuli",
    ACTIVITY_GROUP_CREATE_FAILED: "Imeshindikana kuunda kikundi",
    ACTIVITY_GROUP_RENAME_FAILED: "Imeshindikana kubadilisha jina la kikundi",
    ACTIVITY_GROUP_DELETE_FAILED: "Imeshindikana kufuta kikundi",
    ACTIVITY_GROUP_ASSIGN_FAILED: "Imeshindikana kumpa mwanafunzi kikundi",
    ACTIVITY_GROUP_UNASSIGN_FAILED: "Imeshindikana kumuondoa mwanafunzi kwenye kikundi",
    CAISSE_INSUFFICIENT_BALANCE:
      "Sanduku lililochaguliwa halina salio la jumla la kutosha kwa malipo haya.",
    CAISSE_INSUFFICIENT_MODE_BALANCE:
      "Sanduku halina kiasi cha kutosha kwa njia hii ya malipo (fedha taslimu, hundi, uhamisho, n.k.).",
    CAISSE_NOT_FOUND: "Sanduku halipatikani",
    INVOICE_NOT_FOUND: "Ankara haipatikani, tafadhali kagua thamani yako",
    AMOUNT_EXCEEDS_INVOICE_TOTAL: "Kiasi kinazidi jumla ya ankara",
    AVOIR_DUPLICATE_DEPENSE:
      "Ankara hii tayari ina hati ya mkopo. Hati moja ya mkopo kwa ankara inaruhusiwa tu.",
    AVOIR_INVOICE_NOT_FULLY_PAID:
      "Hati ya mkopo inaweza kuundwa tu kwa ankara ambayo imelipwa kabisa.",
    PAYMENT_NOT_FOUND: "Malipo hayapatikani, tafadhali kagua thamani yako",
    ALREADY_TRANSFERRED: "Ankara hii tayari imehamishwa, haiwezi kughairiwa",
    NOT_AUTHORIZED_TO_CANCEL:
      "Huna ruhusa ya kughairi kanuni hii, mmiliki wa sanduku kuu tu anaweza kughairi kanuni zilizohamishwa",
    ALREADY_CANCELLED: "Ankara hii tayari imeghairiwa",
    VALIDATED_CHEQUES_EXIST:
      "Haiwezekani kughairi ankara: hundi/drafti/uhamishaji zilizothibitishwa zipo",
    BORDEREAU_VALIDATED_CHEQUES_EXIST:
      "Haiwezekani kufuta hati ya amana yenye hundi zilizothibitishwa",
    FACTURE_ONLY_AVOIR: "Ankara zinaweza kughairiwa tu na aina ya 'Kuwa na'",
    CHEQUE_TRAITE_ALREADY_REPLACED_OR_CANCELLED:
      "Hundi/drafti tayari imebadilishwa au imeghairiwa",
    CHEQUE_TRAITE_ALREADY_VALIDATED: "Hundi/drafti tayari imethibitishwa",
    DUPLICATE_CHEQUES: "Baadhi ya hundi tayari zipo!",
    DUPLICATE_CHEQUE_OR_TRAITE_NUMBER:
      "Nambari ya hundi au drafti tayari imetumika, au umeiingiza zaidi ya mara moja katika malipo haya.",
    DUPLICATE_PROVIDER_INVOICE_NUMBER:
      "Ankara hii tayari ipo; tafadhali hariri ankara iliyopo",
    DUPLICATE_INPUT_CHEQUES:
      "Baadhi ya hundi zimerudiwa katika data ya kuingiza",
    TRANCHES_ALREADY_PAID:
      "Mwanafunzi tayari amelipa vipande, hatuwezi kughairi usajili. unaweza kughairi kanuni kisha jaribu tena!",
    MONTHS_ALREADY_PAID:
      "Mwanafunzi tayari amelipa miezi, hatuwezi kughairi usajili. unaweza kughairi kanuni kisha jaribu tena!",
    INSCRIPTION_ALREADY_PAID:
      "Mwanafunzi tayari amelipa usajili, hatuwezi kughairi usajili. unaweza kughairi kanuni kisha jaribu tena!",
    VALIDATION_ERROR:
      "Baadhi ya maelezo si sahihi, tafadhali kagua maingizo yako.",
    TEACHER_INVALID_PHONE: "Nambari ya simu si sahihi. Tumia muundo wa kimataifa, mfano +254712345678.",
    TEACHER_INVALID_BIRTH_DATE: "Tarehe ya kuzaliwa si sahihi. Chagua tarehe halali (DD/MM/YYYY) au iache wazi.",
    TEACHER_INVALID_CIN_CREATED_AT: "Tarehe ya kutolewa kwa kitambulisho si sahihi. Chagua tarehe halali (DD/MM/YYYY) au iache wazi.",
    TEACHER_INVALID_INTERVIEW_DATE: "Tarehe ya usaili si sahihi. Chagua tarehe halali (DD/MM/YYYY) au iache wazi.",
    TEACHER_INVALID_START_DATE: "Tarehe ya kuanza si sahihi. Chagua tarehe halali (DD/MM/YYYY) au iache wazi.",
    TEACHER_INVALID_END_DATE: "Tarehe ya kumalizika si sahihi. Chagua tarehe halali (DD/MM/YYYY) au iache wazi.",
    TEACHER_INVALID_BANK_BRANCH: "Tawi la benki si sahihi. Tumia herufi, nafasi, vistari na mabano pekee.",
    TEACHER_INVALID_EXPECTED_HOURS: "Saa zinazotarajiwa kwa siku si sahihi. Weka nambari kati ya 0 na 24.",
    TEACHER_CIN_DUPLICATE: "Kitambulisho hiki tayari kinatumiwa na mfanyakazi mwingine. Weka kingine au acha wazi.",
    AUTHENTICATION_ERROR:
      "Kushindwa kuingia, tafadhali kagua utambulisho wako.",
    AUTHORIZATION_ERROR: "Ufikiaji haujaruhusiwa.",
    NOT_FOUND_ERROR: "Rasilimali iliyoombwa haipatikani.",
    CONFLICT_ERROR: "Tendo hili lina migongano na data iliyopo.",
    DATABASE_ERROR: "Tatizo limetokea, tafadhali jaribu tena.",
    EXTERNAL_SERVICE_ERROR:
      "Huduma ya nje haiko kwa muda, tafadhali jaribu baadaye.",
    SUBJECT_REQUIRED: "Somo linahitajika",
    SUBJECT_ALREADY_EXISTS: "Somo hili tayari lipo katika usanidi",
    CONFIG_NOT_FOUND: "Usanidi haujapatikana",
    SUBJECT_NOT_FOUND: "Somo halijapatikana",
    MISSING_REQUIRED_FIELDS: "Sehemu zinazohitajika hazipo",
    NO_GRADES_FOR_TRIMESTER:
      "Hakuna alama zilizorekodiwa kwa mwanafunzi huyu katika muhula uliochaguliwa. Ripoti haiwezi kutengenezwa.",
    CONFIG_DELETE_FAILED: "Kushindwa kufuta usanidi",
    CONFIG_CLONE_FAILED: "Kushindwa kunakili usanidi",
    CONFIG_UPDATE_ORDERS_FAILED: "Kushindwa kusasisha mpangilio wa usanidi",
    SUBJECT_ORDER_UPDATE_FAILED: "Kushindwa kusasisha mpangilio wa somo",
    DUPLICATE_CONFIG:
      "Usanidi tayari upo kwa mchanganyiko huu wa kiwango, robo, na mwaka wa shule",
    SUBJECT_ADD_FAILED: "Kushindwa kuongeza somo",
    SUBJECT_UPDATE_FAILED: "Kushindwa kusasisha somo",
    SUBJECT_DELETE_FAILED: "Kushindwa kufuta somo",
    SUBJECTS_QUERY_FAILED: "Kushindwa kupata masomo",
    CONFIG_QUERY_FAILED: "Kushindwa kupata usanidi",
    CONFIG_SAVE_FAILED: "Kushindwa kuhifadhi usanidi",
    INVALID_CONFIG_OPTIONS: "Chaguo za usanidi si sahihi",
    PAYMENT_ID_REQUIRED: "Kitambulisho cha malipo kinahitajika",
    DUPLICATE_PAYMENT_MONTH:
      "Mfanyakazi huyu tayari amelipwa kwa mwezi huu. Tafadhali chagua mwezi mwingine au mfanyakazi mwingine.",
    STORAGE_QUOTA_EXCEEDED:
      "Kikomo cha hifadhi hakiruhusu upakiaji huu. Wasiliana na timu ya mauzo kuongeza kikomo, au ondoa faili kufungua nafasi.",
    UPLOAD_PRESIGN_FAILED: "Kuandaa upakiaji kumeshindikana. Jaribu tena.",
    ACTIVITY_SCHEDULE_MISSING_SCHOOLARYEAR: "Chagua mwaka wa shule.",
    ACTIVITY_SCHEDULE_INVALID_DATA: "Kagua taarifa za kikao.",
    ACTIVITY_SCHEDULE_INVALID_ID: "Kikao kilichochaguliwa si sahihi.",
    ACTIVITY_SCHEDULE_INVALID_RECURRENCE:
      "Marudio lazima yaunde kikao 1 hadi vikao 500.",
    ACTIVITY_SCHEDULE_ACTIVITY_NOT_FOUND: "Shughuli haijapatikana.",
    ACTIVITY_SCHEDULE_TEACHER_NOT_FOUND: "Mwalimu hajapatikana.",
    ACTIVITY_SCHEDULE_ROOM_NOT_FOUND: "Chumba hakijapatikana.",
    ACTIVITY_SCHEDULE_GROUP_NOT_FOUND:
      "Kikundi hiki si cha shughuli iliyochaguliwa.",
    ACTIVITY_SCHEDULE_NOT_FOUND: "Kikao hakijapatikana.",
    ACTIVITY_SCHEDULE_CONFLICT:
      "Mwalimu au chumba tayari kimepangiwa wakati huu.",
    ACTIVITY_SCHEDULE_CANCELED:
      "Rejesha kikao kabla ya kukihariri.",
    ACTIVITY_SCHEDULE_LIST_FAILED: "Imeshindikana kupakia vikao vya shughuli.",
    ACTIVITY_SCHEDULE_CREATE_FAILED: "Imeshindikana kuunda kikao.",
    ACTIVITY_SCHEDULE_UPDATE_FAILED: "Imeshindikana kusasisha kikao.",
    ACTIVITY_SCHEDULE_CANCEL_FAILED: "Imeshindikana kughairi kikao.",
    ACTIVITY_SCHEDULE_RESTORE_FAILED: "Imeshindikana kurejesha kikao.",
    ACTIVITY_SCHEDULE_DELETE_FAILED: "Imeshindikana kufuta kikao.",
    ACTIVITY_SCHEDULE_HAS_ATTENDANCE:
      "Kikao hiki kina alama za mahudhurio. Kighairi badala ya kukifuta.",
    ACTIVITY_ATTENDANCE_MISSING_SCHOOLARYEAR: "Chagua mwaka wa shule.",
    ACTIVITY_ATTENDANCE_INVALID_ID: "Kitambulisho cha mahudhurio si sahihi.",
    ACTIVITY_ATTENDANCE_INVALID_DATA: "Data ya mahudhurio si sahihi.",
    ACTIVITY_ATTENDANCE_SESSION_NOT_FOUND: "Kikao cha shughuli hakijapatikana.",
    ACTIVITY_ATTENDANCE_SESSION_CANCELED:
      "Huwezi kuweka mahudhurio kwenye kikao kilichoghairiwa.",
    ACTIVITY_ATTENDANCE_SESSION_FUTURE:
      "Huwezi kuweka mahudhurio kwenye kikao cha baadaye.",
    ACTIVITY_ATTENDANCE_FORBIDDEN: "Hauruhusiwi kuweka mahudhurio ya kikao hiki.",
    ACTIVITY_ATTENDANCE_YEAR_LOCKED:
      "Mahudhurio ya shughuli yamefungwa kwa mwaka huu wa shule.",
    ACTIVITY_ATTENDANCE_VALIDATED_LOCKED:
      "Mahudhurio haya yamethibitishwa na utawala na yamefungwa.",
    ACTIVITY_ATTENDANCE_NOT_VALIDATED:
      "Mahudhurio ya kikao hiki bado hayajathibitishwa na utawala.",
    ACTIVITY_ATTENDANCE_REOPEN_FAILED: "Imeshindwa kufungua tena kikao.",
    ACTIVITY_ATTENDANCE_YEAR_NOT_FOUND: "Mwaka wa shule haukupatikana.",
    ACTIVITY_ATTENDANCE_YEAR_LOCK_FAILED:
      "Imeshindwa kusasisha ruhusa ya walimu kwa mwaka huu wa shule.",
    ACTIVITY_ATTENDANCE_STUDENT_NOT_ON_ROSTER:
      "Mwanafunzi hayuko kwenye orodha ya kikao hiki.",
    ACTIVITY_ATTENDANCE_ALREADY_EXISTS:
      "Alama ya mahudhurio tayari ipo kwa mwanafunzi huyu.",
    ACTIVITY_ATTENDANCE_NOT_FOUND: "Alama ya mahudhurio haijapatikana.",
    ACTIVITY_ATTENDANCE_ROSTER_FAILED:
      "Imeshindikana kupakia orodha ya wanafunzi.",
    ACTIVITY_ATTENDANCE_CREATE_FAILED: "Imeshindikana kuunda mahudhurio.",
    ACTIVITY_ATTENDANCE_UPDATE_FAILED: "Imeshindikana kusasisha mahudhurio.",
    ACTIVITY_ATTENDANCE_DELETE_FAILED: "Imeshindikana kufuta mahudhurio.",
    ACTIVITY_ATTENDANCE_SUMMARY_FAILED:
      "Imeshindikana kujenga muhtasari wa mahudhurio.",
    ACTIVITY_ATTENDANCE_ACTIVITY_NOT_FOUND: "Shughuli haijapatikana.",
    ACTIVITY_ATTENDANCE_NOT_DAILY:
      "Dalili ya mahudhurio inapatikana kwa shughuli za kila siku tu.",
    ACTIVITY_ATTENDANCE_PAYMENT_NOT_FOUND: "Usajili wa shughuli haujapatikana.",
    ACTIVITY_ATTENDANCE_INDICATION_FAILED:
      "Imeshindikana kupakia dalili ya mahudhurio.",
    ACTIVITY_ATTENDANCE_VALIDATE_FAILED:
      "Imeshindikana kuthibitisha mahudhurio ya shughuli.",
    ACTIVITY_ATTENDANCE_EMPTY_ROSTER:
      "Hakuna wanafunzi kwenye orodha ya kikao hiki.",
    ACTIVITY_ATTENDANCE_ROSTER_INCOMPLETE:
      "Alama lazima zifunike orodha yote ya kikao.",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR: "Chagua mwaka wa shule.",
    ACTIVITY_GROUP_INVALID_ID: "Kikundi cha shughuli si sahihi.",
    ACTIVITY_GROUP_PAYMENT_INVALID_ID: "Usajili uliochaguliwa si sahihi.",
    ACTIVITY_GROUP_INVALID_DATA: "Kagua taarifa za kikundi cha shughuli.",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "Shughuli haijapatikana.",
    ACTIVITY_GROUP_NOT_FOUND: "Kikundi cha shughuli hakijapatikana.",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND: "Usajili wa shughuli haujapatikana.",
    ACTIVITY_GROUP_NAME_EXISTS:
      "Kikundi hai chenye jina hili tayari kipo.",
    ACTIVITY_GROUP_LIST_FAILED: "Imeshindikana kupakia vikundi vya shughuli.",
    ACTIVITY_GROUP_CREATE_FAILED: "Imeshindikana kuunda kikundi cha shughuli.",
    ACTIVITY_GROUP_RENAME_FAILED:
      "Imeshindikana kusasisha kikundi cha shughuli.",
    ACTIVITY_GROUP_DELETE_FAILED: "Imeshindikana kufuta kikundi cha shughuli.",
    ACTIVITY_GROUP_ASSIGN_FAILED:
      "Imeshindikana kumpangia mwanafunzi kwenye kikundi.",
    ACTIVITY_GROUP_UNASSIGN_FAILED:
      "Imeshindikana kumwondoa mwanafunzi kwenye kikundi.",
  },
  upload: {
    failedTitle: "Upakiaji umeshindwa",
  },
  status: {
    VALIDATED: "Imethibitishwa",
    REJECTED: "Imekataliwa",
    PENDING: "Inasubiri",
    NON_DEPOSE: "Haijawekwa amana",
    DEPOSE: "Imewekwa amana",
    TRAITE: "Imesindika",
    REPLACED: "Imebadilishwa na fedha taslimu",
    CANCELLED: "Imeghairiwa",
    ACTIVE: "Hai",
    INACTIVE: "Si hai",
    active: "Hai",
    cancelled: "Imeghairiwa",
  },
  schedule: {
    weekA: "A",
    weekB: "B",
    unknownClass: "Darasa lisilojulikana",
    unknown: "Haijulikani",
    teacher: "Mwalimu",
    classroom: "Chumba cha darasa",
    session: "Kipindi",
    scheduleNotFound: "Ratiba haijapatikana",
    errorCreatingSession: "Hitilafu imetokea wakati wa kuunda kipindi",
    addSessionFailed: "Kushindwa kuongeza kipindi",
    timetableExceeded:
      "Mwisho wa kipindi ({endTime}) unazidi muda wa mwisho wa ratiba ({timetableEnd}) kwa {day}",
    time: "Muda",
    monday: "Jumatatu",
    tuesday: "Jumanne",
    wednesday: "Jumatano",
    thursday: "Alhamisi",
    friday: "Ijumaa",
    saturday: "Jumamosi",
    group: "Kikundi",
    week: "Wiki",
    sunday: "Jumapili",
  },
  financialStats: {
    title: "Takwimu za Kifedha",
    subtitle: "Ufahamu wa kifedha na uchambuzi wa kina kwa shule yako",
    refresh: "Sasisha",
    startDate: "Tarehe ya Mwanzo",
    endDate: "Tarehe ya Mwisho",
    total: "Jumla",
    totalRevenue: "Mapato ya Jumla",
    revenueSubtitle: "Mapato ya jumla kutoka vyanzo vyote",
    totalExpenses: "Matumizi ya Jumla",
    expensesSubtitle: "Gharama na matumizi ya jumla",
    netProfit: "Faida ya Wazi",
    profitSubtitle: "Mapato toa matumizi",
    profitMargin: "Kiwango cha Faida",
    marginSubtitle: "Asilimia ya faida",
    financialHealth: "Afya ya Kifedha",
    health: {
      excellent: "Bora sana",
      good: "Nzuri",
      fair: "Wastani",
      poor: "Duni",
      unknown: "Haijulikani",
    },
    healthDescription: {
      excellent: "Utendaji bora wa kifedha na faida kubwa",
      good: "Afya nzuri ya kifedha na mwenendo wa ukuaji chanya",
      fair: "Utendaji wa kifedha wa kutosha na nafasi ya kuboresha",
      poor: "Utendaji wa kifedha unahitaji umakini wa haraka",
      unknown: "Haiwezi kutathmini afya ya kifedha",
    },
    totalInvoices: "Ankara za Jumla",
    cancellationRate: "Kiwango cha Kughairi",
    monthlyTrend: "Mwenendo wa Kila Mwezi",
    paymentMethods: "Njia za Malipo",
    revenueExpenseComparison: "Mapato dhidi ya Matumizi",
    topPerformingMonths: "Miezi ya Utendaji Bora",
    revenueAnalytics: "Uchambuzi wa Mapato",
    expenseAnalytics: "Uchambuzi wa Matumizi",
    studentAnalytics: "Uchambuzi wa Wanafunzi",
    caisseAnalytics: "Uchambuzi wa Sanduku la Fedha",
    averageInvoiceValue: "Thamani ya Wastani ya Ankara",
    growthRate: "Kiwango cha Ukuaji",
    dailyRevenue: "Mapato ya Kila Siku",
    dailyRevenueTrend: "Mwenendo wa Mapato ya Kila Siku",
    revenueByType: "Mapato kwa Aina",
    factures: "Ankara",
    receipts: "Risiti",
    paymentMethodsBreakdown: "Mgawanyo wa Njia za Malipo",
    paymentMethod: "Njia ya Malipo",
    amount: "Kiasi",
    percentage: "Asilimia",
    cash: "Pesa taslimu",
    check: "Hati ya malipo",
    card: "Kadi",
    transfer: "Uhamisho",
    wire: "Uhamisho wa Umeme",
    employeeExpenses: "Matumizi ya Wafanyakazi",
    generalExpenses: "Matumizi ya Jumla",
    cancellations: "Ughairi",
    monthlyExpenseBreakdown: "Mgawanyo wa Matumizi ya Kila Mwezi",
    expenseDistribution: "Mgawanyo wa Matumizi",
    expenseCategories: "Kategoria za Matumizi",
    category: "Kategoria",
    trend: "Mwenendo",
    employees: "Wafanyakazi",
    general: "Jumla",
    totalStudents: "Wanafunzi wa Jumla",
    averagePaymentPerStudent: "Malipo ya Wastani kwa Mwanafunzi",
    topPayingStudents: "Wanafunzi wa Malipo Makubwa",
    showAll: "Onyesha Yote",
    showLess: "Onyesha Kidogo",
    rank: "Cheo",
    student: "Mwanafunzi",
    totalPaid: "Jumla ya Kulipwa",
    invoices: "Ankara",
    lastPayment: "Malipo ya Mwisho",
    actions: "Vitendo",
    viewDetails: "Ona Maelezo",
    paymentMethodsDistribution: "Mgawanyo wa Njia za Malipo",
    paymentFrequency: "Mzunguko wa Malipo",
    singlePayment: "Malipo Moja",
    multiplePayments: "Malipo Mengi",
    frequentPayers: "Walipaji wa Mara Nyingi",
    noData: "Hakuna data inayopatikana",
    totalCaisses: "Sanduku za Fedha za Jumla",
    averageRevenuePerCaisse: "Mapato ya Wastani kwa Sanduku la Fedha",
    caissePerformance: "Utendaji wa Sanduku la Fedha",
    caisse: "Sanduku la Fedha",
    averageInvoiceValue: "Thamani ya Wastani ya Ankara",
    performance: "Utendaji",
    monthlyTrend: "Mwenendo wa Kila Mwezi",
    revenueComparison: "Ulinganisho wa Mapato",
    caisseDistribution: "Mgawanyo wa Sanduku la Fedha",
    principal: "Kuu",
    subcaisse: "Sanduku la Fedha la Chini",
    bank: "Benki",
    excellent: "Bora sana",
    good: "Nzuri",
    fair: "Wastani",
    poor: "Duni",
    positivePerformance: "Chanya",
    negativePerformance: "Hasi",
    monthlyTrends: "Mienendo ya Kila Mwezi",
    revenueExpenseProfit: "Mapato, Matumizi na Faida",
    financialOverview: "Muhtasari wa Kifedha",
    revenueVsExpenses: "Mapato dhidi ya Matumizi",
    revenue: "Mapato",
    expenses: "Matumizi",
    profit: "Faida",
    tnd: "TND",
    inscrit: "Amejiandikisha",
    nonInscrit: "Hajajiandikisha",
    categories: "Kategoria",
    revenueSourcesTitle: "Vyanzo vya mapato",
    revenueSourcesSubtitle: "Ada vs mapato ya moduli ya matumizi",
    revenueSource: {
      tuition: "Ada / ankara",
      inverseEncaissement: "Matumizi ya kinyume (mapato)",
      avoirFournisseur: "Jamaa la mkopo wa muuzaji",
    },
    depenseOutflowTitle: "Malipo kwa njia ya malipo",
    depenseOutflowSubtitle: "Pesa zilizolipwa (matumizi)",
    depenseByTypeTitle: "Matumizi yaliyolipwa kwa aina",
    depenseByTypeSubtitle: "Mgawanyiko kwa aina ya matumizi",
    moneyFlowTitle: "Mtiririko wa pesa (kipindi)",
    moneyIn: "Mapato",
    moneyOut: "Matumizo",
    netCashPosition: "Jumla (ndani − nje)",
    tuitionShort: "Ada",
    inverseShort: "Kinyume",
    avoirShort: "Jamaa",
    depensePaidOut: "Matumizi yaliyolipwa (moduli)",
    otherCategory: "Nyingine",
  },
  error404: {
    pageInaccessible: "Ukurasa Haupatikani",
    subscriptionMessage: "Usajili wako wa sasa hauhimili kipengele hiki.",
    upgradeMessage: "Boresha sasa ili kuongeza uzoefu wako!",
    returnButton: "Rudi",
  },
  reduction: {
    designation: "Jina",
    reduction: "Punguzo",
    reductionTND: "Punguzo (TND)",
    reductionKES: "Punguzo (KES)",
    reductionPercent: "Punguzo (%)",
    amountBeforeReduction: "Kiasi kabla ya punguzo",
    amountAfterReduction: "Kiasi baada ya punguzo",
    actions: "Vitendo",
    amountInTND: "Kiasi katika TND",
    amountInKES: "Kiasi katika KES",
    percentage: "Asilimia",
    selected: "imechaguliwa",
  },
  payment: {
    selectFeesToPay: "Chagua ada za kulipa",
    showAll: "Onyesha zote",
    hideAll: "Ficha zote",
    payWithAdvance: "Lipa kwa mapema",
    withoutAdvance: "Bila mapema",
    enableAdvancePayment: "Washa malipo ya mapema",
    advanceAmountTND: "Kiasi cha mapema (TND)",
    enterAmount: "Ingiza kiasi",
    advanceAmountExceedsTotal:
      "Kiasi cha mapema kilichoingizwa ni kikubwa kuliko jumla ya ada za kulipa. kiasi cha mapema lazima kiwe kidogo au sawa na {maxAmount}",
    advanceAmountInsufficient:
      "Kiasi cha mapema kilichoingizwa hakiruhusu kufunika ada zote. Tafadhali ingiza kiasi cha mapema cha juu zaidi.",
    tuition: "Ada za masomo",
    activity: "Shughuli",
    feesToPay: "Ada za kulipa",
    remaining: "Kimebaki",
    advanceApplied: "Mapema yamewekwa",
    remainingToPay: "Kimebaki kulipa",
    partialPaymentRemaining: "Malipo ya sehemu - kiasi kilichobaki kulipa",
    advanceInsufficientForFee:
      "Kiasi cha mapema kilichoingizwa hakiruhusu kufunika ada hii. Tafadhali ingiza kiasi cha mapema cha juu zaidi.",
    paid: "Imelipwa",
    deselectAll: "Ondoa uteuzi wa zote",
    selectAll: "Chagua zote",
    registration: "Usajili",
    installment: "Kipande",
    fees: "Ada",
    amount: "Kiasi",
  },
  activityPayment: {
    service: "Huduma",
    numberOfStudents: "Idadi ya wanafunzi",
    order: "Utaratibu",
    no: "Hapana",
    allMonths: "Miezi yote",
    allClasses: "Madarasa yote",
    monthlyPayment: "Malipo ya kila mwezi",
    installmentPayment: "Malipo ya vipande",
    studentName: "Jina la mwanafunzi",
    classroom: "Darasa",
    parents: "Wazazi",
    parentPhones: "Simu za wazazi",
    paymentMode: "Njia ya malipo",
    monthly: "Kila mwezi",
    byInstallment: "Kwa vipande",
    globalStatus: "Hali ya jumla",
    paid: "Imelipwa",
    unpaid: "Haijalipwa",
    noClassFound: "Hakuna darasa lililopatikana",
    activityNotFound: "Shughuli haijapatikana!",
    noActivityRegistrationFound: "Hakuna usajili wa shughuli uliopatikana",
  },
  inscriptionActivites: {
    monthlyPayment: "Malipo ya kila mwezi",
    installmentPayment: "Malipo ya vipande",
    paymentMode: "Njia ya malipo",
    monthly: "Kila mwezi",
    byInstallment: "Kwa vipande",
    globalStatus: "Hali ya jumla",
    paid: "Imelipwa",
    unpaid: "Haijalipwa",
    noClassFound: "Hakuna darasa lililopatikana",
    manageGroups: "Simamia vikundi",
    manageGroupsTitle: "Vikundi — {activity}",
    addGroup: "Ongeza",
    groupName: "Jina la kikundi",
    renameGroup: "Badilisha jina",
    deleteGroup: "Futa",
    noGroupsYet: "Hakuna vikundi kwa shughuli hii bado",
    confirmDeleteGroup: "Futa kikundi hiki?",
    selectActivityFirst: "Chagua shughuli kwanza",
    selectActivityToManageGroups: "Chagua shughuli ili kusimamia vikundi vyake",
    filterByGroup: "Chuja kwa kikundi",
    groupCreated: "Kikundi kimeundwa kwa mafanikio",
    groupRenamed: "Jina la kikundi limebadilishwa kwa mafanikio",
    groupDeleted: "Kikundi kimefutwa kwa mafanikio",
    groupAssigned: "Mwanafunzi amepewa kikundi kwa mafanikio",
    groupUnassigned: "Mwanafunzi ameondolewa kwenye kikundi kwa mafanikio",
    multipleRegistration: "Usajili wa aina nyingi",
    multipleRegistrationTitle: "Usajili kwa shughuli nyingi",
    multipleRegistrationStep1Title: "1. Shughuli na wanafunzi",
    multipleRegistrationStep1Subtitle:
      "Chagua shughuli kadhaa za aina moja (zote Za kila siku au zote Kila mwezi/Kipindi) kisha wanafunzi wa kusajili",
    multipleRegistrationStep2Title: "2. Usanidi kwa kila shughuli",
    multipleRegistrationStep2Subtitle:
      "Sanidi tarehe na hali ya malipo ya kila shughuli kando",
    multipleRegistrationNoActivitiesSelected: "Hakuna shughuli iliyochaguliwa",
  },
  emploiActivites: {
    title: "Ratiba ya shughuli",
    addSession: "Ongeza kikao",
    editSession: "Hariri kikao",
    selectActivityHint: "Chagua shughuli ili kusimamia ratiba yake",
    selectActivityEmpty: "Chagua shughuli ili kuona vikao",
    filterByGroup: "Chuja kwa kikundi",
    wholeActivity: "Shughuli nzima",
    day: "Siku",
    time: "Saa",
    duration: "Muda (dak)",
    selectTeacher: "Chagua mwalimu",
    selectRoom: "Chagua chumba",
    dayRequired: "Siku inahitajika",
    timeRequired: "Saa inahitajika",
    durationRequired: "Muda unahitajika",
    cancelSession: "Ghairi kikao",
    confirmCancelSession: "Ghairi kikao hiki?",
    restoreSession: "Rejesha kikao",
    confirmRestoreSession: "Rejesha kikao hiki kilichoghairiwa?",
    confirmDeleteSession: "Futa kikao hiki?",
    canceled: "Imeghairiwa",
    active: "Hai",
    sessionCreated: "Kikao kimeundwa",
    sessionUpdated: "Kikao kimesasishwa",
    sessionCanceled: "Kikao kimeghairiwa",
    sessionRestored: "Kikao kimerejeshwa",
    sessionDeleted: "Kikao kimefutwa",
    repeat: "Rudia kikao",
    repeatHint: "Unda vikao vingi kati ya tarehe mbili",
    repeatFrequency: "Marudio",
    repeatDaily: "Kila siku",
    repeatWeekly: "Kila wiki",
    repeatMonthly: "Kila mwezi",
    startDate: "Tarehe ya kuanza",
    endDate: "Tarehe ya kumaliza",
    dateRangeRequired: "Tarehe za kuanza na kumaliza zinahitajika",
    endBeforeStart: "Tarehe ya kumaliza lazima iwe baada ya kuanza",
    frequencyRequired: "Chagua marudio",
    noOccurrences: "Hakuna vikao vya kuunda kwa kipindi hiki",
    sessionsWillBeCreated: "Vikao {count} vitaundwa",
    sessionsCreated: "Vikao {count} vimeundwa",
  },
  activityAttendance: {
    title: "Mahudhurio ya shughuli",
    sessionsTab: "Vipindi",
    summaryTab: "Muhtasari",
    period: "Kipindi",
    quickPeriod: "Kipindi cha haraka",
    weekly: "Wiki hii",
    monthly: "Mwezi huu",
    student: "Mwanafunzi",
    studentCount: "Wanafunzi {nb}",
    expected: "Zilizotarajiwa",
    attended: "Alihudhuria",
    needDates: "Chagua kipindi cha tarehe",
    pickActivity: "Chagua shughuli kuona vipindi",
    sessionsHint:
      "Fungua kikao kuweka mahudhurio. Hakuna kinachohifadhiwa hadi ubonyeze Thibitisha. Usithibitishe kwa sikukuu.",
    noSessions: "Hakuna vipindi kwa vichujio hivi",
    group: "Kikundi",
    teacher: "Mwalimu",
    room: "Chumba",
    day: "Siku",
    time: "Saa",
    status: "Hali",
    canceled: "Imefutwa",
    canceledHint: "Kipindi hiki kimefutwa",
    future: "Ijayo",
    futureHint:
      "Unaweza kuweka mahudhurio kwa vipindi vya leo au vilivyopita tu",
    adminValidated: "Imethibitishwa na utawala",
    pendingAdmin: "Imethibitishwa na mwalimu",
    pendingAdminHint:
      "Mwalimu amethibitisha mahudhurio haya na bado anaweza kuyabadilisha. Yakague, kisha bofya Thibitisha ili kuyafunga kwa mwalimu.",
    teacherValidatedAt: "Uthibitisho wa mwalimu",
    teacherNotValidated: "Bado haijathibitishwa na mwalimu",
    notRecorded: "Haijarekodiwa",
    nothingRecordedYet:
      "Hakuna mahudhurio yaliyorekodiwa kwa kikao hiki bado. Weka hali (Aliyepo kwa chaguo-msingi) kisha bonyeza Thibitisha.",
    validatedHint:
      "Yamethibitishwa na utawala: yamefungwa kwa mwalimu. Bado unaweza kubadilisha kisha Thibitisha tena, au kuyafungua tena kwa mwalimu.",
    reopen: "Fungua tena kwa mwalimu",
    reopenConfirm:
      "Ruhusu mwalimu kubadilisha mahudhurio ya kikao hiki tena? Yatafungwa tena utawala utakapoyathibitisha.",
    reopenSuccess: "Kikao kimefunguliwa tena kwa mwalimu",
    reopened: "Imefunguliwa tena",
    reopenedHint:
      "Imefunguliwa tena: mwalimu anaweza kubadilisha kikao hiki hadi utawala utakapokithibitisha tena.",
    yearLockedForTeachers:
      "Huu si mwaka wa shule wa sasa. Walimu hawawezi kubadilisha mahudhurio ya shughuli zake.",
    yearUnlockedForTeachers:
      "Huu si mwaka wa shule wa sasa, lakini walimu wameruhusiwa kwa sasa kubadilisha mahudhurio ya shughuli zake.",
    allowTeacherEdit: "Ruhusu walimu kubadilisha",
    yearLockUpdated: "Ruhusa ya walimu imesasishwa",
    validate: "Thibitisha mahudhurio",
    validateConfirm:
      "Hifadhi mahudhurio ya wanafunzi wote kwa kikao hiki?",
    validateSuccess: "Mahudhurio yamethibitishwa",
    openSheet: "Karatasi ya mahudhurio",
    markTitle: "Weka mahudhurio",
    emptyRoster: "Hakuna wanafunzi walioandikishwa kwa kipindi hiki",
    groupRosterHint:
      "Wanafunzi waliopangiwa kikundi “{group}” tu wanaonyeshwa.",
    hint:
      "Vipindi vilivyothibitishwa tu vinahesabiwa. Chagua shughuli kuona wanafunzi wote. Futa kichujio cha darasa ikiwa kimewekwa.",
    empty:
      "Hakuna wanafunzi kwa vichujio hivi. Chagua shughuli, panua tarehe, au futa kichujio cha darasa.",
  },
  activityPaymentAttendance: {
    title: "Mahudhurio kwa kipindi hiki",
    subtitle:
      "Dalili tu — chagua siku za malipo kwa mkono hapa chini. Huhesabu vipindi vilivyothibitishwa tu (Aliyepo na Ucheleweshaji = alihudhuria).",
    refresh: "Onyesha upya",
    needDates: "Chagua kipindi cha tarehe",
    missingIds: "Mwanafunzi au shughuli haipo",
    noSessions: "Hakuna vipindi vilivyopangwa katika kipindi hiki",
    noSessionsHint:
      "Ratiba ya shughuli haina vipindi kwa mwanafunzi huyu katika tarehe zilizochaguliwa.",
    present: "Aliyepo",
    retard: "Ucheleweshaji",
    absence: "Ameyokosekana",
    exclus: "Kutengwa",
    none: "Hakuna",
    totals:
      "Vipindi {sessions} · Aliyepo {present} · Ucheleweshaji {retard} · Ameyokosekana {absence} · Kutengwa {exclus}",
  },
  emploiActivites: {
    title: "Ratiba ya shughuli",
    addSession: "Ongeza kikao",
    editSession: "Hariri kikao",
    selectActivityHint: "Chagua shughuli ili kusimamia ratiba yake",
    selectActivityEmpty: "Chagua shughuli ili kuona vikao",
    filterByGroup: "Chuja kwa kikundi",
    wholeActivity: "Shughuli nzima",
    day: "Siku",
    time: "Saa",
    duration: "Muda (dak)",
    selectTeacher: "Chagua mwalimu",
    selectRoom: "Chagua chumba",
    dayRequired: "Siku inahitajika",
    timeRequired: "Saa inahitajika",
    durationRequired: "Muda unahitajika",
    cancelSession: "Ghairi kikao",
    confirmCancelSession: "Ghairi kikao hiki?",
    restoreSession: "Rejesha kikao",
    confirmRestoreSession: "Rejesha kikao hiki kilichoghairiwa?",
    confirmDeleteSession: "Futa kikao hiki?",
    canceled: "Imeghairiwa",
    active: "Hai",
    sessionCreated: "Kikao kimeundwa",
    sessionUpdated: "Kikao kimesasishwa",
    sessionCanceled: "Kikao kimeghairiwa",
    sessionRestored: "Kikao kimerejeshwa",
    sessionDeleted: "Kikao kimefutwa",
    repeat: "Rudia kikao",
    repeatHint: "Unda vikao vingi kati ya tarehe mbili",
    repeatFrequency: "Marudio",
    repeatDaily: "Kila siku",
    repeatWeekly: "Kila wiki",
    repeatMonthly: "Kila mwezi",
    startDate: "Tarehe ya kuanza",
    endDate: "Tarehe ya kumaliza",
    dateRangeRequired: "Tarehe za kuanza na kumaliza zinahitajika",
    endBeforeStart: "Tarehe ya kumaliza lazima iwe baada ya kuanza",
    frequencyRequired: "Chagua marudio",
    noOccurrences: "Hakuna vikao vya kuunda kwa kipindi hiki",
    sessionsWillBeCreated: "Vikao {count} vitaundwa",
    sessionsCreated: "Vikao {count} vimeundwa",
  },
  activityMultiForm: {
    installmentFees: "Ada za vipande",
    installment: "Kipande",
    selectedPaymentMode: "Njia ya malipo iliyochaguliwa ni ",
    byInstallments: "kwa vipande",
    monthly: "kila mwezi",
    feesToPay: "Ada za kulipa",
    fees: "Ada",
    included: "Imejumuishwa",
  },
  studentCredentials: {
    deactivateOrActivateAccount: "Kuzima au kuamsha akaunti ya mwanafunzi",
    accountActivated: "Akaunti imeamshwa, mtumiaji anaweza kufikia programu.",
    accountDeactivated: "Akaunti imezimwa, mtumiaji hawezi kufikia programu.",
    deactivate: "Zima",
    activate: "Amsha",
    studentQrCode: "Msimbo wa QR wa mwanafunzi",
    usernameNoWhitespace: "Jina la mtumiaji haliwezi kuwa na nafasi",
    passwordConfirmationRequired: "Tafadhali ingiza nenosiri tena",
    passwordMismatch: "Maelezo mawili hayafanani!",
    statusChangeSuccess: "Mabadiliko yamekamilika kwa mafanikio",
  },
  college: {
    bulletin: {
      config: {
        title: "Usanidi wa ripoti ya chuo cha sekondari",
        description:
          "Sanidi masomo na aina za alama kwa ripoti za chuo cha sekondari!",
        subjectOrderUpdated: "Mpangilio wa masomo umesasishwa kwa mafanikio",
        subjectAlreadyExists: "Somo hili tayari lipo katika usanidi",
        failedToUpdateSubjectOrder:
          "Kushindwa kusasisha mpangilio wa somo. Tafadhali jaribu tena",
        configClone: "Usanidi umenakiliwa kwa mafanikio",
        ajouterConfigCollege: "Ongeza usanidi wa chuo cha sekondari",
        modifierConfigCollege: "Hariri usanidi wa chuo cha sekondari",
        modifierConfigSubject: "Hariri usanidi wa somo",
        niveau: "Kiwango",
        order: "Mpangilio",
        markTypes: "Aina za alama",
        configurerMarkType: "Sanidi alama",
        aucuneMatiere: "Hakuna masomo",
        confirmDeleteWithMarks:
          "Somo hili lina rekodi za alama za {count} mwanafunzi/mwanafunzi. Una uhakika unataka kulifuta?",
        from: "Kutoka",
        to: "Hadi",
        niveaux: "Viwango",
        trimestres: "Mihula",
        anneeScolaire: "Mwaka wa shule",
        count: "Idadi",
        markType: {
          oral: "Kinywani",
          cont1: "Udhibiti 1",
          cont2: "Udhibiti 2",
          synth: "Muhtasari",
          written: "Maandishi",
          tp: "Kazi za vitendo",
        },
      },
    },
  },
  footer: {
    copyright: "Hakimiliki ©",
    allRightsReserved: "Haki Zote Zimehifadhiwa.",
    version: "Toleo:",
  },
  attestationInscription: {
    title: "Cheti cha Usajili",
    iUndersigned: "Mimi, mwenye kusaini hapa chini",
    directorMale: "mkuu",
    directorFemale: "mkuu",
    ofThe: "wa",
    certifiesThatStudent: "anathibitisha kuwa mwanafunzi",
    bornOn: "aliyezaliwa tarehe",
    isEnrolledIn: "ameandikishwa katika taasisi yetu kwa mwaka wa masomo",
    inClass: "katika darasa",
    doneAt: "Imetengenezwa",
    on: "tarehe",
    signatureAndStamp: "Saini na Mhuri",
  },
  ficheClasse: {
    nonDisponible: "Haipatikani",
    anneeScolaireLabel: "Mwaka wa masomo",
    delegeRegionalEducation: "Mamlaka ya Elimu ya Kikanda",
    date: "Tarehe",
    listeEleves: "Orodha ya wanafunzi",
    classe: "Darasa",
    garcon: "Mvulana",
    fille: "Msichana",
    total: "Jumla",
    garcons: "Wavulana",
    filles: "Wasichana",
    numero: "Nambari",
    identifiantUnique: "Kitambulisho cha kipekee",
    nomComplet: "Jina kamili",
    dateNaissance: "Tarehe ya kuzaliwa",
    group: "Kikundi",
    sexe: "Jinsia",
    listeElevesPDF: "Orodha_ya_Wanafunzi",
    formulaireParent: "Fomu ya mzazi",
    nomPrenom: "Jina kamili",
    nomPrenomFr: "Jina kamili kwa Kifaransa",
    nomParent: "Jina la mzazi",
    telephone: "Simu",
    pere: "Baba",
    mere: "Mama",
    ficheParentPDF: "Fomu_ya_Mzazi",
    parentSheetSelectAtLeastOneColumn:
      "Tafadhali chagua angalau safu wima moja ya kuchapisha.",
    parentSheetSelectColumnsHint:
      "Chagua safu wima za kujumuisha kwenye karatasi ya mzazi. Unaweza kutengeneza orodha kamili au sehemu unazohitaji tu (mf. orodha ya barua pepe, orodha ya anwani).",
    parentSheetSelectColumnsTitle: "Chagua safu wima za kuchapisha",
  },
  attendanceHistoryPdf: {
    classe: "Darasa",
    period: "Kipindi",
    num: "Nambari",
    studentName: "Jina la mwanafunzi",
    page: "Ukurasa",
    legend: "Ufafanuzi",
    present: "Yupo",
    absence: "Kutokuwepo",
    retard: "Kuchelewa",
    exclus: "Kutengwa",
    history: "Historia",
  },
  conseilClass: {
    managerAndTeacher: "Mkurugenzi na walimu",
    options: "Chaguo",
    allow: "Onyesha",
    auto: "Otomatiki",
    useSchoolCode: "Tumia msimbo wa shule",
    repeatEachPage: "Rudia kila ukurasa",
    rect: "Mpaka",
    orientation: "Mwelekeo",
    landscape: "Mlalo",
    portrait: "Wima",
    govText: "Maandishi ya serikali",
    schoolLogo: "Nembo ya shule",
    schoolYear: "Mwaka wa shule",
    govLog: "Nembo ya serikali",
    stats: "Takwimu",
    mainTitle: "Kichwa kikuu",
    secondaryText: "Maandishi ya pili",
    preParagraph: "Aya ya utangulizi",
    table: "Jedwali la waliofaulu",
    tablePostParagraph: "Aya baada ya jedwali la waliofaulu",
    postParagraph: "Aya baada ya jedwali",
    number: "Nambari",
    fullName: "Jina kamili",
    firstName: "Jina la kwanza",
    lastName: "Jina la ukoo",
    birthDate: "Tarehe ya kuzaliwa",
    birthPlace: "Mahali pa kuzaliwa",
    uniqueIden: "Kitambulisho cha kipekee",
    prevYears: "Miaka iliyopita",
    trim1: "Muhula 1",
    trim2: "Muhula 2",
    trim3: "Muhula 3",
    moy: "Wastani",
    decision: "Uamuzi",
    handicape: "Ulemavu",
    exceptionalStats: "Jedwali la kupita kwa msada",
    filled: "Jaza kwa wanafunzi",
    specCount: "Idadi ya mistari tupu",
    agePass: "Jedwali la kupita kwa umri",
    fail: "Jedwali la walioshindwa",
    govSpecific: "Kizuizi cha mkoa (ukurasa wa mwisho)",
    manager: "Mkuu wa shule",
    teacher: "Walimu",
    templateName: "Jina la kiole",
    templateNamePlaceholder: "Mf. PV ya baraza la darasa",
    selectTemplate: "Kiole kilichohifadhiwa",
    builtinDefault: "chaguo-msingi",
    pvMissingKeyBanner: "Wanafunzi {count} bila uamuzi unaolingana (A/C/R)",
    pvMissingKeyHint:
      "Wanafunzi hawa hawaonekani kwenye jedwali la PV. Rekebisha mipangilio ya maamuzi ya baraza au weka uamuzi kwa kila mwanafunzi.",
    pvMissingKeyMore: "... na {count} zaidi",
    settingsSaved: "Mipangilio imehifadhiwa kwa mafanikio",
    templateAssigned: "Kiole kimetengwa kwa kiwango hiki",
    checkInputs: "Tafadhali angalia maingizo yako",
    selectClassFirst: "Chagua darasa kwanza",
    couldNotGetClassPv: "Imeshindwa kupakia data ya PV ya darasa",
    cloneAlert:
      "Mipangilio imenakiliwa. Onyesha upya ukurasa kuona athari kamili.",
    templateNameRequired: "Tafadhali weka jina la kiole",
    templateNameAlreadyExists:
      "Jina la kiole tayari lipo. Chagua jina lingine.",
    nameTemplateTitle: "Taja kiole",
    nameTemplatePrompt:
      "Unahifadhi kutoka kiole cha chaguo-msingi. Toa jina la kipekee kabla ya kuhifadhi kwa kiwango hiki.",
    selectSourceTemplate: "Kiole cha chanzo cha kunakili",
    cloneSourceHint:
      "Ili kunakili kiole kingine, chagua kwenye mipangilio, hifadhi, kisha fungua kunakili.",
    cloneSaveTemplateFirst:
      "Hifadhi kiole kilichochaguliwa kwenye mipangilio kabla ya kunakili.",
    unnamedTemplate: "Bila jina",
    selectCloneTargets: "Chagua angalau lengo moja",
  },
  pickup: {
    title: "Uchukuaji",
    enabled: "Washa uchukuaji wa mzazi",
    radius: "Umbali unaoruhusiwa (mita)",
    location: "Mahali pa uchukuaji",
    locationHint:
      "Acha wazi ili kutumia mahali pa shule palipowekwa kwenye mipangilio ya shule.",
    noBuildingLocation:
      "Mahali pa shule hapajawekwa kwenye mipangilio ya shule. Weka mahali pa uchukuaji.",
    noLocation:
      "Mahali panahitajika ili kuwasha uchukuaji. Weka mahali pa uchukuaji au mahali pa shule.",
    latLngTogether: "Latitudo na longitudo lazima zijazwe pamoja.",
    saved: "Mipangilio ya uchukuaji imehifadhiwa",
    waiting: "Wanasubiri",
    history: "Historia",
    noWaiting: "Hakuna mwanafunzi anayesubiri",
    student: "Mwanafunzi",
    classe: "Darasa",
    parent: "Mzazi",
    requestedAt: "Muda wa ombi",
    expiresIn: "Inaisha baada ya",
    status: "Hali",
    statusPickedUp: "Amechukuliwa",
    statusExpired: "Imeisha (haijathibitishwa)",
    validatedBy: "Imethibitishwa na",
    validate: "Thibitisha kuondoka",
    confirmValidate: "Thibitisha kwamba mwanafunzi ameondoka na mzazi?",
    validated: "Kuondoka kwa mwanafunzi kumethibitishwa",
    level: "Kiwango",
    sortOldest: "Kufika: wa zamani kwanza",
    sortNewest: "Kufika: wa karibuni kwanza",
    distance: "Umbali kutoka shule",
    relation: {
      father: "Baba",
      mother: "Mama",
      guardian: "Mlezi",
    },
  },
};

export default {
  locale: "sw-KE",
  localeAntd,
  messages,
};
